// en, es, pt
export default {
  EnEu: {
    BOOLEAN: {
      Yes: 'Yes',
      No: 'No'
    },
    USER: {
      Details: 'Details',
      Email: 'E-mail:',
      Name: 'Name:',
      Profile: 'Plans:',
      Document: 'Document:',
      Phone: 'Phone:',
      Country: 'Country:',
    },
    BUTTONS: {
      Save: 'Save',
      Cancel: 'Cancel',
      Back: 'Back',
      Send: 'Send',
      Enter: 'Login',
      AccessAccount: 'Access your account',
      Register: 'Register',
      BackLogin: 'Back to Login',
      RecoverButton: 'Recovery Password',
      DownloadFile: 'Download File',
      BackHomePage: 'Back to Home Page',
      MoreQuestion: 'More Questions',
      RecoveryPassword: 'Recovery Access',
      TestTrial: 'Free 7-day trial',
      Save_Announcement: 'Save Announcement',
      Edit_Data: 'Edit Data',
      Remove: 'Remove'
    },
    GENERAL: {
      Home: 'Home',
      Edit: 'Edit',
      Delete: 'Delete',
      Update: 'Update',
      Create: 'Create',
      Error: 'Error',
      Atention: 'Atention',
      Send: 'Enviar',
      Cma_Url: 'https://www.cma.com.br/eng/home-eng/',
      Safras_Url: 'https://safras.com.br/eng/home-ingles/',
      Safras_Url_Request: 'https://pagina.safras.com.br/ing-mercado-agropecuario',
      Error_Download_File: 'Failed to download file',
      Copy_Data: 'Copy data'
    },
    LOGIN: {
      Title: 'Login',
      User: 'E-mail',
      Password: 'Password',
      Remember: 'Remember',
      ForgotPass: 'Forgotten password?',
      Enter: 'Login',
      Code: 'code',
      Register: 'Register',
      New_Here: 'New here?',
      Lost_Acess: 'Difficulty with access?',
      Know_More: 'Know More',
      Click_Here: 'Click here',
      Resend_Token: 'to resend the code',
      Notify_Error_Title: 'Warning',
      Notify_Error_Message: 'Invalid username or password',
      New_Here_Link: 'https://www2.safras.com.br/plataforma/',
      Two_Factor_Auth_Title: "Double authentication",
      Two_Factor_Auth_Desc: "We have sent an authentication code to your e-mail.",
      Two_Factor_Auth_Code: "Code",
      Two_Factor_Auth_Code_Placeholder: "Type the code",
      Confirm_Email_Title: "E-mail confirmation",
      Confirm_Email_Desc: "Your registration to access the Safras Platform demo has not yet been completed. You need to register the token sent by Safras & Mercado to your email address on the registration screen.",
      Confirm_Email_Desc_Token_Val: "Token expiry time: up to 2 hours.",
      Confirm_Email_Desc_Sec: "Did not get the e-mail?",
      Confirm_Email_Field_Code: 'Code',
      Confirm_Email_Placeholder_Code: 'Type the code',
      Confirm_Email_Send_Token: 'Code successfully sent',
      Notify_Accept_Terms: 'You must agree to the Terms of Use to complete registration.',
      Footer_CMA: 'is protected by reCaptcha and is subject to your',
      Click_Back: 'Click to back',
      Text_Market: 'Safras & Mercado: everything about agribusiness in one place'
    },
    LOGINS4: {
      Error_Message_Title: 'There was a problem.',
      Error_Message_Content: 'Try again in a moment and, if the problem persists, contact our customer service center.',
      Error_Message_Content_Other_Login: 'Dear user, your session has expired. Please close this module and reopen it.',
    },
    MENU: {
      Home: 'Home',
      AllSubjects: 'All Subjects',
      Subjects: 'Subjects',
      AllCommodities: 'All Commodities',
      Commodities: 'Commodities',
      DisabledItems: 'Subscribe now',
      MoreCommodities: 'More Commodities',
      NoRights: 'No rights'
    },
    TABLE: {
      Column_ID: 'ID',
      Column_DT_Insert: 'Insert Date',
      Column_DT_Change: 'Change Date',
    },
    MESSAGES: {
      Messages_Created: 'Created Record',
      Messages_Updated: 'Updated Record',
      Messages_Deleted: 'Deleted Record',
      Messages_Generic_Error: 'Error executing operation',
    },
    NAVBAR_DROPDOWN_MENU: {
      Profile: 'Profile',
      Change_Password: 'Change Password',
      Ask_To_Analyst: 'Ask to Analyst',
      Dark_Theme: 'Dark Theme',
      Light_Theme: 'Light Theme',
      Biometry: 'Biometry',
      Language: 'Language',
      Logout: 'Logout',
      Privacy_Policy: 'Privacy Policy',
      Notification: 'Notification',
      Signatures: 'Signature',
      Packages: 'Plans',
      My_Account: 'My Account',
      Info_Account: 'Account Detail',
      Platform_Config: 'Platform Configuration',
      Font_Size: 'Text Size',
      Font_Align: 'Image alignment',
      Font_Compact: 'Compact',
      Font_Default: 'Default',
      Font_Big: 'Big',
      Appearance: 'Appearance',
      View_Type_List: 'List',
      View_Type_Card: 'Card',
      About: 'About',
      Help: 'Help',
      Show_Ticker: 'Show ticker',
      Hide_Ticker: 'Hide ticker',
      Quotes_Config: 'Support'
    },
    CHANGE_PASSWORD: {
      Title: 'Password',
      Field_Email: 'E-mail',
      Field_Current_Password: 'Current Password',
      Field_New_Password: 'New Password',
      Field_New_Password_Repeat: 'Repeat Password',
      Notify_Success_Title: 'Change Password',
      Notify_Success_Message: 'Password Updated Successfully',
      Quit_all_apps: 'Sign out of all devices',
      Remember_Password: "Don't remember your current password?",
      Click_Retrieve: 'Click here to retrieve',
      Update_Password: 'Update your password',
      Enter_Current_Password: 'To update your password, you must enter your current one.'
    },
    RESET_PASSWORD: {
      ResetTitle: 'Change Password',
      ResetDesc: 'Please enter your new password',
      ResetPass: 'New Password',
      ResetConfirm: 'Repeat new password',
      Reset_Confirm: 'repeat',
      InvalidToken: 'Invalid Code',
      Notify_Title: 'Change Password',
      Notify_Error_Message: 'Please check the password fields.',
      PasswordChanged: 'Change Password',
      PasswordChangedDesc: 'Your password has been updated successfully',
    },
    FORGOT_PASSWORD: {
      RecoverTitle: 'Recovery your password',
      RecoverDesc: 'Please enter your e-mail address and we will send you instructions to recover your password',
      Field_Email: 'E-mail',
      EmailSent: 'E-mail Sent',
      CheckEmail: 'An e-mail has been sent to you. Please check your inbox',
      Notify_Success_Title: 'Password',
      Notify_Success_Message: 'Please check your e-mail',
      Notify_Error_Title: 'Recovery yot password',
      Notify_Error_Message: 'Invalid e-mail address'
    },
    ASK_THE_ANALYST: {
      Title: 'Ask the Analyst',
      TitleHedge: 'Request For Quotes',
      Field_Email: 'E-mail',
      Field_Name: 'Name',
      Field_Question: 'Question',
      Field_Commodity: 'Commodity',
      Remaining_Questions: 'Remaining questions available: '
    },
    MY_ACCOUNT: {
      Title: 'My Account',
      Field_Email: 'E-mail',
      Field_Name: 'Name',
      Field_CnpjCpf: 'Document',
      Field_Phone: 'Phone',
      Field_Groups: 'Groups',
      Field_Language: 'Platform Language',
      Text_Language: 'This parameter only changes the platform language. To change the content, please contact the customer service center.',
      Field_Country: 'Country',
      Title_Receive_Email: 'Receive By E-mail',
      Title_Notification: 'Notifications',
      Field_Option_All: 'All',
      Notify_Success_Title: 'My Account',
      Notify_Success_Message: 'Data Updated Successfully',
      Help_Language: 'Required to receive e-mail in the chosen language'
    },
    ERROR_404: {
      Title: 'Ops, page not found',
      Message: 'Sorry, this page was not found'
    },
    FOOTER: {
      Help: 'Help'
    },
    HELP: {
      Tab_About: 'About',
      Tab_Attendance: 'Attendance',
      Tab_Version: 'Version',
      Tab_LGPD: 'LGPD',
      Tab_PrivacyPolicy: 'Privacy Policy',
      Tab_Tour: 'Tour',
      Tab_Terms: 'Terms of use',
      Tab_Quotes_Config: 'Support'
    },
    HELP_ABOUT: {
      Cma_Title: 'About CMA',
      Cma_Text: 'CMA Consultoria, Métodos, Assessoria e Mercantil S/A is a Brazilian multinational company that since 1973 has been engaged in the development of high technology solutions applied to the financial and commodities, education, telecommunications and data center markets. The company has its headquarters and 9 branches in Brazil, in addition to branches in the United States, Latin America and Europe, with customers in 35 countries.',
      Safras_Title: 'About SAFRAS & Mercados',
      Safras_Text: 'SAFRAS & Mercado is the leading Brazilian agribusiness consultancy. It monitors the soy, corn, cotton, coffee, sugar & alcohol, beef, chicken, pork, rice, beans and bioenergy markets on a daily basis, offering different levels of services that help the decision-making of participants from different agricultural sectors. SAFRAS has the most complete historical database of Brazilian agribusiness, is an international reference in agricultural projections and scenarios.',
      Know_More: 'Learn more at',
      Visit_Website: 'Visit the website at:'
    },
    HELP_ATTENDANCE: {
      Title: 'Attendance',
      Contact_Text: 'Contact us and we will contact you soon!',
      Phone: 'Phone:',
      Email: 'E-mail:',
      Whatsapp: 'WhatsApp:',
      Form_Text: 'Send a message using the form below.',
      Form_Field_Message: 'Message',
      Notify_Success_Title: 'Attendance',
      Notify_Success_Message: 'Message sent successfully',
      Phone_href: '',
      Phone_Text: '',
      Whatsapp_href: 'href="https://wa.me/551130532600" target="_blank"',
      Whatsapp_Text: '(11) 3053-2600',
      Mail_href: 'mailto:international.support@cma.com.br',
      Mail_Text: 'international.support@cma.com.br',
      NoRights_Text_Commodity: 'I would like to enable access to commodity content %.',
      NoRights_Text_Content: 'I would like to enable access to % commodity content #.',
      NoRights_Text_GetMoreQuestions: 'I would like to enable more questions for analysts.',
      Edit_Account_Data: 'I would like to edit my data',
    },
    HELP_VERSION: {
      Title: 'Version',
      Item_Version: 'Version',
      Item_Browser: 'Browser',
      Item_System: 'System',
      Item_Resolution: 'Resolution',
      Item_Status: 'Status',
    },
    HELP_LGPD: {
      Accept_Cookies: 'Accept',
      Reject_Cookies: 'Reject',
      Privacy_Policy: 'Read Privacy Policy',
      Cookies_Notice: 'Our website uses cookies to provide you with personalized content and for site analysis. We recommend that you accept, for better navigation on the page!',
      LGPD_Title: 'Lei Geral de Proteção de Dados Pessoais (LGPD)',
      LGPD_Text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged."
    },
    HELP_PRIVACY_POLICY: {
      Privacy_Policy: 'Privacy and Confidentiality Policy',
      Title: 'Information Privacy and Confidentiality Policy'
    },
    HELP_SUPPORT: {
      Follow_Market: 'Follow the Market',
      Restore_Layout: "Restore default layout",
      Clear_Local_Data: "Clear local data",
      Detailed_Info: "Detailed information",
      Layout_History: "Layout history",
      Created: 'Created',
      Updated: "Updated",
      Copy_Info_Success: "Data has been copied to the clipboard.",
      Clear_Local_Data_Dialog_Title: "Clear data",
      Clear_Local_Data_Dialog_Message: "Do you want to clear the 'accompany the market' data?",
      Restore_Layout_Dialog_Title: "Restore layout",
      Restore_Layout_Dialog_Message: "Do you want to restore your 'accompany the market' layout to the default? The page will be refreshed, and you will need to log in again.",
      Update_Layout_History_Dialog_Title: "Restore layout history",
      Update_Layout_History_Dialog_Message: "Do you want to restore your layout from the day",
      Detailed_Info_No_Data: 'No data at the moment'
    },
    TERMS_USE: {
      Title: 'Terms of use',
      Text: '<p class="mt-3 mb-3">All content made available on the Safras Platform is protected by the Copyright Law and for exclusive use by its subscribers. For this reason, the reproduction or distribution of the content, in whole or in part, without prior and express authorization from CMA is prohibited. Failure to comply with this prohibition will result in civil and criminal sanctions.</p><p class="mt-3 mb-3">The information provided on the Safras Platform exclusively reflects investigations and research carried out by professionals from Safras & Mercado. Consists of information available to the public and believed to be reliable at the time of publication.</p><p class="mt-3 mb-3">This content is subject to change and is based on freedom of expression. Therefore, it has a purely informative nature, not representing any offers or recommendations for trading securities, whether securities, commodities and/or other financial or economic instruments.</p><p class="mt-3 mb-3"> The information contained in the Safras Platform aims to encourage debate and education on economics and agribusiness for its subscribers. In this way, subscribers must develop their own market assessments for making decisions about the management of their businesses and/or investments, exempting, safeguarding and fully protecting CMA from the consequences of these decisions and, even, from any financial losses, losses and damages, during and after the end of the subscription plan period.</p>',
      Text_Mobile: '<p class="mt-3 mb-3">All content made available on the Safras Platform is protected by the Copyright Law and for exclusive use by its subscribers. For this reason, the reproduction or distribution of the content, in whole or in part, without prior and express authorization from CMA is prohibited. Failure to comply with this prohibition will result in civil and criminal sanctions.</p><p class="mt-3 mb-3">The information provided on the Safras Platform exclusively reflects investigations and research carried out by professionals from Safras & Mercado. Consists of information available to the public and believed to be reliable at the time of publication.</p><p class="mt-3 mb-3">This content is subject to change and is based on freedom of expression. Therefore, it has a purely informative nature, not representing any offers or recommendations for trading securities, whether securities, commodities and/or other financial or economic instruments.</p><p class="mt-3 mb-3"> The information contained in the Safras Platform aims to encourage debate and education on economics and agribusiness for its subscribers. In this way, users must develop their own market assessments for making decisions about the management of their businesses and/or investments, exempting, safeguarding and fully protecting CMA from the consequences of these decisions and, even, from any financial losses, losses and damages, during and after the period of use of the system.</p>',
      Read_Accepted: 'I have read and accepted',
      Cancel: 'Cancel'
    },
    REPORT: {
      No_Report_Found: 'No Results Found',
      No_Report_Found_Text: "You can redo the search to find what you're looking for",
      No_Report_Found_Text_Demo: "For more results and exclusive content, sign up or access our platform.",
      Load_More: 'Load More...',
      Download_Spreadsheet: 'Download Spreadsheet',
      Download_Spreadsheet_Text: 'Click to download the spreadsheet',
      Hear_Text: 'Hear the Text',
      All_Commodities: 'All Commodities',
      View_More: 'View More'
    },
    REPORT_FILTER: {
      Informative_Title: 'Informative',
      Informative: 'Analysis and Newsletters',
      Search: 'Search',
      Filters: 'Filters',
      Filter_Periodicity: 'Frequency',
      Filter_Publication_Type: 'Content Type',
      Filter_Subject: 'Commodities',
      Filter_Order_By: 'Order by',
      Filter_Content: 'Contents',
      Filter_Country: 'Report Origin',
      Filter_Highlights: 'Highlights',
      Filter_InLive: 'Live',
      Filter_Important: 'Important',
      Filter_Exclusive: 'Exclusive',
      Filter_Date: 'Date',
      Filter_Date_From: 'FROM',
      Filter_Date_To: 'TO',
      Filter_Media_type: 'Media type',
      Filter_Priority: 'Priority',
      Filter_Attachment: 'Attachment',
      Filter_Video: 'Video',
      Filter_Audio: 'Audio',
      Filter_Podcast: 'Podcast',
      Filter_Relevant: 'Relevant',
      Clear_Filter: 'Clear Filter',
      To_View: 'To view',
      Results: 'results',
      Follow_Market: 'Follow the Market',
      Favorite_Content: 'Edit Favorites',
      Filter_Report_Type: 'Report Type',
      Information_label: 'Informative',
      Advanced_Filters: 'Advanced Filters',
      Filter_Author: 'Filter by author',
      One_Day: '1 DAY',
      One_Week: '1 WEEK',
      One_Month: '1 MONTH',
      Three_Months: '3 MONTHS',
      Select_Date: 'SELECT A DATE',
    },
    REPORT_ITEM: {
      Updated: 'Updated',
      Today: 'Today'
    },
    BROWSER_NOT_SUPPORTED: {
      Title: 'WARNING',
      Text: 'For a unique experience with more performance and security try our app on other browsers. It is also possible to install our App for Windows.',
      Other_Browsers: 'Other Browsers',
      Windows_Store: 'Windows Store'
    },
    DOWNLOAD_PUBLIC_FILE_EMAIL: {
      Title: 'Download File',
      Notify_Error_Title: 'Token',
      Notify_Error_Message_Token_Not_Found: 'Token not found',
      Notify_Error_Message_Invalid_Token: 'Invalid Token'
    },
    PLAYLIST: {
      Empty_Playlist: 'Your playlist is empty',
      Empty_Playlist_Text: 'Add a video to your playlist',
      Youtube_Add_Playlist_Text: 'Video added to playlist',
      Audio_Add_Playlist_Text: 'Audio added to playlist',
      Item_Add_Playlist_Text: 'Item added to playlist',
      Upcoming_Videos: 'Upcoming videos',
      Clean: 'CLEAN',
      Running: 'Running'
    },
    LOST_ACCESS: {
      Title: 'Lost Access',
      ResetText: 'How do you prefer to reset your access ?',
      EmailCheckbox: 'By E-mail',
      OtherCheckbox: 'Other',
      ByEmail_Title: 'Send a message to us',
      Other_Title: 'Contact our customer service!',
      Email_field: 'E-mail',
      Phone_field: 'Phone',
      Message_field: 'Message',
      RecoveryPassword: 'Recovery Access',
      Notify_Error_Title: 'Lost Access',
      Notify_Error_Message_Error: 'Invalid e-mail address',
      Phone_href: 'tel:+5501130532750',
      Phone_Text: '(11) 3053-2750',
      Mail_href: 'mailto:atendimento@cma.com.br',
      Mail_Text: 'atendimento@cma.com.br'
    },
    NEW_CLIENT: {
      Title: 'New around here?',
      Title2: 'Follow the movements of agricultural markets.',
      Title3: 'Exclusive Advantages of the SAFRAS Platform',
      Description_1: 'Complete follow-up of <span> USDA </span> reports, integrating market forecasts, agricultural news, alerts, tables, videos and audios',
      Description_2: 'Important data on production, marketing, planting, harvesting and exports of the main commodities, highlighting exclusive data from <span> SAFRAS & Mercado </span>',
      Description_3: 'Own team of journalists with extensive expertise in agribusiness coverage',
      Email_field: 'E-mail',
      Phone_field: 'Phone',
      Name_field: 'Name',
      Notify_Error_Title: 'New around here ?',
      Notify_Error_Message_Error: 'Please check for errors',
    },
    TOUR_STEPS: {
      ButtonSkip: 'Do not display',
      ButtonPrevious: 'Previous',
      ButtonNext: 'Next',
      ButtonStop: 'Finish',
      StepNewCommodityText: `<div>A new <b>Fertilizer</b> commodity has been inserted on the platform</div>`,
      StepFilterText: `<div>Filter moved</div>`,
      StepNewHighlightText: `<div class="tour-title">Now we have highlights for Safras TV!</div> <div class="tour-small">Discover the "Resenha SAFRAS & Mercado", the new weekly program that brings together special guests, of great influence in agribusiness</div>`,
      StepFavoriteText: `<div class="tour-title">Now we have favorites!</div> <div class="tour-small">Hovering the mouse over the item will show the icon that allows you to bookmark the content.</div>`,
      StepPlayTourAgainText: `<div class="tour-title">Inside the help window you can start the Platform Tour again with the latest news</div>`,
    },
    DIALOG_MESSAGES: {
      Title: 'Warning',
      UserRightsText: 'Your user does not have access to this content. Contact us to enable',
      GetMoreQuestionsText: 'There are no more questions available. Contact us to learn more',
      PlatformTourText: 'Would you like to start the tour and see what\'s new on the platform?',
      AcceptText: 'Contact us',
      CancelText: 'Close',
      StartText: 'Start',
      NotDisplatText: 'Do not display',
      SentRequestDemo: 'We have sent your demo request. We will send you an e-mail for more news.',
      AccountEditDataText: 'To edit your data, please send a message to our customer service team.'
    },
    BADGES: {
      Important: 'IMPORTANT',
      Exclusive: 'EXCLUSIVE',
      InLive: 'LIVE',
      Disclosure: 'DISCLOSURE',
      Announcement: 'ANNOUNCEMENT',
      Invite: 'Invite',
    },
    BADGES_MEDIA: {
      Appendix: 'Appendix',
      Audio: 'Audio',
      Video: 'Video',
      Podcast: 'Podcast'
    },
    REGISTER: {
      Title: 'Create Account',
      Subtitle: 'Fill the below form to create a new account.',
      Field_Email: 'E-mail',
      Field_Email_Again: 'Repeat E-mail',
      Placeholder_Email: 'Type E-mail',
      Placeholder_Email_Again: 'Type E-mail Again',
      Field_Username: 'Name',
      Placeholder_Username: 'Type Name',
      Field_UserType: 'User Type',
      Placeholder_UserType: 'Select User Type',
      Field_Cnpj: 'CNPJ',
      Placeholder_Cnpj: '00.000.000/0000-00',
      Field_Cpf: 'CPF',
      Placeholder_Cpf: '000.000.000-00',
      Field_Phone: 'Phone',
      Placeholder_Phone: '00 00000-0000',
      Field_Password: 'Password',
      Placeholder_Password: 'Type Password',
      Confirm_Email_Title: 'Confirm E-mail',
      Confirm_Email_Subtitle: 'We sent the code to your e-mail',
      Confirm_Email_Field_Code: 'Code',
      Confirm_Email_Placeholder_Code: 'Type the code',
      Confirm_Email_Send_Token: 'Code successfully sent',
      UserType_Item_PF: 'Natural Person',
      UserType_Item_PJ: 'Legal Person',
      HasAccount: 'Already have an account?',
      Terms_Of_Use: 'Please, read the Terms of Use',
      Accept_Terms: 'I accept the terms of use',
      Register: 'Register',
      Request_Free: 'I want to register to access only the free content on the platform',
      Request_Demo: 'I want to register and request a 7-day demo period to have access to all content on the platform',
      Success_Register: 'Successfully registered'
    },
    USER_SIGNATURE: {
      Title: 'Signature',
      Contracted_Plan: 'Contracted Plan',
      Signature_Validate: 'Subscription active until',
      Signature_Option_Agency_Safras_RT: 'SAFRAS Agency (RT)',
      Signature_Option_Other_Agencies: 'Other Agencies (under contract)',
      Signature_Option_Analisy_Agro_Today: 'Agro Analysis Today',
      Signature_Option_Analisy_Agro_Vision: 'Agro Vision Analysis',
      Signature_Option_Estatistic_Export: 'Statistics + Export/Import',
      Signature_Option_Ask_Analyst: 'Ask the Analyst',
      Signature_Option_Safras_Tv: 'SAFRAS TV',
      Signature_Option_Safras_Podcast: 'SAFRAS Podcast',
      Signature_Option_Courses: 'Courses',
      Signature_Option_Speechs: 'Speeches',
      Signature_Option_Weather: 'Climate',
      Signature_Option_Fisical_Market: 'Physical Market',
      Signature_Option_Future_Market: 'Future Market (DT and/or RT)',
      Signature_Option_Indicative: 'Indicators',
      Signature_Option_Exchange_Market: 'Exchange (DT)',
      Signature_Option_Lineup_Ships: 'Line-up of Ships',
      Signature_Option_Freight_Calculator: 'Freight Calculator',
      Signature_Option_Open_Line: 'Open Line (Direct Access to the Analyst)',
      Signature_Option_Monthly_Conference: 'Monthly teleconference with the Analyst',
      Latest: 'Latest',
      Publications: 'Publications'
    },
    PACKAGES: {
      Title: 'Packages',
      Contracted_Plan: 'Contracted Plan',
      Signature_Validate: 'Subscription active until',
      I_Want_To_Hire: 'I Want to Hire',
      More_Info: 'More Information'
    },
    USER_NOTIFICATION: {
      Notification: 'Notifications',
      Subtitle: "Configure email and app notifications for each commodity",
      Not_Receive_Email: "I don't want to receive e-mails",
      Not_Receive_Push: "I don't want to receive notifications in the app",
      Content: 'Contents',
      Email: 'E-mail',
      Push: 'App',
      All: 'All',
      Block_notifications: 'Block notifications',

    },
    NEWS_DETAIL: {
      Event: 'Event',
      Invite: 'Invite',
      Type: 'Type',
      Type_Online: 'Online',
      Type_Presential: 'Presential',
      All_Day: 'All Day',
      Start_Date: 'Start date',
      Final_Date: 'Final date',
      Location: 'Place',
      Price: 'Price',
      Link: 'Link',
      Related_Event: 'Related Event',
      Content: 'Content',
      Country: 'Country',
      Report: 'Report',
      Report_Date: 'Report Date',
      Publish_Date: 'Publish Date',
      Updated: 'Updated',
      Private_Content: 'Private content for subscribers only',
      By: 'by',
      Read_More: 'Read more at',
      Kind_Event: 'Kind of Event',
      Start_Event: 'Start of Event',
      Event_Details: 'Event Details',
      Price: 'Price',
      End_Event: 'End of Event',
      Event_Location: 'Event Location',
      Open: 'Open',
      Related_News: 'Related News',
    },
    USER_PROFILE: {
      Subscriber: 'Subscriber',
      Demo: 'Demonstration',
      Free: 'Free'
    },
    SIGAWEB_DEMO: {
      Plan_Free_Title: 'Free Plan',
      Plan_Demo_Title: 'Demo Plan',
      Plan_Subscribe_Title: 'Subscription Plan',
      Free_Text_First: 'You are using a free subscription plan.',
      Free_Text_Second: 'If you wish, request a demonstration of the complete Safras Platform, with access to all contents and functionalities.',
      Free_Text_Third: 'To find out about the other subscription plans, contact us at  <a href="mailto:prevendas@cma.com.br?Subject=Contato" target="_top">prevendas@cma.com.br</a> or by phone/WhatsApp: <a href="https://wa.me/5511939478908?text=Olá%2C%20gostaria%20de%20sabe%20as%20condições%20para%20continuar%20acessando%20a%20Plataforma%20SAFRAS" target="_blank">(11) 93947-8908</a>',
      Free_Text_Email: 'prevendas@cma.com.br',
      Free_Text_Click_Here: 'Request demo',
      Request_Demo: 'Request for demo',
      Signature_Valid_Until: 'Signature valid until',
      Signature_Active: 'Active signature',
      Dialog_Title: 'Notice',
      Field_Empty: 'not found.',
      Field_Invalid_Format: 'with invalid format.',
      User_Exist: 'There is already an active contract in our system..',
      User_Demo_Exist: 'There is already an active demo in our system.',
      Contact: '\n\nIf the error persists, contact us for more information.',
      SentRequest: 'We received your Safras Platform demo request. We will send access information to your registered email.',
      Attendance_Message: 'Hello, I need help with the demo.',
      Demo_Request: 'Demo request',
      Update_Phone_Title: 'Update your phone number',
      Update_Phone_Text: 'Please enter your phone number so we can update our system.',
      Update: 'Update'
    },
    AUTHOR_DETAIL: {
      Publication: 'Publications',
      Total: 'Total',
      Today: 'Today',
      Last_Sent: 'Last sent'
    },
    DISPLAY_TYPES: {
      List: 'List',
      Card: 'Card',
      Mosaic: 'Mosaic',
      Tag: 'Tag',
      Calendar: 'Calendar',
      Schedule: 'Schedule',
      Playlist: 'Playlist'
    },
    ACCESSIBILITY: {
      Accessibility: 'Accessibility',
      Normal: 'Normal',
      To_Hear: 'To hear',
      Pause_reading: 'Pause reading',
      Appendix: 'Appendix'
    },
    HIGHLIGHTS: {
      Highlights: 'Highlights',
      Exclusive_Content: 'Exclusive Content',
    },
    MULTIMEDIA: {
      Details: 'See details',
      Play: 'Play',
      Add_Playlist: 'Add to playlist'
    },
    VIEW_MODES: {
      By: '',
      In: ''
    },
    LOGOUT: {
      Title: 'Closed session',
      Message: 'Your session has been terminated due to concurrent access.'
    },
    TICKER: {
      View: 'View:',
      Important: 'Important',
      Highlights: 'Highlights',
      View_At_Top: 'View at top',
      View_In_Footer: 'View in footer',
    },
    PRIVATE_CONTENT: {
      Register: 'Sign Up Now!',
      Exclusive_Subscribers: 'Achieve success in agribusiness with the SAFRAS Platform!',
      Sign_Up_access: 'The free demo period aims to offer a sample of what the Safras Platform can provide for your business and investments. If you want unlimited access to all the service’s exclusive features and content, get to know about the different subscription plans to be part of our customer community.',
      Smart_Content_Title: 'Discover Subscription Plans',
      Smart_Content_L1: 'Identify profitable opportunities and increase your competitive potential in agribusiness.',
      Smart_Content_L2: 'Invest with accuracy, security, and protection in agricultural commodities.',
      Smart_Content_L3: 'Make strategic decisions with exclusive analysis from the SAFRAS Platform.',
      Smart_Content_L4: 'Stay updated on the global scenario with news, weather forecasts, and price parities.',
      Smart_Content_L5: 'Maximize your results with protection and access to comprehensive statistics.',
      Alert_Footer: 'Free access to the Safras Platform and the free demo period are intended to offer a sample of what Safras Platform can provide for your business and investments. If you want unlimited access to all the service’s exclusive features and content, learn about the different subscription plans to be part of our customer community.'
    },
    PRIVATE_CONTENTUSERDEMO: {
      Register: 'Explore Subscription Plans',
      Attendance: 'Attendance',
      IOS_Text: 'If you are interested in this type of content, request release',
      Exclusive_Subscribers: 'You are in the SAFRAS Platform demonstration period.!',
      Sign_Up_access: 'I apologize for the misunderstanding. During the demonstration period, certain information may not be accessible. However, as a subscriber to the SAFRAS Platform, you will have access to a wide range of features and benefits. Explore the different subscription plans to become part of our customer community and fully experience everything we have to offer, including the ability to explore, learn, and make the most out of our platform.',
      Smart_Content_Title: 'Discover Subscription Plans',
      Smart_Content_L1: 'Identify profitable opportunities and increase your competitive potential in agribusiness.',
      Smart_Content_L2: 'Invest with accuracy, security, and protection in agricultural commodities.',
      Smart_Content_L3: 'Make strategic decisions with exclusive analysis from the SAFRAS Platform.',
      Smart_Content_L4: 'Stay updated on the global scenario with news, weather forecasts, and price parities.',
      Smart_Content_L5: 'Maximize your results with protection and access to comprehensive statistics.',
      Alert_Footer: 'The free trial period aims to provide a sample of what the SAFRAS Platform can offer to your business and investments. If you wish to have unlimited access to all the exclusive resources and content of the service, explore the different subscription plans to join our customer community.'
    },
    PRIVATE_CONTENTUSERSUBSCRIBER: {
      Register: 'Explore Subscription Plans',
      Exclusive_Subscribers: 'Congratulations, you are already a Safras Platform subscriber!',
      Sign_Up_access: 'However, your current plan does not include the information that you are trying to access.Learn about alternative subscription plans to gain access to more strategic information and resources that will help you expand your business and investment results.',
      Smart_Content_Title: 'Discover Subscription Plans',
      Smart_Content_L1: 'Identify profitable opportunities and increase your competitive potential in agribusiness.',
      Smart_Content_L2: 'Invest with accuracy, security, and protection in agricultural commodities.',
      Smart_Content_L3: 'Make strategic decisions with exclusive analysis from the SAFRAS Platform.',
      Smart_Content_L4: 'Stay updated on the global scenario with news, weather forecasts, and price parities.',
      Smart_Content_L5: 'Maximize your results with protection and access to comprehensive statistics.',
    },
    TOAST_NOTIFICATIONS: {
      // Validação de token
      invalidToken: 'Invalid code',
      expiredToken: 'Expired code',
      // Login
      userNotFound: 'User not found',
      insufficientRights: 'User does not have rights to access the system. Contact our Customer Service team via email atendimento@cma.com.br.',
      disabledUser: 'Disabled user',
      invalidCredentials: 'Invalid username or password',
      // Login via S4
      unauthorized: 'Unauthorized',
      disabledS4User: 'Disabled user',
      // Esqueci a senha
      emailNotFound: 'Email not found',
      disabledUserForgotPassword: 'Disabled user',
      emailNotFoundSystem: 'Email not found. Contact our Customer Service team via email atendimento@cma.com.br.',
      // Reset de senha
      invalidConfirmPassword: 'Invalid password confirmation',
      expiredResetToken: 'Expired token',
      invalidResetToken: 'Invalid token',
      // Troca de senha
      invalidCurrentPassword: 'Invalid current password',
      newPasswordMismatch: 'New password and confirmation must match',
      newPasswordSameAsCurrent: 'New password cannot be the same as the current password',
      // Cadastro
      invalidCPF: 'Invalid CPF',
      invalidCNPJ: 'Invalid CNPJ',
      cpfAlreadyRegistered: 'CPF already registered',
      cnpjAlreadyRegistered: 'CNPJ already registered',
      emailAlreadyRegistered: 'E-mail already registered. Try to access the system or Contact our Customer Service team by email atendimento@cma.com.br.',
      emailAlreadyRegisteredSystem: 'This email is already registered in our system. Use it to access the Safras Platform.',
      // Leitura de PDF
      documentNotFound: 'Document not found',
      // Download público de PDF
      invalidCode: 'Invalid code',
      documentNotFoundPublic: 'Document not found',
      expiredTokenPublic: 'Expired token',
      nonExistentEmail: 'Non-existent email',
      nonExistentReportId: 'Non-existent report ID',
      userNotFoundPublic: 'User not found',
      disabledUserPublic: 'Disabled user',
      // Removendo DeviceID no logout
      deviceIdNotFound: 'Device ID not found',
      // TMN Quotes
      displayCannotLoadSystemTitle: 'Failed to load the system',
      displayCannotLoadSystemMessage: 'Communication failure. Please refresh the page or contact our Customer Service team via email atendimento@cma.com.br.',
      displayNotAuthorizedTitle: 'Error',
      displayNotAuthorizedMessage: 'Communication failure. Please refresh the page or contact our Customer Service team via email atendimento@cma.com.br.',
      messagesNotifyHelperTitle: 'Error',
      messagesNotifyHelperMessage: 'Communication failure. Please refresh the page or contact our Customer Service team via email atendimento@cma.com.br.',
      // Ask The Analyst
      askAnalystTitle: 'Ask the Analyst',
      askAnalystSuccess: 'Question sent to analyst successfully',
      // REGISTER
      registerRequestDemoTitle: 'Demo',
      registerRequestDemoMessage: 'Upon completion of registration, we will process your demo request. We will send you an email for more information.',
      // Packages
      packRequestDemoTitle: 'Demo',
      packRequestDemoMessage: 'Request sent successfully.',
      userPhoneNotFound: 'Phone not found',

      // TMN HELPER
      checkNotifyErrorTitle: 'Error',
      checkNotifyErrorsMessage: 'Communication failure. Please refresh the page or contact our Customer Service team via email atendimento@cma.com.br.',
      // CHECK USER INFO
      checkUserInfoTitle: 'User',
      checkUserInfoMessage: 'Disabled user.',
      // INTERNAL SERVER ERROR
      internalServerErrorTitle: 'Error 503',
      internalServerErrorMessage: 'System currently unavailable, please try again in a few moments.',
      userCannotDelete: 'Account with active subscription cannot be deleted.',
    },
    WDMA: {
      Error_System_Title: 'Unable to load the system.',
      Error_System_Subtitle: 'Try again later...',
      Error_System_Button_Update: 'Update',
      Error_System_Button_Attendance: 'Get in touch',
      Error_Session_Close: 'We have identified that another station has connected',
      Error_System_Title_Session_Close: 'You have been disconnected.',
      Error_System_Button_Connect: 'Connect',
      Error_Title_Max_Simultaneous_Connections: 'You have reached the maximum number of allowed simultaneous connections',
      Error_Max_Simultaneous_Connections: 'Please close an old connection to allow new access',
      Error_Title_Invalid_Credentials: 'Access denied',
      Error_Invalid_Credentials: 'Check your credentials or contact your administrator',
    },
    DELETE_ACCOUNT: {
      Delete_Account_Button: 'Request for Deletion of Personal Data',
      Title: 'NOTICE',
      First_Question: `The request for deletion of personal data from our databases is a right guaranteed by the General Law for the Protection of Personal Data.
      \n However, without this information, we will not be able to identify your accesses.
      \n Therefore, if you proceed with this request, once your request is processed, your access to the Safras Platform will be blocked, and you will not be able to access it again until you re-register.
      \n If you have a current contract for the use of the Safras Platform, registering the request for the deletion of your personal data will not release you from complying with the agreed conditions of contractual termination, and your request will only take effect after you receive contact from our commercial area, which will guide you through the steps of this deregistration process.
      \n In case you have or ever had a contract to use the products sold by this company, your personal data will be deleted from the Safras Platform but may be retained in the company’s internal systems as long as they are necessary to meet the legal obligations to which the company is subjected.
      \n Do you really want to proceed?`,
      First_Question_Button_Decline: 'Give up',
      First_Question_Button_Continue: 'Register request',
      First_Question_Success_Title: 'Success',
      First_Question_Success_Text: `Your request to delete your personal data has been received and is being processed.
      \n Your session is being terminated.
      \n If you wish to resume your access to the Safras Platform, make a new registration.`,
      Cannot_Delete_Text: `Your request to delete your personal data has been received and is being processed.
      \n Please, wait for contact from our commercial area, which will review with you the conditions of your current contract.`
    },
    SCHEDULE: {
      Empty_Schedule: 'Your calendar is empty',
      Empty_Schedule_Text: 'Add events to your calendar.',
      Clean: 'CLEAN',
      Today: 'Today',
      Month: 'Month',
      Week: 'Week',
      Day: 'Day',
      List: 'List'
    },
    BIOMETRY: {
      Cancel: "Cancel",
      Activate: "Activate",
      Use_Pin: "Use PIN",
      Show_Fingerprint_Desc: "Biometric recognition to access your",
      Register_Biometric_Secret_Desc: "Biometric recognition",
      Biometry_Confirm_Activate_Text: "Do you want to enable biometrics now for quick and secure access?",
      Biometry_Confirm_Title: "Login"
    }
  },
  EsEs: {
    BOOLEAN: {
      Yes: 'Sí',
      No: 'No'
    },
    USER: {
      Details: 'Detalles',
      Email: 'E-mail:',
      Name: 'Nombre:',
      Profile: 'Planes:',
      Document: 'Documento:',
      Phone: 'Teléfono:',
      Country: 'País:',
    },
    BUTTONS: {
      Save: 'Salvar',
      Cancel: 'Cancelar',
      Back: 'Atrás',
      Send: 'Enviar',
      Enter: 'Entrar',
      AccessAccount: 'Acceder a tu cuenta',
      Register: 'Registro',
      BackLogin: 'Atrás para iniciar sesión',
      RecoverButton: 'Contraseña de recuperación',
      DownloadFile: 'Descargar archivo',
      BackHomePage: 'Volver a la página de inicio',
      MoreQuestion: 'Más preguntas',
      RecoveryPassword: 'Recovery Password',
      TestTrial: 'Prueba gratuita de 7 días',
      Save_Announcement: 'Guardar anuncio',
      Edit_Data: 'Editar datos',
      Remove: 'Eliminar'
    },
    GENERAL: {
      Home: 'Hogar',
      Edit: 'Editar',
      Delete: 'Borrar',
      Update: 'Actualizar',
      Create: 'Crear',
      Error: 'Error',
      Atention: 'Atención',
      Send: 'Mandar',
      Cma_Url: 'https://www.cma.com.br/esp/home-2/',
      Safras_Url: 'https://safras.com.br/es/home-espanhol/',
      Safras_Url_Request: 'https://pagina.safras.com.br/esp-mercado-agropecuario',
      Error_Download_File: 'No se pudo descargar el archivo',
      Copy_Data: 'Copiar datos'
    },
    LOGIN: {
      Title: 'Entrar',
      User: 'E-mail',
      Password: 'Contraseña',
      Remember: 'Recuerda',
      ForgotPass: 'Contraseña olvidada?',
      Enter: 'Entrar',
      Register: 'Registro',
      Code: 'código',
      New_Here: '¿Nuevo aquí?',
      Lost_Acess: 'Dificultad con el acceso?',
      Know_More: 'Sepa Mas',
      Click_Here: 'Haga clic aquí',
      Resend_Token: 'para reenviar el codigo',
      Notify_Error_Title: 'Aviso',
      Notify_Error_Message: 'Usuario o contraseña invalido',
      New_Here_Link: 'https://www.cma.com.br/esp/plataforma-safras-espanol/',
      Two_Factor_Auth_Title: "Dupla autenticação",
      Two_Factor_Auth_Desc: "Enviamos para seu e-mail um código para autenticação. ",
      Two_Factor_Auth_Code: "Codigo",
      Two_Factor_Auth_Code_Placeholder: "Digite o codigo",
      Confirm_Email_Title: "Confirmação de e-mail",
      Confirm_Email_Desc: "Su registro para acceder a la demostración de la Plataforma Safras aún no se ha completado. Debes registrar el token enviado por Safras & Mercado a tu dirección de correo electrónico en la pantalla de registro.",
      Confirm_Email_Desc_Token_Val: "Tiempo de vencimiento del token: hasta 2 horas.",
      Confirm_Email_Desc_Sec: "¿No recibiste el correo electrónico?",
      Confirm_Email_Field_Code: 'Codigo',
      Confirm_Email_Placeholder_Code: 'Digite o código',
      Confirm_Email_Send_Token: 'Codigo enviado com sucesso',
      Notify_Accept_Terms: 'Usted debe aceptar las Bases y Condiciones para finalizar el registro.',
      Footer_CMA: 'está protegido por reCaptcha y está sujeto a su',
      Click_Back: 'HAGA CLIC PARA VOLVER',
      Text_Market: 'Safras & Mercado: todo sobre agronegocios en un solo lugar'
    },
    LOGINS4: {
      Error_Message_Title: 'Hay un problema.',
      Error_Message_Content: 'Inténtelo de nuevo en un momento y, si el problema persiste, comuníquese con nuestro centro de atención al cliente.',
      Error_Message_Content_Other_Login: 'Prezado usuário, sua sessão expirou. Por favor, feche este módulo e abra novamente.',
    },
    MENU: {
      Home: 'Home',
      AllSubjects: 'All Subjects',
      Subjects: 'Subjects',
      AllCommodities: 'Todos los Commodities',
      Commodities: 'Commodities',
      DisabledItems: 'Suscríbase ahora',
      MoreCommodities: 'Más Commodities',
      NoRights: 'Sin derechos'
    },
    TABLE: {
      Column_ID: 'ID',
      Column_DT_Insert: 'Insert Date',
      Column_DT_Change: 'Change Date',
    },
    MESSAGES: {
      Messages_Created: 'Registro creado',
      Messages_Updated: 'Registro actualizado',
      Messages_Deleted: 'Registro eliminado',
      Messages_Generic_Error: 'Error al ejecutar la operación',
    },
    NAVBAR_DROPDOWN_MENU: {
      Profile: 'Perfil',
      Change_Password: 'Cambiar Contraseña',
      Ask_To_Analyst: 'Preguntar al analista',
      Dark_Theme: 'Tema Oscuro',
      Light_Theme: 'Tema claro',
      Biometry: 'Biometria',
      Language: 'Idioma',
      Logout: 'Salir',
      Privacy_Policy: 'Política de privacidad',
      Notification: 'Notificación',
      Signatures: 'Firmas',
      Packages: 'Planes',
      My_Account: 'Mi cuenta',
      Info_Account: 'Detalle de la cuenta',
      Platform_Config: 'Configuración de plataforma',
      Font_Size: 'Tamano del texto',
      Font_Align: 'Alineación de la imagen',
      Font_Compact: 'Compacto',
      Font_Default: 'Defecto',
      Font_Big: 'Grande',
      Appearance: 'Apariencia',
      View_Type_List: 'Lista',
      View_Type_Card: 'Tarjeta',
      About: 'Sobre',
      Help: 'Ayuda',
      Show_Ticker: 'Mostrar ticker',
      Hide_Ticker: 'Ocultar ticker',
      Quotes_Config: 'Apoyo'
    },
    CHANGE_PASSWORD: {
      Title: 'Contraseña',
      Field_Email: 'E-mail',
      Field_Current_Password: 'Contraseña actual',
      Field_New_Password: 'Nueva contraseña',
      Field_New_Password_Repeat: 'Repite la contraseña',
      Notify_Success_Title: 'Cambia la contraseña',
      Notify_Success_Message: 'Contraseña actualizada exitosamente',
      Quit_all_apps: 'Cerrar sesión en todos los dispositivos',
      Remember_Password: "¿No recuerdas tu contraseña actual?",
      Click_Retrieve: 'Haga clic aquí para recuperar',
      Update_Password: 'Actualiza tu contraseña',
      Enter_Current_Password: 'Para actualizar su contraseña, debe ingresar la actual.'
    },
    RESET_PASSWORD: {
      ResetTitle: 'Cambia la contraseña',
      ResetDesc: 'Por favor ingrese su nueva contraseña',
      ResetPass: 'Nueva contraseña',
      ResetConfirm: 'Repita la nueva contraseña',
      Reset_Confirm: 'repetir',
      InvalidToken: 'Codigo no valido',
      Notify_Title: 'Cambia la contraseña',
      Notify_Error_Message: 'Por favor revise los campos de contraseña.',
      PasswordChanged: 'Cambia la contraseña',
      PasswordChangedDesc: 'Su contraseña se ha actualizado correctamente',
    },
    FORGOT_PASSWORD: {
      RecoverTitle: 'Recupere su contraseña',
      RecoverDesc: 'Ingrese su dirección de correo electrónico y le enviaremos instrucciones para recuperar su contraseña.',
      Field_Email: 'E-mail',
      EmailSent: 'E-mail enviado',
      CheckEmail: 'Se te ha enviado un correo electrónico. Por favor revise su bandeja de entrada',
      Notify_Success_Title: 'Contraseña',
      Notify_Success_Message: 'Por favor revise su correo electrónico',
      Notify_Error_Title: 'Recuperación de contraseña',
      Notify_Error_Message: 'Dirección de correo electrónico no válida'
    },
    ASK_THE_ANALYST: {
      Title: 'Preguntar al Analista',
      TitleHedge: 'Cotizar con la mesa',
      Field_Email: 'E-mail',
      Field_Name: 'Nombre',
      Field_Question: 'Pregunta',
      Field_Commodity: 'Commodity',
      Remaining_Questions: 'Preguntas restantes disponibles: '
    },
    MY_ACCOUNT: {
      Title: 'Perfil',
      Field_Email: 'E-mail',
      Field_Name: 'Nombre',
      Field_CnpjCpf: 'Document',
      Field_Phone: 'Phone',
      Field_Groups: 'Grupos',
      Field_Language: 'Lenguaje de la plataforma',
      Text_Language: 'Este parámetro cambia solo el idioma de la plataforma. Para cambiar el contenido, comuníquese con el centro de atención al cliente.',
      Field_Country: 'País',
      Title_Receive_Email: 'Reciba por correo electrónico',
      Title_Notification: 'Notificações',
      Field_Option_All: 'Todos',
      Notify_Success_Title: 'Perfil',
      Notify_Success_Message: 'Datos actualizados exitosamente',
      Help_Language: 'Requerido para recibir correo electrónico en el idioma elegido'
    },
    ERROR_404: {
      Title: 'Ops, página no encontrada',
      Message: 'Lo sentimos, esta página no fue encontrada'
    },
    FOOTER: {
      Help: 'Ayuda'
    },
    HELP: {
      Tab_About: 'Sobre',
      Tab_Attendance: 'Asistencia',
      Tab_Version: 'Versión',
      Tab_LGPD: 'LGPD',
      Tab_PrivacyPolicy: 'Política de privacidad',
      Tab_Tour: 'Tour',
      Tab_Terms: 'Terminos de uso',
      Tab_Quotes_Config: 'Apoyo'
    },
    HELP_ABOUT: {
      Cma_Title: 'Sobre CMA',
      Cma_Text: 'CMA Consultoria, Métodos, Assessoria e Mercantil S/A es una empresa multinacional brasileña que desde 1973 se dedica al desarrollo de soluciones de alta tecnología aplicadas a los mercados financieros y de productos básicos, educación, telecomunicaciones y centros de datos. La compañía tiene su sede y 9 sucursales en Brasil, además de sucursales en los Estados Unidos, América Latina y Europa, con clientes en 35 países.',
      Safras_Title: 'Sobre SAFRAS & Mercados',
      Safras_Text: 'SAFRAS & Mercado es la principal consultora brasileña de agronegocios. Monitorea diariamente los mercados de soya, maíz, algodón, café, azúcar y alcohol, carne de res, pollo, cerdo, arroz, frijoles y bioenergía, ofreciendo diferentes niveles de servicios que ayudan a la toma de decisiones de los participantes de diferentes sectores agrícolas. SAFRAS tiene la base de datos histórica más completa de la agroindustria brasileña, es una referencia internacional en proyecciones y escenarios agrícolas.',
      Know_More: 'Obtenga más información en',
      Visit_Website: 'Visite el sitio web en:'
    },
    HELP_ATTENDANCE: {
      Title: 'Asistencia',
      Contact_Text: '¡Contáctenos y nos pondremos en contacto con usted pronto!',
      Phone: 'Teléfono:',
      Email: 'E-mail:',
      Whatsapp: 'WhatsApp:',
      Form_Text: 'O envíe un mensaje usando el formulario a continuación.',
      Form_Field_Message: 'Mensaje',
      Notify_Success_Title: 'Asistencia',
      Notify_Success_Message: 'Mensaje enviado con éxito',
      Phone_href: 'tel:+34913231858',
      Phone_Text: '+34 91 323 18 58',
      Whatsapp_href: 'href="https://wa.me/551130532600" target="_blank"',
      Whatsapp_Text: '(11) 3053-2600',
      Mail_href: 'mailto:international.support@cma.com.br',
      Mail_Text: 'international.support@cma.com.br',
      NoRights_Text_Commodity: 'Me gustaría habilitar el acceso a contenido básico %.',
      NoRights_Text_Content: 'Me gustaría habilitar el acceso al % de contenido de productos básicos #.',
      NoRights_Text_GetMoreQuestions: 'Me gustaría habilitar más preguntas para los analistas.',
      Edit_Account_Data: 'Me gustaría editar mis datos',
    },
    HELP_VERSION: {
      Title: 'Versión',
      Item_Version: 'Versión',
      Item_Browser: 'Navegador',
      Item_System: 'Sistema',
      Item_Resolution: 'Resolución',
      Item_Status: 'Estado',
    },
    HELP_LGPD: {
      Accept_Cookies: 'Aceptar',
      Reject_Cookies: 'Rechazar',
      Privacy_Policy: 'Ler Política de Privacidad',
      Cookies_Notice: 'Nuestro sitio web utiliza cookies para brindarle contenido personalizado y para el análisis del sitio. ¡Le recomendamos que acepte, para una mejor navegación en la página!',
      LGPD_Title: 'Lei Geral de Proteção de Dados Pessoais (LGPD)',
      LGPD_Text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged."
    },
    HELP_PRIVACY_POLICY: {
      Privacy_Policy: 'Política de Privacidade',
      Title: 'Política de Privacidade e Confidencialidade da Informação'
    },
    HELP_SUPPORT: {
      Follow_Market: 'Sigue el Mercado',
      Restore_Layout: "Restaurar diseño predeterminado",
      Clear_Local_Data: "Borrar datos locales",
      Detailed_Info: "Información detallada",
      Layout_History: "Historial de diseño",
      Created: 'Creado',
      Updated: "Actualizado",
      Copy_Info_Success: "Los datos se han copiado al portapapeles.",
      Clear_Local_Data_Dialog_Title: "Borrar datos",
      Clear_Local_Data_Dialog_Message: "¿Desea borrar los datos de 'acompañar el mercado'?",
      Restore_Layout_Dialog_Title: "Restaurar diseño predeterminado",
      Restore_Layout_Dialog_Message: "¿Desea restaurar el diseño de 'acompañar el mercado' al predeterminado? La página se actualizará y será necesario iniciar sesión nuevamente.",
      Update_Layout_History_Dialog_Title: "Restaurar historial de diseño",
      Update_Layout_History_Dialog_Message: "¿Desea restaurar su diseño del día",
      Detailed_Info_No_Data: 'No hay datos por el momento'
    },
    TERMS_USE: {
      Title: 'Terminos de uso',
      Text: '<p class="mt-3 mb-3">Todo el contenido disponible en la Plataforma Safras está protegido por la Ley de Derechos de Autor y para uso exclusivo de sus suscriptores. Por ello, queda prohibida la reproducción o distribución del contenido, total o parcialmente, sin la previa y expresa autorización de CMA. El incumplimiento de esta prohibición dará lugar a sanciones civiles y penales.</p><p class="mt-3 mb-3">La información proporcionada en la Plataforma Safras refleja exclusivamente investigaciones e investigaciones realizadas por profesionales de Safras & Mercado. Consiste en información disponible al público y que se cree confiable al momento de la publicación.</p><p class="mt-3 mb-3">Este contenido está sujeto a cambios y se basa en la libertad de expresión. Por tanto, tiene carácter meramente informativo, no constituyendo ofertas ni recomendaciones para la negociación de valores, ya sean valores, materias primas y/u otros instrumentos financieros o económicos.</p><p class="mt-3 mb-3"> El La información contenida en la Plataforma Safras tiene como objetivo fomentar el debate y la educación sobre economía y agronegocios para sus suscriptores. De esta forma, los suscriptores deberán desarrollar sus propios diagnósticos de mercado para la toma de decisiones sobre la gestión de sus negocios y/o inversiones, eximiendo, salvaguardando y protegiendo integralmente a CMA de las consecuencias de dichas decisiones e, incluso, de cualesquiera pérdidas, daños y perjuicios económicos. , durante y después del final del período del plan de suscripción.</p>',
      Text_Mobile: '<p class="mt-3 mb-3">Todo el contenido disponible en la Plataforma Safras está protegido por la Ley de Derechos de Autor y para uso exclusivo de sus suscriptores. Por ello, queda prohibida la reproducción o distribución del contenido, total o parcialmente, sin la previa y expresa autorización de CMA. El incumplimiento de esta prohibición dará lugar a sanciones civiles y penales.</p><p class="mt-3 mb-3">La información proporcionada en la Plataforma Safras refleja exclusivamente investigaciones e investigaciones realizadas por profesionales de Safras & Mercado. Consiste en información disponible al público y que se cree confiable al momento de la publicación.</p><p class="mt-3 mb-3">Este contenido está sujeto a cambios y se basa en la libertad de expresión. Por tanto, tiene carácter meramente informativo, no constituyendo ofertas ni recomendaciones para la negociación de valores, ya sean valores, materias primas y/u otros instrumentos financieros o económicos.</p><p class="mt-3 mb-3"> El La información contenida en la Plataforma Safras tiene como objetivo fomentar el debate y la educación sobre economía y agronegocios para sus suscriptores. De esta forma, los suscriptores deberán desarrollar sus propios diagnósticos de mercado para la toma de decisiones sobre la gestión de sus negocios y/o inversiones, eximiendo, salvaguardando y protegiendo integralmente a CMA de las consecuencias de dichas decisiones e, incluso, de cualesquiera pérdidas, daños y perjuicios económicos. , durante y después de la período de uso del sistema.</p>',
      Read_Accepted: 'He leído y acepto',
      Cancel: 'Cancelar'
    },
    REPORT: {
      No_Report_Found: 'No se encontró informe',
      No_Report_Found_Text: "Puede rehacer la búsqueda para encontrar lo que está buscando.",
      No_Report_Found_Text_Demo: "Para obtener más resultados y contenidos exclusivos, regístrese o acceda a nuestra plataforma.",
      Load_More: 'Carga más...',
      Download_Spreadsheet: 'Descarga de hoja de cálculo',
      Download_Spreadsheet_Text: 'Haga clic para descargar la hoja de cálculo',
      Hear_Text: 'Escuchar el Texto',
      All_Commodities: 'Todos los Commodities',
      View_More: 'Ver más'
    },
    REPORT_FILTER: {
      Informative_Title: 'Informativo',
      Informative: 'Análisis e Informativos',
      Search: 'Buscar',
      Filters: 'Pesquisar',
      Filter_Periodicity: 'Frecuencia',
      Filter_Publication_Type: 'Tipo de contenido',
      Filter_Subject: 'Commodities',
      Filter_Order_By: 'Ordenar por',
      Filter_Content: 'Contents',
      Filter_Country: 'Origen Informe',
      Filter_Highlights: 'Destacado',
      Filter_InLive: 'En vivo',
      Filter_Important: 'Importante',
      Filter_Exclusive: 'Exclusivo',
      Filter_Date: 'Fecha',
      Filter_Date_From: 'DE',
      Filter_Date_To: 'HASTA',
      Filter_Media_type: 'Tipo de Medio',
      Filter_Priority: 'Prioridad',
      Filter_Attachment: 'Adjunto',
      Filter_Video: 'Video',
      Filter_Audio: 'Audio',
      Filter_Podcast: 'Podcast',
      Filter_Relevant: 'Importante',
      Clear_Filter: 'Filtro claro',
      To_View: 'Para ver',
      Results: 'resultados',
      Follow_Market: 'Sigue el Mercado',
      Favorite_Content: 'Editar Favoritos',
      Filter_Report_Type: 'Tipo de informe',
      Information_label: 'Información',
      Advanced_Filters: 'Filtros Avanzados',
      Filter_Author: 'Filtrar por autor',
      One_Day: '1 DÍA',
      One_Week: '1 SEMANA',
      One_Month: '1 MÊS',
      Three_Months: '3 MESES',
      Select_Date: 'SELECCIONA UNA FECHA',

    },
    REPORT_ITEM: {
      Updated: 'Actualizado',
      Today: 'Hoy'
    },
    BROWSER_NOT_SUPPORTED: {
      Title: 'ADVERTENCIA',
      Text: 'Para una experiencia única con más rendimiento y seguridad, pruebe nuestra aplicación en otros navegadores. También es posible instalar nuestra aplicación para Windows.',
      Other_Browsers: 'Otros navegadores',
      Windows_Store: 'Windows Store'
    },
    DOWNLOAD_PUBLIC_FILE_EMAIL: {
      Title: 'Descargar archivo',
      Notify_Error_Title: 'Token',
      Notify_Error_Message_Token_Not_Found: 'Token extraviado',
      Notify_Error_Message_Invalid_Token: 'Token Inválido'
    },
    PLAYLIST: {
      Empty_Playlist: 'Tu lista de reproducción está vacía',
      Empty_Playlist_Text: 'Agrega un video a tu lista de reproducción',
      Youtube_Add_Playlist_Text: 'Video agregado a la lista de reproducción',
      Audio_Add_Playlist_Text: 'Audio agregado a la lista de reproducción',
      Item_Add_Playlist_Text: 'Elemento agregado a la lista de reproducción',
      Upcoming_Videos: 'Próximos vídeos',
      Clean: 'LIMPIAR',
      Running: 'En ejecución'
    },
    LOST_ACCESS: {
      Title: 'Acceso perdido',
      ResetText: '¿Cómo prefiere restablecer su acceso?',
      EmailCheckbox: 'By E-mail',
      OtherCheckbox: 'Otra',
      ByEmail_Title: 'Envienos un mensaje',
      Other_Title: 'Contacte nuestro servicio al cliente!',
      Email_field: 'E-mail',
      Phone_field: 'Teléfono',
      Message_field: 'Mensaje',
      Notify_Error_Title: 'Acceso perdido',
      Notify_Error_Message_Error: 'Dirección de correo electrónico no valida',
      Phone_href: 'tel:+34913231858',
      Phone_Text: '+ 34 91 323 18 58',
      Mail_href: 'mailto:soporte@cmaeuropa.com',
      Mail_Text: 'soporte@cmaeuropa.com'
    },
    NEW_CLIENT: {
      Title: '¿Nuevo por aquí?',
      Title2: 'Seguir los movimientos de los mercados agrícolas',
      Title3: 'Ventajas exclusivas de la plataforma SAFRAS',
      Description_1: 'Seguimiento completo de los informes <span> USDA </span>, integrando pronósticos de mercado, noticias agrícolas, alertas, tablas, videos y audios',
      Description_2: 'Datos importantes sobre producción, comercialización, siembra, cosecha y exportación de los principales productos, destacando datos exclusivos de <span> SAFRAS & Mercado </span>',
      Description_3: 'Equipo propio de periodistas con amplia experiencia en cobertura de agronegocios',
      Email_field: 'E-mail',
      Phone_field: 'Teléfono',
      Name_field: 'Nombre',
      Notify_Error_Title: '¿Nuevo por aquí?',
      Notify_Error_Message_Error: 'Por favor verifique si hay errores',
    },
    TOUR_STEPS: {
      ButtonSkip: 'No se muestran',
      ButtonPrevious: 'Anterior',
      ButtonNext: 'Próximo',
      ButtonStop: 'Terminar',
      StepFilterText: `<div>Filtro movido</div>`,
      StepNewHighlightText: `<div class="tour-title">Ahora tenemos lo más destacado de Safras TV!</div> <div class="tour-small">Descubre la "Resenha SAFRAS & Mercado", el nuevo programa semanal que reúne a invitados especiales, de gran influencia en la agroindustria</div>`,
      StepNewCommodityText: `<div>Se ha insertado un nuevo <b>Fertilizante</b> en la plataforma</div>`,
      StepFavoriteText: `<div class="tour-title">Ahora tenemos favoritos!</div> <div class="tour-small">Al pasar el mouse sobre el elemento, se mostrará el ícono que le permite marcar el contenido.</div>`,
      StepPlayTourAgainText: `<div class="tour-title">Dentro de la ventana de ayuda puede iniciar el Tour de la plataforma nuevamente con las últimas noticias</div>`,
    },
    DIALOG_MESSAGES: {
      Title: 'Advertencia',
      UserRightsText: 'Su usuario no tiene acceso a este contenido. Contáctenos para habilitar',
      GetMoreQuestionsText: 'No hay más preguntas disponibles. Contáctenos para aprender más',
      PlatformTourText: '¿Le gustaría comenzar el recorrido y ver las novedades de la plataforma?',
      AcceptText: 'Entrar en contacto',
      CancelText: 'Cerrar',
      StartText: 'Start',
      NotDisplatText: 'No se muestran',
      SentRequestDemo: 'Hemos enviado su solicitud de demostración. Le enviaremos un correo electrónico para más noticias.',
      AccountEditDataText: 'Para editar sus datos, envíe un mensaje a nuestro equipo de atención al cliente.'
    },
    BADGES: {
      Important: 'IMPORTANTE',
      Exclusive: 'EXCLUSIVO',
      InLive: 'AO VIVO',
      Disclosure: 'DIVULGACIÓN',
      Announcement: 'ANUNCIO',
      Invite: 'INVITACIÓN',
    },
    BADGES_MEDIA: {
      Appendix: 'Adjunto',
      Audio: 'Audio',
      Video: 'Video',
      Podcast: 'Podcast'
    },
    REGISTER: {
      Title: 'Crear una cuenta',
      Subtitle: 'Complete el siguiente formulario para crear una nueva cuenta.',
      Field_Email: 'Correo electrónico',
      Field_Email_Again: 'Repite correo electrónico',
      Placeholder_Email: 'Escribir correo electrónico',
      Placeholder_Email_Again: 'Escribir correo electrónico nuevamente',
      Field_Username: 'Nombre',
      Placeholder_Username: 'Escribe un nombre',
      Field_UserType: 'Tipo de usuario',
      Placeholder_UserType: 'Seleccionar tipo de usuario',
      Field_Cnpj: 'CNPJ',
      Placeholder_Cnpj: '00.000.000/0000-00',
      Field_Cpf: 'CPF',
      Placeholder_Cpf: '000.000.000-00',
      Field_Phone: 'Teléfono',
      Placeholder_Phone: '00 00000-0000',
      Field_Password: 'Clave',
      Placeholder_Password: 'Escriba contraseña',
      Confirm_Email_Title: 'Confirmar correo electrónico',
      Confirm_Email_Subtitle: 'Te enviamos el codigo a tu correo',
      Confirm_Email_Field_Code: 'Codigo',
      Confirm_Email_Placeholder_Code: 'Escribe el codigo',
      Confirm_Email_Send_Token: 'Codigo enviado com sucesso',
      UserType_Item_PF: 'Peso físico',
      UserType_Item_PJ: 'Pessoa Jurídica',
      HasAccount: 'Já tem uma conta?',
      Terms_Of_Use: 'Leer Bases y Condiciones',
      Accept_Terms: 'Acepto las condiciones de uso',
      Register: 'Registrar',
      Request_Free: 'Quiero registrarme para acceder solo al contenido gratuito de la plataforma',
      Request_Demo: 'Quiero registrarme y solicitar un periodo demo de 7 días para tener acceso a todo el contenido de la plataforma',
      Success_Register: 'Registrado exitosamente'
    },
    USER_SIGNATURE: {
      Title: 'Firma',
      Contracted_Plan: 'Plan Contratado',
      Signature_Validate: 'Suscripción activa hasta',
      Signature_Option_Agency_Safras_RT: 'Agencia SAFRAS (RT)',
      Signature_Option_Other_Agencies: 'Otras agencias (bajo contrato)',
      Signature_Option_Analisy_Agro_Today: 'Análisis Agro Hoy',
      Signature_Option_Analisy_Agro_Vision: 'Análisis de Visión Agro',
      Signature_Option_Estatistic_Export: 'Estadísticas + Exportar/Importar',
      Signature_Option_Ask_Analyst: 'Pregunte al analista',
      Signature_Option_Safras_Tv: 'SAFRAS TV',
      Signature_Option_Safras_Podcast: 'Podcast de SAFRAS',
      Signature_Option_Courses: 'Cursos',
      Signature_Option_Speechs: 'discursos',
      Signature_Option_Weather: 'Climatizado',
      Signature_Option_Fisical_Market: 'Mercado Físico',
      Signature_Option_Future_Market: 'Mercado Futuro (DT y/o RT)',
      Signature_Option_Indicative: 'Indicadores',
      Signature_Option_Exchange_Market: 'Intercambio (DT)',
      Signature_Option_Lineup_Ships: 'Alineación de barcos',
      Signature_Option_Freight_Calculator: 'Calculadora de flete',
      Signature_Option_Open_Line: 'Línea Abierta (Acceso Directo al Analista)',
      Signature_Option_Monthly_Conference: 'Teleconferencia mensual con el Analista',
      Latest: 'El Último',
      Publications: 'Publicaciones'
    },
    PACKAGES: {
      Title: 'Planos',
      Contracted_Plan: 'Plan Contratado',
      Signature_Validate: 'Suscripción activa hasta',
      I_Want_To_Hire: 'Quiero contratar',
      More_Info: 'Mas informaciones'
    },
    USER_NOTIFICATION: {
      Notification: 'Notificaciones',
      Subtitle: 'Configurar notificaciones de correo electrónico y aplicaciones para cada producto',
      Not_Receive_Email: 'No quiero recibir correos electrónicos',
      Not_Receive_Push: 'No quiero recibir notificaciones en la aplicación',
      Content: 'Contenido',
      Email: 'Correo electrónico',
      Push: 'App',
      All: 'Todos',
      Block_notifications: 'Bloquear notificaciones'
    },
    NEWS_DETAIL: {
      Event: 'Evento',
      Invite: 'Invitación',
      Type: 'Tipo',
      Type_Online: 'Online',
      Type_Presential: 'Presential',
      All_Day: 'Todo el día',
      Start_Date: 'Fecha de inicio',
      Final_Date: 'Fecha final',
      Location: 'Lugar',
      Price: 'Valor',
      Link: 'Link',
      Related_Event: 'Noticias evento',
      Content: 'Content',
      Country: 'Country',
      Report: 'Report',
      Report_Date: 'Report Date',
      Publish_Date: 'Publish Date',
      Updated: 'Updated',
      Private_Content: 'Private content for subscribers only',
      By: 'por',
      Read_More: 'Lea mas en',
      Kind_Event: 'Tipo de Evento',
      Start_Event: 'Comienzo del Evento',
      Event_Details: 'Detalles del Evento',
      Price: 'Valor',
      End_Event: 'Fin del Evento',
      Event_Location: 'Lugar del Evento',
      Open: 'Open',
      Related_News: 'Noticias relacionadas',
    },
    USER_PROFILE: {
      Subscriber: 'Abonado',
      Demo: 'Demostración',
      Free: 'Gratis'
    },
    SIGAWEB_DEMO: {
      Plan_Free_Title: 'Plan Gratis',
      Plan_Demo_Title: 'Plan de demostración',
      Plan_Subscribe_Title: 'Plan de Suscripción',
      Free_Text_First: 'Usted está utilizando un plan de suscripción gratuito.',
      Free_Text_Second: 'Si lo desea, solicite una prueba de la Plataforma Safras completa, con acceso a todos los contenidos y funcionalidades.',
      Free_Text_Third: 'Para conocer los demás planes de suscripción, entre en contacto con nosotros por medio del e-mail: <a href="mailto:prevendas@cma.com.br?Subject=Contato" target="_top">prevendas@cma.com.br</a> o por teléfono/WhatsApp: <a href="https://wa.me/5511939478908?text=Olá%2C%20gostaria%20de%20sabe%20as%20condições%20para%20continuar%20acessando%20a%20Plataforma%20SAFRAS" target="_blank">(11) 93947-8908</a>',
      Free_Text_Email: 'prevendas@cma.com.br',
      Free_Text_Click_Here: 'Solicitar demostración',
      Request_Demo: 'Solicitar demostración',
      Signature_Valid_Until: 'Firma válida hasta',
      Signature_Active: 'Suscripción activa',
      Dialog_Title: 'Aviso',
      Field_Empty: 'no encontrado.',
      Field_Invalid_Format: 'con formato inválido.',
      User_Exist: 'Ya hay un contrato activo en nuestro sistema..',
      User_Demo_Exist: 'Ya hay una demostración activa en nuestro sistema.',
      Contact: '\n\nSi el error persiste, contáctenos para obtener más información.',
      SentRequest: 'Recibimos su solicitud de prueba de la Plataforma Safras. Enviaremos la información para el acceso en su e-mail registrado.',
      Attendance_Message: 'Hola, necesito ayuda con la demostración.',
      Demo_Request: 'Solitud de demostración',
      Update_Phone_Title: 'Actualiza tu número de teléfono',
      Update_Phone_Text: 'Ingrese su número de teléfono para que podamos actualizar nuestro sistema.',
      Update: 'Actualizar'
    },
    AUTHOR_DETAIL: {
      Publication: 'Publicaciones',
      Total: 'Total',
      Today: 'Hoy',
      Last_Sent: 'Último enviado'
    },
    DISPLAY_TYPES: {
      List: 'Lista',
      Card: 'Card',
      Mosaic: 'Mosaico',
      Tag: 'Etiqueta',
      Calendar: 'Calendar',
      Schedule: 'Agenda',
      Playlist: 'Playlist'
    },
    ACCESSIBILITY: {
      Accessibility: 'Accesibilidad',
      Normal: 'Normal',
      To_Hear: 'Escuchar',
      Pause_reading: 'Pausar la lectura',
      Appendix: 'Adjunto'
    },
    HIGHLIGHTS: {
      Highlights: 'DESTAQUES',
      Exclusive_Content: 'Contenido Exclusivo',
    },
    MULTIMEDIA: {
      Details: 'Ver detalles',
      Play: 'Reproducir',
      Add_Playlist: 'Agregar a la lista de reproducción'
    },
    VIEW_MODES: {
      By: '',
      In: ''
    },
    LOGOUT: {
      Title: 'sesión cerrada',
      Message: 'Su sesión ha sido cancelada debido al acceso simultáneo.'
    },
    TICKER: {
      View: 'Para ver:',
      Important: 'Importante',
      Highlights: 'Resalta',
      View_At_Top: 'Ver en la parte superior',
      View_In_Footer: 'Ver en pie de página',
    },
    PRIVATE_CONTENT: {
      Register: '¡Regístrese ahora!',
      Exclusive_Subscribers: '¡Alcance el éxito en el agro negocio con la Plataforma SAFRAS!',
      Sign_Up_access: 'Usted puede registrarse gratuitamente para tener acceso a recursos y contenidos exclusivos o solicitar una demostración del servicio completo.',
      Smart_Content_Title: 'Descubre el poder de la Plataforma SAFRAS',
      Smart_Content_L1: 'Identifica oportunidades rentables y aumenta tu potencial competitivo en el agro negocio.',
      Smart_Content_L2: 'Invierte con precisión, seguridad y protección en productos agrícolas.',
      Smart_Content_L3: 'Toma decisiones estratégicas con análisis exclusivos de la Plataforma SAFRAS.',
      Smart_Content_L4: 'Mantente actualizado con noticias, pronósticos climáticos y paridades de precios a nivel global.',
      Smart_Content_L5: 'Maximiza tus resultados con protección y acceso a estadísticas completas.',
      Alert_Footer: 'El acceso gratuito a la Plataforma Safras y el período de demostración gratuito tiene como objetivo ofrecer una muestra de que la Plataforma Safras puede proporcionar a sus negocios e inversiones. Si desea el acceso ilimitado a todos los recursos y contenidos exclusivos del servicio, conozca los diferentes planes de suscripción para hacer parte de nuestra comunidad de clientes.'
    },
    PRIVATE_CONTENTUSERDEMO: {
      Register: 'Conoce los Planes de Suscripción',
      Attendance: 'Asistencia',
      IOS_Text: 'Si te interesa este tipo de contenido, solicita liberación',
      Exclusive_Subscribers: '¡Estás en el período de demostración de la Plataforma SAFRAS!',
      Sign_Up_access: 'Esta información no está disponible durante el período de demostración, pero está disponible para los suscriptores del servicio. Conoce los diferentes planes de suscripción para formar parte de nuestra comunidad de clientes y poder explorar, aprender y aprovechar al máximo todo lo que tenemos para ofrecer.',
      Smart_Content_Title: 'Descubre el poder de la Plataforma SAFRAS',
      Smart_Content_L1: 'Identifica oportunidades rentables y aumenta tu potencial competitivo en el agro negocio.',
      Smart_Content_L2: 'Invierte con precisión, seguridad y protección en productos agrícolas.',
      Smart_Content_L3: 'Toma decisiones estratégicas con análisis exclusivos de la Plataforma SAFRAS.',
      Smart_Content_L4: 'Mantente actualizado con noticias, pronósticos climáticos y paridades de precios a nivel global.',
      Smart_Content_L5: 'Maximiza tus resultados con protección y acceso a estadísticas completas.',
      Alert_Footer: 'O período de demonstração gratuita tem como objetivo oferecer uma amostra do que a Plataforma Safras pode proporcionar aos seus negócios e investimentos. Caso deseje acesso ilimitado a todos os recursos e conteúdos exclusivos do serviço, conheça os diferentes planos de assinatura para fazer parte de nossa comunidade de clientes.'
    },
    PRIVATE_CONTENTUSERSUBSCRIBER: {
      Register: 'Conoce los Planes de Suscripción',
      Exclusive_Subscribers: '¡Felicitaciones, ya eres suscriptor de la Plataforma SAFRAS!',
      Sign_Up_access: 'Sin embargo, tu plan actual no incluye esta información a la que estás tratando de acceder. Conoce otros planes de suscripción para tener acceso a más información estratégica y recursos que te ayudarán a mejorar tus resultados comerciales e inversiones.',
      Smart_Content_Title: 'Descubre el poder de la Plataforma SAFRAS',
      Smart_Content_L1: 'Identifica oportunidades rentables y aumenta tu potencial competitivo en el agro negocio.',
      Smart_Content_L2: 'Invierte con precisión, seguridad y protección en productos agrícolas.',
      Smart_Content_L3: 'Toma decisiones estratégicas con análisis exclusivos de la Plataforma SAFRAS.',
      Smart_Content_L4: 'Mantente actualizado con noticias, pronósticos climáticos y paridades de precios a nivel global.',
      Smart_Content_L5: 'Maximiza tus resultados con protección y acceso a estadísticas completas.',
    },
    TOAST_NOTIFICATIONS: {
      // Validação de token
      invalidToken: 'Código inválido',
      expiredToken: 'Código expirado',
      // Login
      userNotFound: 'Usuario no encontrado',
      insufficientRights: 'El usuario no tiene derechos para acceder al sistema. Póngase en contacto con nuestro equipo de Atención al Cliente a través del correo electrónico atendimento@cma.com.br.',
      disabledUser: 'Usuario deshabilitado',
      invalidCredentials: 'Usuario o contraseña inválidos',
      // Login via S4
      unauthorized: 'No autorizado',
      disabledS4User: 'Usuario deshabilitado',
      // Esqueci a senha
      emailNotFound: 'Correo electrónico no encontrado',
      disabledUserForgotPassword: 'Usuario deshabilitado',
      emailNotFoundSystem: 'El correo electrónico no encontrado. Póngase en contacto con nuestro equipo de Atención al Cliente a través del correo electrónico atendimento@cma.com.br.',
      // Reset de senha
      invalidConfirmPassword: 'Confirmación de contraseña inválida',
      expiredResetToken: 'Token expirado',
      invalidResetToken: 'Token inválido',
      // Troca de senha
      invalidCurrentPassword: 'Contraseña actual inválida',
      newPasswordMismatch: 'La nueva contraseña y la confirmación deben coincidir',
      newPasswordSameAsCurrent: 'La nueva contraseña no puede ser igual a la contraseña actual',
      // Cadastro
      invalidCPF: 'CPF inválido',
      invalidCNPJ: 'CNPJ inválido',
      cpfAlreadyRegistered: 'CPF ya registrado',
      cnpjAlreadyRegistered: 'CNPJ ya registrado',
      emailAlreadyRegistered: 'Correo electrónico ya registrado. Intente acceder al sistema o comuníquese con nuestro equipo de Atención al Cliente a través del correo electrónico atendimento@cma.com.br.',
      emailAlreadyRegisteredSystem: 'Este e-mail ya se encuentra registrado en nuestro sistema. Utilícelo para acceder a la Plataforma Safras.',
      // Leitura de PDF
      documentNotFound: 'Documento no encontrado',
      // Download público de PDF
      invalidCode: 'Código inválido',
      documentNotFoundPublic: 'Documento no encontrado',
      expiredTokenPublic: 'Token expirado',
      nonExistentEmail: 'Correo electrónico inexistente',
      nonExistentReportId: 'ID de informe inexistente',
      userNotFoundPublic: 'Usuario no encontrado',
      disabledUserPublic: 'Usuario deshabilitado',
      // Removendo DeviceID no logout
      deviceIdNotFound: 'ID de dispositivo no encontrado',
      // TMN Quotes
      displayCannotLoadSystemTitle: 'Error al cargar el sistema',
      displayCannotLoadSystemMessage: 'Falta de comunicación. Actualice la página o comuníquese con nuestro equipo de Atención al Cliente a través del correo electrónico atendimento@cma.com.br.',
      displayNotAuthorizedTitle: 'Error',
      displayNotAuthorizedMessage: 'Falta de comunicación. Actualice la página o comuníquese con nuestro equipo de Atención al Cliente a través del correo electrónico atendimento@cma.com.br.',
      messagesNotifyHelperTitle: 'Error',
      messagesNotifyHelperMessage: 'Falta de comunicación. Actualice la página o comuníquese con nuestro equipo de Atención al Cliente a través del correo electrónico atendimento@cma.com.br.',
      // Ask The Analyst
      askAnalystTitle: 'Preguntar al Analista',
      askAnalystSuccess: 'Pregunta enviada al analista con éxito',
      // REGISTER
      registerRequestDemoTitle: 'Demostración',
      registerRequestDemoMessage: 'Una vez completado el registro, procesaremos su solicitud de demostración. Le enviaremos un correo electrónico para obtener más información.',
      // Packages
      packRequestDemoTitle: 'Demostración',
      packRequestDemoMessage: 'Pedido enviado exitosamente.',
      userPhoneNotFound: 'Telefono no encontrado',

      // TMN HELPER
      checkNotifyErrorTitle: 'Error',
      checkNotifyErrorsMessage: 'Falta de comunicación. Actualice la página o comuníquese con nuestro equipo de Atención al Cliente a través del correo electrónico atendimento@cma.com.br.',
      // CHECK USER INFO
      checkUserInfoTitle: 'Usuario',
      checkUserInfoMessage: 'Usuario deshabilitado.',
      // INTERNAL SERVER ERROR
      internalServerErrorTitle: 'Error 503',
      internalServerErrorMessage: 'El sistema no está disponible actualmente, inténtalo de nuevo en unos momentos.',
      userCannotDelete: 'La cuenta con suscripción activa no se puede eliminar.',
    },
    WDMA: {
      Error_System_Title: 'No se puede cargar el sistema.',
      Error_System_Subtitle: 'Vuelva a intentarlo más tarde...',
      Error_System_Button_Update: 'Actualizar',
      Error_System_Button_Attendance: 'Entrar en contacto',
      Error_Session_Close: 'Hemos identificado que otra estación se ha conectado',
      Error_System_Title_Session_Close: 'Se ha desconectado.',
      Error_System_Button_Connect: 'Conectar',
      Error_Title_Max_Simultaneous_Connections: 'Alcanzaste el número máximo de conexiones simultáneas permitidas',
      Error_Max_Simultaneous_Connections: 'Cerrá una conexión anterior para permitir el nuevo acceso',
      Error_Title_Invalid_Credentials: 'Acceso denegado',
      Error_Invalid_Credentials: 'Verifique sus credenciales o contacte con su administrador',
    },
    DELETE_ACCOUNT: {
      Delete_Account_Button: 'Solicitud de Eliminación de Datos Personales',
      Title: 'AVISO',
      First_Question: `La solicitud de eliminación de datos personales de nuestras bases de datos es un derecho garantizado por la Ley General de Protección de Datos Personales.
      \n Sin embargo, sin esta información, no podremos identificar sus accesos.
      \n Por lo tanto, si continúa con esta solicitud, tan pronto como se procese su solicitud, se bloqueará su acceso a la Plataforma Safras y no podrá volver a acceder hasta que se vuelva a registrar.
      \n Si tiene un contrato vigente para el uso de la Plataforma Safras, registrar la solicitud de eliminación de sus datos personales no lo eximirá de cumplir con las condiciones acordadas de terminación del contrato y su solicitud solo tendrá efecto después de recibir el contacto de nuestro área comercial que le atenderá sobre los pasos de este proceso de baja.
      \n Si tiene o ha tenido un contrato para el uso de productos vendidos por esta empresa, sus datos personales serán eliminados de la Plataforma Safras pero podrán conservarse en los sistemas internos de la empresa mientras sean necesarios para cumplir con las obligaciones legales a las que la empresa está sujeta.
      \n ¿De verdad quieres continuar?`,
      First_Question_Button_Decline: 'Rendirse',
      First_Question_Button_Continue: 'Solicitud de registro',
      First_Question_Success_Title: 'Éxito',
      First_Question_Success_Text: `Su solicitud para eliminar sus datos personales ha sido recibida y está siendo procesada.
      \n Su sesión está siendo terminada.
      \n Si desea reanudar su acceso a la Plataforma Safras, realice un nuevo registro.`,
      Cannot_Delete_Text: `Su solicitud para eliminar sus datos personales ha sido recibida y está siendo procesada.
      \n Espere el contacto de nuestra área comercial que revisará con usted las condiciones de su contrato actual.`
    },
    SCHEDULE: {
      Empty_Schedule: 'Tu calendario está vacío',
      Empty_Schedule_Text: 'Añade eventos a tu calendario.',
      Clean: 'LIMPIAR',
      Today: 'Hoy',
      Month: 'Mes',
      Week: 'Semana',
      Day: 'Día',
      List: 'Lista'
    },
    BIOMETRY: {
      Cancel: "Cancelar",
      Activate: "Activar",
      Use_Pin: "Usar PIN",
      Show_Fingerprint_Desc: "Reconocimiento biométrico para acceder a su",
      Register_Biometric_Secret_Desc: "Reconocimiento biométrico",
      Biometry_Confirm_Activate_Text: "¿Desea activar la biometría ahora para accesos rápidos y seguros?",
      Biometry_Confirm_Title: "Inicio de sesión"
    }
  },
  EsAr: {
    BOOLEAN: {
      Yes: 'Sí',
      No: 'No'
    },
    USER: {
      Details: 'Detalles',
      Email: 'E-mail:',
      Name: 'Nombre:',
      Profile: 'Planes:',
      Document: 'Documento:',
      Phone: 'Teléfono:',
      Country: 'País:',
    },
    BUTTONS: {
      Save: 'Salvar',
      Cancel: 'Cancelar',
      Back: 'Atrás',
      Send: 'Enviar',
      Enter: 'Entrar',
      AccessAccount: 'Acceder a tu cuenta',
      Register: 'Registro',
      BackLogin: 'Atrás para iniciar sesión',
      RecoverButton: 'Contraseña de recuperación',
      DownloadFile: 'Descargar archivo',
      BackHomePage: 'Volver a la página de inicio',
      MoreQuestion: 'Más preguntas',
      RecoveryPassword: 'Recovery Password',
      TestTrial: 'Prueba gratuita de 7 días',
      Save_Announcement: 'Guardar anuncio',
      Edit_Data: 'Editar datos',
      Remove: 'Eliminar'
    },
    GENERAL: {
      Home: 'Hogar',
      Edit: 'Editar',
      Delete: 'Borrar',
      Update: 'Actualizar',
      Create: 'Crear',
      Error: 'Error',
      Atention: 'Atención',
      Send: 'Mandar',
      Cma_Url: 'https://www.cma.com.br/esp/home-2/',
      Safras_Url: 'https://safras.com.br/es/home-espanhol/',
      Safras_Url_Request: 'https://pagina.safras.com.br/esp-mercado-agropecuario',
      Error_Download_File: 'No se pudo descargar el archivo',
      Copy_Data: 'Copiar datos'
    },
    LOGIN: {
      Title: 'Entrar',
      User: 'E-mail',
      Password: 'Contraseña',
      Remember: 'Recuerda',
      ForgotPass: 'Contraseña olvidada?',
      Enter: 'Entrar',
      Register: 'Registro',
      Code: 'código',
      New_Here: '¿Nuevo aquí?',
      Lost_Acess: 'Dificultad con el acceso?',
      Know_More: 'Sepa Mas',
      Click_Here: 'Haga clic aquí',
      Resend_Token: 'para reenviar el codigo',
      Notify_Error_Title: 'Entrar',
      Notify_Error_Message: 'Por favor revise los campos de contraseña.',
      New_Here_Link: 'https://www.cma.com.br/esp/plataforma-safras-espanol/',
      Two_Factor_Auth_Title: "Dupla autenticação",
      Two_Factor_Auth_Desc: "Enviamos para seu e-mail um código para autenticação. ",
      Two_Factor_Auth_Code: "Codigo",
      Two_Factor_Auth_Code_Placeholder: "Digite o Codigo",
      Confirm_Email_Title: "Confirmação de e-mail",
      Confirm_Email_Desc: "Su registro para acceder a la demostración de la Plataforma Safras aún no se ha completado. Debes registrar el token enviado por Safras & Mercado a tu dirección de correo electrónico en la pantalla de registro.",
      Confirm_Email_Desc_Token_Val: "Tiempo de vencimiento del token: hasta 2 horas.",
      Confirm_Email_Desc_Sec: "¿No recibiste el correo electrónico?",
      Confirm_Email_Field_Code: 'Codigo',
      Confirm_Email_Placeholder_Code: 'Digite o codigo',
      Confirm_Email_Send_Token: 'Codigo enviado com sucesso',
      Notify_Accept_Terms: 'Usted debe aceptar las Bases y Condiciones para finalizar el registro.',
      Footer_CMA: 'está protegido por reCaptcha y está sujeto a su',
      Click_Back: 'HAGA CLIC PARA VOLVER',
      Text_Market: 'Safras & Mercado: todo sobre agronegocios en un solo lugar'
    },
    LOGINS4: {
      Error_Message_Title: 'Hay un problema.',
      Error_Message_Content: 'Inténtelo de nuevo en un momento y, si el problema persiste, comuníquese con nuestro centro de atención al cliente.',
      Error_Message_Content_Other_Login: 'Prezado usuário, sua sessão expirou. Por favor, feche este módulo e abra novamente.',
    },
    MENU: {
      Home: 'Home',
      AllSubjects: 'All Subjects',
      Subjects: 'Subjects',
      AllCommodities: 'Todos los Commodities',
      Commodities: 'Commodities',
      DisabledItems: 'Suscríbase ahora',
      MoreCommodities: 'Más Commodities',
      NoRights: 'Sin derechos'
    },
    TABLE: {
      Column_ID: 'ID',
      Column_DT_Insert: 'Insert Date',
      Column_DT_Change: 'Change Date',
    },
    MESSAGES: {
      Messages_Created: 'Registro creado',
      Messages_Updated: 'Registro actualizado',
      Messages_Deleted: 'Registro eliminado',
      Messages_Generic_Error: 'Error al ejecutar la operación',
    },
    NAVBAR_DROPDOWN_MENU: {
      Profile: 'Perfil',
      Change_Password: 'Cambiar Contraseña',
      Ask_To_Analyst: 'Preguntar al analista',
      Dark_Theme: 'Tema Oscuro',
      Light_Theme: 'Tema Claro',
      Biometry: 'Biometria',
      Language: 'Idioma',
      Logout: 'Salir',
      Privacy_Policy: 'Política de privacidad',
      Notification: 'Notificación',
      Signatures: 'Firmas',
      Packages: 'Pacotes',
      My_Account: 'Mi cuenta',
      Info_Account: 'Detalle de la cuenta',
      Platform_Config: 'Configuración de plataforma',
      Font_Size: 'Tamano del texto',
      Font_Align: 'Alineación de la imagen',
      Font_Compact: 'Compacto',
      Font_Default: 'Defecto',
      Font_Big: 'Grande',
      Appearance: 'Apariencia',
      View_Type_List: 'Lista',
      View_Type_Card: 'Tarjeta',
      About: 'Sobre',
      Help: 'Ayuda',
      Show_Ticker: 'Mostrar ticker',
      Hide_Ticker: 'Ocultar ticker',
      Quotes_Config: 'Apoyo'
    },
    CHANGE_PASSWORD: {
      Title: 'Contraseña',
      Field_Email: 'E-mail',
      Field_Current_Password: 'Contraseña actual',
      Field_New_Password: 'Nueva contraseña',
      Field_New_Password_Repeat: 'Repite la contraseña',
      Notify_Success_Title: 'Cambia la contraseña',
      Notify_Success_Message: 'Contraseña actualizada exitosamente',
      Quit_all_apps: 'Cerrar sesión en todos los dispositivos',
      Remember_Password: "¿No recuerdas tu contraseña actual?",
      Click_Retrieve: 'Haga clic aquí para recuperar',
      Update_Password: 'Actualiza tu contraseña',
      Enter_Current_Password: 'Para actualizar su contraseña, debe ingresar la actual.'
    },
    RESET_PASSWORD: {
      ResetTitle: 'Cambia la contraseña',
      ResetDesc: 'Por favor ingrese su nueva contraseña',
      ResetPass: 'Nueva contraseña',
      ResetConfirm: 'Repita la nueva contraseña',
      Reset_Confirm: 'repetir',
      InvalidToken: 'Codigo no valido',
      Notify_Title: 'Cambia la contraseña',
      Notify_Error_Message: 'Por favor revise los campos de contraseña.',
      PasswordChanged: 'Cambia la contraseña',
      PasswordChangedDesc: 'Su contraseña se ha actualizado correctamente',
    },
    FORGOT_PASSWORD: {
      RecoverTitle: 'Recupere su contraseña',
      RecoverDesc: 'Ingrese su dirección de correo electrónico y le enviaremos instrucciones para recuperar su contraseña.',
      Field_Email: 'E-mail',
      EmailSent: 'E-mail enviado',
      CheckEmail: 'Se te ha enviado un correo electrónico. Por favor revise su bandeja de entrada',
      Notify_Success_Title: 'Contraseña',
      Notify_Success_Message: 'Por favor revise su correo electrónico',
      Notify_Error_Title: 'Recuperación de contraseña',
      Notify_Error_Message: 'Dirección de correo electrónico no válida'
    },
    ASK_THE_ANALYST: {
      Title: 'Preguntar al Analista',
      TitleHedge: 'Cotizar con la mesa',
      Field_Email: 'E-mail',
      Field_Name: 'Nombre',
      Field_Question: 'Pregunta',
      Field_Commodity: 'Commodity',
      Remaining_Questions: 'Preguntas restantes disponibles: '
    },
    MY_ACCOUNT: {
      Title: 'Perfil',
      Field_Email: 'E-mail',
      Field_Name: 'Nombre',
      Field_CnpjCpf: 'Document',
      Field_Phone: 'Phone',
      Field_Groups: 'Grupos',
      Field_Language: 'Lenguaje de la plataforma',
      Text_Language: 'Este parámetro cambia solo el idioma de la plataforma. Para cambiar el contenido, comuníquese con el centro de atención al cliente.',
      Field_Country: 'País',
      Title_Receive_Email: 'Reciba por correo electrónico',
      Title_Notification: 'Notificações',
      Field_Option_All: 'Todos',
      Notify_Success_Title: 'Perfil',
      Notify_Success_Message: 'Datos actualizados exitosamente',
      Help_Language: 'Requerido para recibir correo electrónico en el idioma elegido'
    },
    ERROR_404: {
      Title: 'Ops, página no encontrada',
      Message: 'Lo sentimos, esta página no fue encontrada'
    },
    FOOTER: {
      Help: 'Ayuda'
    },
    HELP: {
      Tab_About: 'Sobre',
      Tab_Attendance: 'Asistencia',
      Tab_Version: 'Versión',
      Tab_LGPD: 'LGPD',
      Tab_PrivacyPolicy: 'Política de privacidad',
      Tab_Tour: 'Tour',
      Tab_Terms: 'Terminos de uso',
      Tab_Quotes_Config: 'Apoyo'
    },
    HELP_ABOUT: {
      Cma_Title: 'Sobre CMA',
      Cma_Text: 'CMA Consultoria, Métodos, Assessoria e Mercantil S/A es una empresa multinacional brasileña que desde 1973 se dedica al desarrollo de soluciones de alta tecnología aplicadas a los mercados financieros y de productos básicos, educación, telecomunicaciones y centros de datos. La compañía tiene su sede y 9 sucursales en Brasil, además de sucursales en los Estados Unidos, América Latina y Europa, con clientes en 35 países.',
      Safras_Title: 'Sobre SAFRAS & Mercados',
      Safras_Text: 'SAFRAS & Mercado es la principal consultora brasileña de agronegocios. Monitorea diariamente los mercados de soya, maíz, algodón, café, azúcar y alcohol, carne de res, pollo, cerdo, arroz, frijoles y bioenergía, ofreciendo diferentes niveles de servicios que ayudan a la toma de decisiones de los participantes de diferentes sectores agrícolas. SAFRAS tiene la base de datos histórica más completa de la agroindustria brasileña, es una referencia internacional en proyecciones y escenarios agrícolas.',
      Know_More: 'Obtenga más información en',
      Visit_Website: 'Visite el sitio web en:'
    },
    HELP_ATTENDANCE: {
      Title: 'Asistencia',
      Contact_Text: '¡Contáctenos y nos pondremos en contacto con usted pronto!',
      Phone: 'Teléfono:',
      Email: 'E-mail:',
      Whatsapp: 'WhatsApp:',
      Form_Text: 'Envíe un mensaje usando el formulario a continuación.',
      Form_Field_Message: 'Mensaje',
      Notify_Success_Title: 'Asistencia',
      Notify_Success_Message: 'Mensaje enviado con éxito',
      Phone_href: '',
      Phone_Text: '',
      Whatsapp_href: 'href="https://wa.me/551130532600" target="_blank"',
      Whatsapp_Text: '(11) 3053-2600',
      Mail_href: 'mailto:international.support@cma.com.br',
      Mail_Text: 'international.support@cma.com.br',
      NoRights_Text_Commodity: 'Me gustaría habilitar el acceso a contenido básico %.',
      NoRights_Text_Content: 'Me gustaría habilitar el acceso al % de contenido de productos básicos #.',
      NoRights_Text_GetMoreQuestions: 'Me gustaría habilitar más preguntas para los analistas.',
      Edit_Account_Data: 'Me gustaría editar mis datos',
    },
    HELP_VERSION: {
      Title: 'Versión',
      Item_Version: 'Versión',
      Item_Browser: 'Navegador',
      Item_System: 'Sistema',
      Item_Resolution: 'Resolución',
      Item_Status: 'Estado',
    },
    HELP_LGPD: {
      Accept_Cookies: 'Aceptar',
      Reject_Cookies: 'Rechazar',
      Privacy_Policy: 'Ler Política de Privacidad',
      Cookies_Notice: 'Nuestro sitio web utiliza cookies para brindarle contenido personalizado y para el análisis del sitio. ¡Le recomendamos que acepte, para una mejor navegación en la página!',
      LGPD_Title: 'Lei Geral de Proteção de Dados Pessoais (LGPD)',
      LGPD_Text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged."
    },
    HELP_PRIVACY_POLICY: {
      Privacy_Policy: 'Política de Privacidade',
      Title: 'Política de Privacidade e Confidencialidade da Informação'
    },
     HELP_SUPPORT: {
      Follow_Market: 'Sigue el Mercado',
      Restore_Layout: "Restaurar diseño predeterminado",
      Clear_Local_Data: "Borrar datos locales",
      Detailed_Info: "Información detallada",
      Layout_History: "Historial de diseño",
      Created: 'Creado',
      Updated: "Actualizado",
      Copy_Info_Success: "Los datos se han copiado al portapapeles.",
      Clear_Local_Data_Dialog_Title: "Borrar datos",
      Clear_Local_Data_Dialog_Message: "¿Desea borrar los datos de 'acompañar el mercado'?",
      Restore_Layout_Dialog_Title: "Restaurar diseño predeterminado",
      Restore_Layout_Dialog_Message: "¿Desea restaurar el diseño de 'acompañar el mercado' al predeterminado? La página se actualizará y será necesario iniciar sesión nuevamente.",
      Update_Layout_History_Dialog_Title: "Restaurar historial de diseño",
      Update_Layout_History_Dialog_Message: "¿Desea restaurar su diseño del día",
      Detailed_Info_No_Data: 'No hay datos por el momento'
    },
    TERMS_USE: {
      Title: 'Terminos de uso',
      Text: '<p class="mt-3 mb-3">Todo el contenido disponible en la Plataforma Safras está protegido por la Ley de Derechos de Autor y para uso exclusivo de sus suscriptores. Por ello, queda prohibida la reproducción o distribución del contenido, total o parcialmente, sin la previa y expresa autorización de CMA. El incumplimiento de esta prohibición dará lugar a sanciones civiles y penales.</p><p class="mt-3 mb-3">La información proporcionada en la Plataforma Safras refleja exclusivamente investigaciones e investigaciones realizadas por profesionales de Safras & Mercado. Consiste en información disponible al público y que se cree confiable al momento de la publicación.</p><p class="mt-3 mb-3">Este contenido está sujeto a cambios y se basa en la libertad de expresión. Por tanto, tiene carácter meramente informativo, no constituyendo ofertas ni recomendaciones para la negociación de valores, ya sean valores, materias primas y/u otros instrumentos financieros o económicos.</p><p class="mt-3 mb-3"> El La información contenida en la Plataforma Safras tiene como objetivo fomentar el debate y la educación sobre economía y agronegocios para sus suscriptores. De esta forma, los suscriptores deberán desarrollar sus propios diagnósticos de mercado para la toma de decisiones sobre la gestión de sus negocios y/o inversiones, eximiendo, salvaguardando y protegiendo integralmente a CMA de las consecuencias de dichas decisiones e, incluso, de cualesquiera pérdidas, daños y perjuicios económicos. , durante y después del final del período del plan de suscripción.</p>',
      Text_Mobile: '<p class="mt-3 mb-3">Todo el contenido disponible en la Plataforma Safras está protegido por la Ley de Derechos de Autor y para uso exclusivo de sus suscriptores. Por ello, queda prohibida la reproducción o distribución del contenido, total o parcialmente, sin la previa y expresa autorización de CMA. El incumplimiento de esta prohibición dará lugar a sanciones civiles y penales.</p><p class="mt-3 mb-3">La información proporcionada en la Plataforma Safras refleja exclusivamente investigaciones e investigaciones realizadas por profesionales de Safras & Mercado. Consiste en información disponible al público y que se cree confiable al momento de la publicación.</p><p class="mt-3 mb-3">Este contenido está sujeto a cambios y se basa en la libertad de expresión. Por tanto, tiene carácter meramente informativo, no constituyendo ofertas ni recomendaciones para la negociación de valores, ya sean valores, materias primas y/u otros instrumentos financieros o económicos.</p><p class="mt-3 mb-3"> El La información contenida en la Plataforma Safras tiene como objetivo fomentar el debate y la educación sobre economía y agronegocios para sus suscriptores. De esta forma, los suscriptores deberán desarrollar sus propios diagnósticos de mercado para la toma de decisiones sobre la gestión de sus negocios y/o inversiones, eximiendo, salvaguardando y protegiendo integralmente a CMA de las consecuencias de dichas decisiones e, incluso, de cualesquiera pérdidas, daños y perjuicios económicos. , durante y después de la período de uso del sistema.</p>',
      Read_Accepted: 'He leído y acepto',
      Cancel: 'Cancelar'
    },
    REPORT: {
      No_Report_Found: 'No se encontró informe',
      No_Report_Found_Text: "Puede rehacer la búsqueda para encontrar lo que está buscando.",
      No_Report_Found_Text_Demo: "Para obtener más resultados y contenidos exclusivos, regístrese o acceda a nuestra plataforma.",
      Load_More: 'Carga más...',
      Download_Spreadsheet: 'Descarga de hoja de cálculo',
      Download_Spreadsheet_Text: 'Haga clic para descargar la hoja de cálculo',
      Hear_Text: 'Escuchar el Texto',
      All_Commodities: 'Todos los Commodities',
      View_More: 'Ver más'
    },
    REPORT_FILTER: {
      Informative_Title: 'Informativo',
      Informative: 'Análisis e Informativos',
      Search: 'Buscar',
      Filters: 'Pesquisar',
      Filter_Periodicity: 'Frecuencia',
      Filter_Publication_Type: 'Tipo de contenido',
      Filter_Subject: 'Ordenar por',
      Filter_Order_By: 'Order by',
      Filter_Content: 'Contents',
      Filter_Country: 'Origen Informe',
      Filter_Highlights: 'Destacado',
      Filter_InLive: 'En vivo',
      Filter_Important: 'Importante',
      Filter_Exclusive: 'Exclusivo',
      Filter_Date: 'Fecha',
      Filter_Date_From: 'DE',
      Filter_Date_To: 'HASTA',
      Filter_Media_type: 'Tipo de Medio',
      Filter_Priority: 'Prioridad',
      Filter_Attachment: 'Adjunto',
      Filter_Video: 'Video',
      Filter_Audio: 'Audio',
      Filter_Podcast: 'Podcast',
      Filter_Relevant: 'Importante',
      Clear_Filter: 'Filtro claro',
      To_View: 'Para ver',
      Results: 'resultados',
      Follow_Market: 'Sigue el Mercado',
      Favorite_Content: 'Editar Favoritos',
      Filter_Report_Type: 'Tipo de informe',
      Information_label: 'Información',
      Advanced_Filters: 'Filtros Avanzados',
      Filter_Author: 'Filtrar por autor',
      One_Day: '1 DÍA',
      One_Week: '1 SEMANA',
      One_Month: '1 MÊS',
      Three_Months: '3 MESES',
      Select_Date: 'SELECCIONA UNA FECHA'
    },
    REPORT_ITEM: {
      Updated: 'Actualizado',
      Today: 'Hoy'
    },
    BROWSER_NOT_SUPPORTED: {
      Title: 'ADVERTENCIA',
      Text: 'Para una experiencia única con más rendimiento y seguridad, pruebe nuestra aplicación en otros navegadores. También es posible instalar nuestra aplicación para Windows.',
      Other_Browsers: 'Otros navegadores',
      Windows_Store: 'Windows Store'
    },
    DOWNLOAD_PUBLIC_FILE_EMAIL: {
      Title: 'Descargar archivo',
      Notify_Error_Title: 'Token',
      Notify_Error_Message_Token_Not_Found: 'Token extraviado',
      Notify_Error_Message_Invalid_Token: 'Token Inválido'
    },
    PLAYLIST: {
      Empty_Playlist: 'Tu lista de reproducción está vacía',
      Empty_Playlist_Text: 'Agrega un video a tu lista de reproducción',
      Youtube_Add_Playlist_Text: 'Video agregado a la lista de reproducción',
      Audio_Add_Playlist_Text: 'Audio agregado a la lista de reproducción',
      Item_Add_Playlist_Text: 'Elemento agregado a la lista de reproducción',
      Upcoming_Videos: 'Próximos vídeos',
      Clean: 'LIMPIAR',
      Running: 'En ejecución'
    },
    LOST_ACCESS: {
      Title: 'Acceso perdido',
      ResetText: '¿Cómo prefiere restablecer su acceso?',
      EmailCheckbox: 'By E-mail',
      OtherCheckbox: 'Otra',
      ByEmail_Title: 'Envienos un mensaje',
      Other_Title: 'Contacte nuestro servicio al cliente!',
      Email_field: 'E-mail',
      Phone_field: 'Teléfono',
      Message_field: 'Mensaje',
      Notify_Error_Title: 'Acceso perdido',
      Notify_Error_Message_Error: 'Por favor verifique si hay errores',
      Phone_href: 'tel:+34913231858',
      Phone_Text: '+ 34 91 323 18 58',
      Mail_href: 'mailto:soporte@cmaeuropa.com',
      Mail_Text: 'soporte@cmaeuropa.com'
    },
    NEW_CLIENT: {
      Title: '¿Nuevo por aquí?',
      Title2: 'Seguir los movimientos de los mercados agrícolas',
      Title3: 'Ventajas exclusivas de la plataforma SAFRAS',
      Description_1: 'Seguimiento completo de los informes <span> USDA </span>, integrando pronósticos de mercado, noticias agrícolas, alertas, tablas, videos y audios',
      Description_2: 'Datos importantes sobre producción, comercialización, siembra, cosecha y exportación de los principales productos, destacando datos exclusivos de <span> SAFRAS & Mercado </span>',
      Description_3: 'Equipo propio de periodistas con amplia experiencia en cobertura de agronegocios',
      Email_field: 'E-mail',
      Phone_field: 'Teléfono',
      Name_field: 'Nombre',
      Notify_Error_Title: '¿Nuevo por aquí?',
      Notify_Error_Message_Error: 'Por favor verifique si hay errores',
    },
    TOUR_STEPS: {
      ButtonSkip: 'No se muestran',
      ButtonPrevious: 'Anterior',
      ButtonNext: 'Próximo',
      ButtonStop: 'Terminar',
      StepFilterText: `<div>Filtro movido</div>`,
      StepNewHighlightText: `<div class="tour-title">Ahora tenemos lo más destacado de Safras TV!</div> <div class="tour-small">Descubre la "Resenha SAFRAS & Mercado", el nuevo programa semanal que reúne a invitados especiales, de gran influencia en la agroindustria</div>`,
      StepNewCommodityText: `<div>Se ha insertado un nuevo <b>Fertilizante</b> en la plataforma</div>`,
      StepFavoriteText: `<div class="tour-title">Ahora tenemos favoritos!</div> <div class="tour-small">Al pasar el mouse sobre el elemento, se mostrará el ícono que le permite marcar el contenido.</div>`,
      StepPlayTourAgainText: `<div class="tour-title">Dentro de la ventana de ayuda puede iniciar el Tour de la plataforma nuevamente con las últimas noticias</div>`,
    },
    DIALOG_MESSAGES: {
      Title: 'Advertencia',
      UserRightsText: 'Su usuario no tiene acceso a este contenido. Contáctenos para habilitar',
      GetMoreQuestionsText: 'No hay más preguntas disponibles. Contáctenos para aprender más',
      PlatformTourText: '¿Le gustaría comenzar el recorrido y ver las novedades de la plataforma?',
      AcceptText: 'Entrar en contacto',
      CancelText: 'Cerrar',
      StartText: 'Start',
      NotDisplatText: 'No se muestran',
      SentRequestDemo: 'Hemos enviado su solicitud de demostración. Le enviaremos un correo electrónico para más noticias.',
      AccountEditDataText: 'Para editar sus datos, envíe un mensaje a nuestro equipo de atención al cliente.'
    },
    BADGES: {
      Important: 'IMPORTANTE',
      Exclusive: 'EXCLUSIVO',
      InLive: 'AO VIVO',
      Disclosure: 'DIVULGACIÓN',
      Announcement: 'ANUNCIO',
      Invite: 'INVITACIÓN',
    },
    BADGES_MEDIA: {
      Appendix: 'Adjunto',
      Audio: 'Audio',
      Video: 'Video',
      Podcast: 'Podcast'
    },
    REGISTER: {
      Title: 'Crear una cuenta',
      Subtitle: 'Complete el siguiente formulario para crear una nueva cuenta.',
      Field_Email: 'Correo electrónico',
      Field_Email_Again: 'Repite correo electrónico',
      Placeholder_Email: 'Escribir correo electrónico',
      Placeholder_Email_Again: 'Escribir correo electrónico nuevamente',
      Field_Username: 'Nombre',
      Placeholder_Username: 'Escribe un nombre',
      Field_UserType: 'Tipo de usuario',
      Placeholder_UserType: 'Seleccionar tipo de usuario',
      Field_Cnpj: 'CNPJ',
      Placeholder_Cnpj: '00.000.000/0000-00',
      Field_Cpf: 'CPF',
      Placeholder_Cpf: '000.000.000-00',
      Field_Phone: 'Teléfono',
      Placeholder_Phone: '00 00000-0000',
      Field_Password: 'Clave',
      Placeholder_Password: 'Escriba contraseña',
      Confirm_Email_Title: 'Confirmar correo electrónico',
      Confirm_Email_Subtitle: 'Te enviamos el código a tu correo',
      Confirm_Email_Field_Code: 'Código',
      Confirm_Email_Placeholder_Code: 'Escribe el código',
      Confirm_Email_Send_Token: 'Codigo enviado com sucesso',
      UserType_Item_PF: 'Peso físico',
      UserType_Item_PJ: 'Pessoa Jurídica',
      HasAccount: 'Já tem uma conta?',
      Terms_Of_Use: 'Leer Bases y Condiciones',
      Accept_Terms: 'Acepto las condiciones de uso',
      Register: 'Registrar',
      Request_Free: 'Quiero registrarme para acceder solo al contenido gratuito de la plataforma',
      Request_Demo: 'Quiero registrarme y solicitar un periodo demo de 7 días para tener acceso a todo el contenido de la plataforma',
      Success_Register: 'Registrado exitosamente'
    },
    USER_SIGNATURE: {
      Title: 'Firma',
      Contracted_Plan: 'Plan Contratado',
      Signature_Validate: 'Suscripción activa hasta',
      Signature_Option_Agency_Safras_RT: 'Agencia SAFRAS (RT)',
      Signature_Option_Other_Agencies: 'Otras agencias (bajo contrato)',
      Signature_Option_Analisy_Agro_Today: 'Análisis Agro Hoy',
      Signature_Option_Analisy_Agro_Vision: 'Análisis de Visión Agro',
      Signature_Option_Estatistic_Export: 'Estadísticas + Exportar/Importar',
      Signature_Option_Ask_Analyst: 'Pregunte al analista',
      Signature_Option_Safras_Tv: 'SAFRAS TV',
      Signature_Option_Safras_Podcast: 'Podcast de SAFRAS',
      Signature_Option_Courses: 'Cursos',
      Signature_Option_Speechs: 'discursos',
      Signature_Option_Weather: 'Climatizado',
      Signature_Option_Fisical_Market: 'Mercado Físico',
      Signature_Option_Future_Market: 'Mercado Futuro (DT y/o RT)',
      Signature_Option_Indicative: 'Indicadores',
      Signature_Option_Exchange_Market: 'Intercambio (DT)',
      Signature_Option_Lineup_Ships: 'Alineación de barcos',
      Signature_Option_Freight_Calculator: 'Calculadora de flete',
      Signature_Option_Open_Line: 'Línea Abierta (Acceso Directo al Analista)',
      Signature_Option_Monthly_Conference: 'Teleconferencia mensual con el Analista',
      Latest: 'El Último',
      Publications: 'Publicaciones'
    },
    PACKAGES: {
      Title: 'Planos',
      Contracted_Plan: 'Plan Contratado',
      Signature_Validate: 'Suscripción activa hasta',
      I_Want_To_Hire: 'Quiero contratar',
      More_Info: 'Mas informaciones'
    },
    USER_NOTIFICATION: {
      Notification: 'Notificaciones',
      Subtitle: 'Configurar notificaciones de correo electrónico y aplicaciones para cada producto',
      Not_Receive_Email: 'No quiero recibir correos electrónicos',
      Not_Receive_Push: 'No quiero recibir notificaciones en la aplicación',
      Content: 'Contenido',
      Email: 'Correo electrónico',
      Push: 'App',
      All: 'Todos',
      Block_notifications: 'Bloquear notificaciones'
    },
    NEWS_DETAIL: {
      Event: 'Evento',
      Invite: 'Invitación',
      Type: 'Tipo',
      Type_Online: 'Online',
      Type_Presential: 'Presential',
      All_Day: 'Todo el día',
      Start_Date: 'Fecha de inicio',
      Final_Date: 'Fecha final',
      Location: 'Lugar',
      Price: 'Valor',
      Link: 'Link',
      Related_Event: 'Noticias evento',
      Content: 'Content',
      Country: 'Country',
      Report: 'Report',
      Report_Date: 'Report Date',
      Publish_Date: 'Publish Date',
      Updated: 'Updated',
      Private_Content: 'Private content for subscribers only',
      By: 'por',
      Read_More: 'Lea mas en',
      Kind_Event: 'Tipo de Evento',
      Start_Event: 'Comienzo del Evento',
      Event_Details: 'Detalles del Evento',
      Price: 'Valor',
      End_Event: 'Fin del Evento',
      Event_Location: 'Lugar del Evento',
      Open: 'Open',
      Related_News: 'Noticias relacionadas',
    },
    USER_PROFILE: {
      Subscriber: 'Abonado',
      Demo: 'Demostración',
      Free: 'Gratis'
    },
    SIGAWEB_DEMO: {
      Plan_Free_Title: 'Plan Gratis',
      Plan_Demo_Title: 'Plan de demostración',
      Plan_Subscribe_Title: 'Plan de Suscripción',
      Free_Text_First: 'Usted está utilizando un plan de suscripción gratuito.',
      Free_Text_Second: 'Si lo desea, solicite una prueba de la Plataforma Safras completa, con acceso a todos los contenidos y funcionalidades.',
      Free_Text_Third: 'Para conocer los demás planes de suscripción, entre en contacto con nosotros por medio del e-mail: <a href="mailto:prevendas@cma.com.br?Subject=Contato" target="_top">prevendas@cma.com.br</a> o por teléfono/WhatsApp: <a href="https://wa.me/5511939478908?text=Olá%2C%20gostaria%20de%20sabe%20as%20condições%20para%20continuar%20acessando%20a%20Plataforma%20SAFRAS" target="_blank">(11) 93947-8908</a>',
      Free_Text_Email: 'prevendas@cma.com.br',
      Free_Text_Click_Here: 'Solicitar demostración',
      Request_Demo: 'Solicitar demostración',
      Signature_Valid_Until: 'Firma válida hasta',
      Signature_Active: 'Suscripción activa',
      Dialog_Title: 'Aviso',
      Field_Empty: 'no encontrado.',
      Field_Invalid_Format: 'con formato inválido.',
      User_Exist: 'Ya hay un contrato activo en nuestro sistema..',
      User_Demo_Exist: 'Ya hay una demostración activa en nuestro sistema.',
      Contact: '\n\nSi el error persiste, contáctenos para obtener más información.',
      SentRequest: 'Recibimos su solicitud de prueba de la Plataforma Safras. Enviaremos la información para el acceso en su e-mail registrado.',
      Attendance_Message: 'Hola, necesito ayuda con la demostración.',
      Demo_Request: 'Solcitud de demostración',
      Update_Phone_Title: 'Actualiza tu número de teléfono',
      Update_Phone_Text: 'Ingrese su número de teléfono para que podamos actualizar nuestro sistema.',
      Update: 'Actualizar'
    },
    AUTHOR_DETAIL: {
      Publication: 'Publicaciones',
      Total: 'Total',
      Today: 'Hoy',
      Last_Sent: 'Últimas enviadas'
    },
    DISPLAY_TYPES: {
      List: 'Lista',
      Card: 'Card',
      Mosaic: 'Mosaico',
      Tag: 'Etiqueta',
      Calendar: 'Calendar',
      Schedule: 'Agenda',
      Playlist: 'Playlist'
    },
    ACCESSIBILITY: {
      Accessibility: 'Accesibilidad',
      Normal: 'Normal',
      To_Hear: 'Escuchar',
      Pause_reading: 'Pausar la lectura',
      Appendix: 'Adjunto'
    },
    HIGHLIGHTS: {
      Highlights: 'DESTAQUES',
      Exclusive_Content: 'Contenido Exclusivo'
    },
    MULTIMEDIA: {
      Details: 'Ver detalles',
      Play: 'Reproducir',
      Add_Playlist: 'Agregar a la lista de reproducción'
    },
    VIEW_MODES: {
      By: '',
      In: ''
    },
    LOGOUT: {
      Title: 'sesión cerrada',
      Message: 'Su sesión ha sido cancelada debido al acceso simultáneo.'
    },
    TICKER: {
      View: 'Para ver:',
      Important: 'Importante',
      Highlights: 'Resalta',
      View_At_Top: 'Ver en la parte superior',
      View_In_Footer: 'Ver en pie de página',
    },
    PRIVATE_CONTENT: {
      Register: '¡Regístrese ahora!',
      Exclusive_Subscribers: '¡Alcance el éxito en el agro negocio con la Plataforma SAFRAS!',
      Sign_Up_access: 'Usted puede registrarse gratuitamente para tener acceso a recursos y contenidos exclusivos o solicitar una demostración del servicio completo.',
      Smart_Content_Title: 'Descubre el poder de la Plataforma SAFRAS',
      Smart_Content_L1: 'Identifica oportunidades rentables y aumenta tu potencial competitivo en el agro negocio.',
      Smart_Content_L2: 'Invierte con precisión, seguridad y protección en productos agrícolas.',
      Smart_Content_L3: 'Toma decisiones estratégicas con análisis exclusivos de la Plataforma SAFRAS.',
      Smart_Content_L4: 'Mantente actualizado con noticias, pronósticos climáticos y paridades de precios a nivel global.',
      Smart_Content_L5: 'Maximiza tus resultados con protección y acceso a estadísticas completas.',
      Alert_Footer: 'El acceso gratuito a la Plataforma Safras y el período de demostración gratuito tiene como objetivo ofrecer una muestra de que la Plataforma Safras puede proporcionar a sus negocios e inversiones. Si desea el acceso ilimitado a todos los recursos y contenidos exclusivos del servicio, conozca los diferentes planes de suscripción para hacer parte de nuestra comunidad de clientes.'
    },
    PRIVATE_CONTENTUSERDEMO: {
      Register: 'Conoce los Planes de Suscripción',
      Attendance: 'Asistencia',
      IOS_Text: 'Si te interesa este tipo de contenido, solicita liberación',
      Exclusive_Subscribers: '¡Estás en el período de demostración de la Plataforma SAFRAS!',
      Sign_Up_access: 'Esta información no está disponible durante el período de demostración, pero está disponible para los suscriptores del servicio. Conoce los diferentes planes de suscripción para formar parte de nuestra comunidad de clientes y poder explorar, aprender y aprovechar al máximo todo lo que tenemos para ofrecer.',
      Smart_Content_Title: 'Descubre el poder de la Plataforma SAFRAS',
      Smart_Content_L1: 'Identifica oportunidades rentables y aumenta tu potencial competitivo en el agro negocio.',
      Smart_Content_L2: 'Invierte con precisión, seguridad y protección en productos agrícolas.',
      Smart_Content_L3: 'Toma decisiones estratégicas con análisis exclusivos de la Plataforma SAFRAS.',
      Smart_Content_L4: 'Mantente actualizado con noticias, pronósticos climáticos y paridades de precios a nivel global.',
      Smart_Content_L5: 'Maximiza tus resultados con protección y acceso a estadísticas completas.',
      Alert_Footer: 'O período de demonstração gratuita tem como objetivo oferecer uma amostra do que a Plataforma Safras pode proporcionar aos seus negócios e investimentos. Caso deseje acesso ilimitado a todos os recursos e conteúdos exclusivos do serviço, conheça os diferentes planos de assinatura para fazer parte de nossa comunidade de clientes.'
    },
    PRIVATE_CONTENTUSERSUBSCRIBER: {
      Register: 'Conoce los Planes de Suscripción',
      Exclusive_Subscribers: '¡Felicitaciones, ya eres suscriptor de la Plataforma SAFRAS!',
      Sign_Up_access: 'Sin embargo, tu plan actual no incluye esta información a la que estás tratando de acceder. Conoce otros planes de suscripción para tener acceso a más información estratégica y recursos que te ayudarán a mejorar tus resultados comerciales e inversiones.',
      Smart_Content_Title: 'Descubre el poder de la Plataforma SAFRAS',
      Smart_Content_L1: 'Identifica oportunidades rentables y aumenta tu potencial competitivo en el agro negocio.',
      Smart_Content_L2: 'Invierte con precisión, seguridad y protección en productos agrícolas.',
      Smart_Content_L3: 'Toma decisiones estratégicas con análisis exclusivos de la Plataforma SAFRAS.',
      Smart_Content_L4: 'Mantente actualizado con noticias, pronósticos climáticos y paridades de precios a nivel global.',
      Smart_Content_L5: 'Maximiza tus resultados con protección y acceso a estadísticas completas.',
    },
    TOAST_NOTIFICATIONS: {
      // Validação de token
      invalidToken: 'Código inválido',
      expiredToken: 'Código expirado',
      // Login
      userNotFound: 'Usuario no encontrado',
      insufficientRights: 'El usuario no tiene derechos para acceder al sistema. Póngase en contacto con nuestro equipo de Atención al Cliente a través del correo electrónico atendimento@cma.com.br.',
      disabledUser: 'Usuario deshabilitado',
      invalidCredentials: 'Usuario o contraseña inválidos',
      // Login via S4
      unauthorized: 'No autorizado',
      disabledS4User: 'Usuario deshabilitado',
      // Esqueci a senha
      emailNotFound: 'Correo electrónico no encontrado',
      disabledUserForgotPassword: 'Usuario deshabilitado',
      emailNotFoundSystem: 'El correo electrónico no encontrado. Póngase en contacto con nuestro equipo de Atención al Cliente a través del correo electrónico atendimento@cma.com.br.',
      // Reset de senha
      invalidConfirmPassword: 'Confirmación de contraseña inválida',
      expiredResetToken: 'Token expirado',
      invalidResetToken: 'Token inválido',
      // Troca de senha
      invalidCurrentPassword: 'Contraseña actual inválida',
      newPasswordMismatch: 'La nueva contraseña y la confirmación deben coincidir',
      newPasswordSameAsCurrent: 'La nueva contraseña no puede ser igual a la contraseña actual',
      // Cadastro
      invalidCPF: 'CPF inválido',
      invalidCNPJ: 'CNPJ inválido',
      cpfAlreadyRegistered: 'CPF ya registrado',
      cnpjAlreadyRegistered: 'CNPJ ya registrado',
      emailAlreadyRegistered: 'Correo electrónico ya registrado. Intente acceder al sistema o comuníquese con nuestro equipo de Atención al Cliente a través del correo electrónico atendimento@cma.com.br.',
      emailAlreadyRegisteredSystem: 'Este e-mail ya se encuentra registrado en nuestro sistema. Utilícelo para acceder a la Plataforma Safras.',
      // Leitura de PDF
      documentNotFound: 'Documento no encontrado',
      // Download público de PDF
      invalidCode: 'Código inválido',
      documentNotFoundPublic: 'Documento no encontrado',
      expiredTokenPublic: 'Token expirado',
      nonExistentEmail: 'Correo electrónico inexistente',
      nonExistentReportId: 'ID de informe inexistente',
      userNotFoundPublic: 'Usuario no encontrado',
      disabledUserPublic: 'Usuario deshabilitado',
      // Removendo DeviceID no logout
      deviceIdNotFound: 'ID de dispositivo no encontrado',
      // TMN Quotes
      displayCannotLoadSystemTitle: 'Error al cargar el sistema',
      displayCannotLoadSystemMessage: 'Falta de comunicación. Actualice la página o comuníquese con nuestro equipo de Atención al Cliente a través del correo electrónico atendimento@cma.com.br.',
      displayNotAuthorizedTitle: 'Error',
      displayNotAuthorizedMessage: 'Falta de comunicación. Actualice la página o comuníquese con nuestro equipo de Atención al Cliente a través del correo electrónico atendimento@cma.com.br.',
      messagesNotifyHelperTitle: 'Error',
      messagesNotifyHelperMessage: 'Falta de comunicación. Actualice la página o comuníquese con nuestro equipo de Atención al Cliente a través del correo electrónico atendimento@cma.com.br.',
      // Ask The Analyst
      askAnalystTitle: 'Preguntar al Analista',
      askAnalystSuccess: 'Pregunta enviada al analista con éxito',
      // REGISTER
      registerRequestDemoTitle: 'Demostración',
      registerRequestDemoMessage: 'Una vez completado el registro, procesaremos su solicitud de demostración. Le enviaremos un correo electrónico para obtener más información.',
      // Packages
      packRequestDemoTitle: 'Demostración',
      packRequestDemoMessage: 'Pedido enviado exitosamente.',
      userPhoneNotFound: 'Telefono no encontrado',
      // TMN HELPER
      checkNotifyErrorTitle: 'Error',
      checkNotifyErrorsMessage: 'Falta de comunicación. Actualice la página o comuníquese con nuestro equipo de Atención al Cliente a través del correo electrónico atendimento@cma.com.br.',
      // CHECK USER INFO
      checkUserInfoTitle: 'Usuario',
      checkUserInfoMessage: 'Usuario deshabilitado.',
      // INTERNAL SERVER ERROR
      internalServerErrorTitle: 'Error 503',
      internalServerErrorMessage: 'El sistema no está disponible actualmente, inténtalo de nuevo en unos momentos.',
      userCannotDelete: 'La cuenta con suscripción activa no se puede eliminar.',
    },
    WDMA: {
      Error_System_Title: 'No se puede cargar el sistema.',
      Error_System_Subtitle: 'Vuelva a intentarlo más tarde...',
      Error_System_Button_Update: 'Actualizar',
      Error_System_Button_Attendance: 'Entrar en contacto',
      Error_Session_Close: 'Hemos identificado que otra estación se ha conectado',
      Error_System_Title_Session_Close: 'Se ha desconectado.',
      Error_System_Button_Connect: 'Conectar',
      Error_Title_Max_Simultaneous_Connections: 'Alcanzaste el número máximo de conexiones simultáneas permitidas',
      Error_Max_Simultaneous_Connections: 'Cerrá una conexión anterior para permitir el nuevo acceso',
      Error_Title_Invalid_Credentials: 'Acceso denegado',
      Error_Invalid_Credentials: 'Verifique sus credenciales o contacte con su administrador',
    },
    DELETE_ACCOUNT: {
      Delete_Account_Button: 'Solicitud de Eliminación de Datos Personales',
      Title: 'AVISO',
      First_Question: `La solicitud de eliminación de datos personales de nuestras bases de datos es un derecho garantizado por la Ley General de Protección de Datos Personales.
      \n Sin embargo, sin esta información, no podremos identificar sus accesos.
      \n Por lo tanto, si continúa con esta solicitud, tan pronto como se procese su solicitud, se bloqueará su acceso a la Plataforma Safras y no podrá volver a acceder hasta que se vuelva a registrar.
      \n Si tiene un contrato vigente para el uso de la Plataforma Safras, registrar la solicitud de eliminación de sus datos personales no lo eximirá de cumplir con las condiciones acordadas de terminación del contrato y su solicitud solo tendrá efecto después de recibir el contacto de nuestro área comercial que le atenderá sobre los pasos de este proceso de baja.
      \n Si tiene o ha tenido un contrato para el uso de productos vendidos por esta empresa, sus datos personales serán eliminados de la Plataforma Safras pero podrán conservarse en los sistemas internos de la empresa mientras sean necesarios para cumplir con las obligaciones legales a las que la empresa está sujeta.
      \n ¿De verdad quieres continuar?`,
      First_Question_Button_Decline: 'Rendirse',
      First_Question_Button_Continue: 'Solicitud de registro',
      First_Question_Success_Title: 'Éxito',
      First_Question_Success_Text: `Su solicitud para eliminar sus datos personales ha sido recibida y está siendo procesada.
      \n Su sesión está siendo terminada.
      \n Si desea reanudar su acceso a la Plataforma Safras, realice un nuevo registro.`,
      Cannot_Delete_Text: `Su solicitud para eliminar sus datos personales ha sido recibida y está siendo procesada.
      \n Espere el contacto de nuestra área comercial que revisará con usted las condiciones de su contrato actual.`
    },
    SCHEDULE: {
      Empty_Schedule: 'Tu calendario está vacío',
      Empty_Schedule_Text: 'Añade eventos a tu calendario.',
      Clean: 'LIMPIAR',
      Today: 'Hoy',
      Month: 'Mes',
      Week: 'Semana',
      Day: 'Día',
      List: 'Lista'
    },
    BIOMETRY: {
      Cancel: "Cancelar",
      Activate: "Activar",
      Use_Pin: "Usar PIN",
      Show_Fingerprint_Desc: "Reconocimiento biométrico para acceder a su",
      Register_Biometric_Secret_Desc: "Reconocimiento biométrico",
      Biometry_Confirm_Activate_Text: "¿Desea activar la biometría ahora para accesos rápidos y seguros?",
      Biometry_Confirm_Title: "Inicio de sesión"
    }
  },
  PtBr: {
    BOOLEAN: {
      Yes: 'Sim',
      No: 'Não'
    },
    USER: {
      Details: 'Detalhes',
      Email: 'E-mail:',
      Name: 'Nome',
      Profile: 'Plano:',
      Document: 'Documento:',
      Phone: 'Telefone:',
      Country: 'País:',
    },
    BUTTONS: {
      Save: 'Salvar',
      Cancel: 'Cancelar',
      Back: 'Voltar',
      Send: 'Enviar',
      Enter: 'Entrar',
      AccessAccount: 'Acesse sua conta',
      Register: 'Cadastre-se',
      BackLogin: 'Voltar',
      RecoverButton: 'Recuperar',
      DownloadFile: 'Download',
      BackHomePage: 'Voltar para Página Inicial',
      MoreQuestion: 'Mais Perguntas',
      RecoveryPassword: 'Enviar',
      TestTrial: 'Teste grátis por 7 dias',
      Save_Announcement: 'Salvar anúncio',
      Edit_Data: 'Editar dados',
      Remove: 'Remover'
    },
    LOGIN: {
      Title: 'Entrar',
      User: 'E-mail',
      Password: 'Senha',
      Remember: 'Lembrar',
      ForgotPass: 'Esqueceu a senha?',
      Enter: 'Entrar',
      Register: 'Cadastre-se',
      Code: 'código',
      New_Here: 'Novo por aqui?',
      Lost_Acess: 'Dificuldade com o acesso?',
      Know_More: 'Saiba mais',
      Click_Here: 'Clique aqui',
      Resend_Token: 'para reenviar o código',
      Notify_Error_Title: 'AVISO',
      Notify_Error_Message: 'Usuário ou senha inválida',
      New_Here_Link: 'https://www2.safras.com.br/plataforma/',
      Two_Factor_Auth_Title: "Dupla autenticação",
      Two_Factor_Auth_Desc: "Enviamos para seu e-mail um código para autenticação. ",
      Two_Factor_Auth_Code: "Código",
      Two_Factor_Auth_Code_Placeholder: "Digite o Código",
      Confirm_Email_Title: "Confirmação de e-mail",
      Confirm_Email_Desc: "Seu cadastro para acesso à demonstração da Plataforma Safras ainda não está concluído. Você precisa registrar na tela de cadastro o token enviado por Safras & Mercado ao seu endereço de e-mail.",
      Confirm_Email_Desc_Token_Val: "Tempo de validade do token: até 2 horas.",
      Confirm_Email_Desc_Sec: "Não recebeu o e-mail?",
      Confirm_Email_Field_Code: 'Código',
      Confirm_Email_Placeholder_Code: 'Digite o código',
      Confirm_Email_Send_Token: 'Código enviado com sucesso',
      Notify_Accept_Terms: 'Você deve aceitar os Termos de Uso para finalizar o cadastro.',
      Footer_CMA: 'é protegido pelo reCaptcha e está sujeito a sua',
      Click_Back: 'Clique para voltar',
      Text_Market: 'Safras & Mercado: tudo sobre o agronegócio em um só lugar'
    },
    LOGINS4: {
      Error_Message_Title: 'Ocorreu um problema.',
      Error_Message_Content: 'Tente novamente em instantes e, caso o problema continue, entre em contato com nossa central de atendimento ao cliente.',
      Error_Message_Content_Other_Login: 'Prezado usuário, sua sessão expirou. Por favor, feche este módulo e abra novamente.',
    },
    GENERAL: {
      Home: 'Início',
      Edit: 'Editar',
      Delete: 'Deletar',
      Update: 'Atualização',
      Create: 'Criação',
      Error: 'Erro',
      Atention: 'Atenção',
      Send: 'Enviar',
      Cma_Url: 'https://www.cma.com.br/',
      Safras_Url: 'https://safras.com.br/',
      Error_Download_File: 'Falha ao baixar arquivo',
      Copy_Data: 'Copiar dados'
    },
    MENU: {
      Home: 'Início',
      AllSubjects: 'Todos os Assuntos',
      Subjects: 'Assuntos',
      AllCommodities: 'Todas Commodities',
      Commodities: 'Commodities',
      DisabledItems: 'Assine já',
      MoreCommodities: 'Mais Culturas',
      NoRights: 'Sem direito'
    },
    TABLE: {
      Table_Column_ID: 'ID',
      Table_Column_DT_Insert: 'Data Inclusão',
      Table_Column_DT_Change: 'Data Alteração',
    },
    MESSAGES: {
      Messages_Created: 'Registro Criado',
      Messages_Updated: 'Registro Atualizado',
      Messages_Deleted: 'Registro Deletado',
      Messages_Generic_Error: 'Erro ao Executar a Operação',
    },
    NAVBAR_DROPDOWN_MENU: {
      Profile: 'Minha Conta',
      Change_Password: 'Trocar Senha',
      Ask_To_Analyst: 'Pergunte ao Analista',
      Dark_Theme: 'Tema Escuro',
      Light_Theme: 'Tema Claro',
      Biometry: 'Biometria',
      Language: 'Idioma',
      Logout: 'Sair',
      Privacy_Policy: 'Política de privacidade',
      Notification: 'Notificação',
      Signatures: 'Assinatura',
      Packages: 'Planos',
      My_Account: 'Minha conta',
      Info_Account: 'Detalhe da conta',
      Platform_Config: 'Configuração da plataforma',
      Font_Size: 'Tamanho do texto',
      Font_Align: 'Alinhamento da imagem',
      Font_Compact: 'Compacto',
      Font_Default: 'Normal',
      Font_Big: 'Amplo',
      Appearance: 'Aparência',
      View_Type_List: 'Lista',
      View_Type_Card: 'Card',
      About: 'Sobre',
      Help: 'Ajuda',
      Show_Ticker: 'Mostrar ticker',
      Hide_Ticker: 'Ocultar ticker',
      Quotes_Config: 'Suporte'
    },
    CHANGE_PASSWORD: {
      Title: 'Trocar Senha',
      Field_Email: 'E-mail',
      Field_Current_Password: 'Senha Atual',
      Field_New_Password: 'Nova Senha',
      Field_New_Password_Repeat: 'Repetir a Nova Senha',
      Notify_Success_Title: 'Trocar Senha',
      Notify_Success_Message: 'A sua senha foi atualizada com sucesso',
      Quit_all_apps: 'Sair de todos os dispositivos',
      Remember_Password: "Não lembra sua senha atual?",
      Click_Retrieve: 'Clique aqui para recuperar',
      Update_Password: 'Atualize sua senha',
      Enter_Current_Password: 'Para atualizar sua senha, é necessário informar a atual'
    },
    RESET_PASSWORD: {
      ResetTitle: 'Troca de Senha',
      ResetDesc: 'Por favor, digite a sua nova senha',
      ResetPass: 'Nova senha',
      ResetConfirm: 'Repetir a nova senha',
      Reset_Confirm: 'repetir',
      InvalidToken: 'Código inválido',
      Notify_Title: 'Troca de senha',
      Notify_Error_Message: 'Por favor, verifique os campos senhas.',
      PasswordChanged: 'Troca de Senha',
      PasswordChangedDesc: 'A sua senha foi atualizada com sucesso',
    },
    FORGOT_PASSWORD: {
      RecoverTitle: 'Recupere a sua senha',
      RecoverDesc: 'Informe seu e-mail e enviaremos instruções para você criar uma nova senha.',
      Field_Email: 'E-mail',
      EmailSent: 'E-mail enviado',
      CheckEmail: 'Um e-mail foi enviado para você. Por favor, verifique a sua caixa de entrada',
      Notify_Success_Title: 'Senha',
      Notify_Success_Message: 'Por favor, verifique o seu e-mail',
      Notify_Error_Title: 'Recupere a sua senha',
      Notify_Error_Message: 'Endereço de e-mail inválido'
    },
    ASK_THE_ANALYST: {
      Title: 'Pergunte ao Analista',
      TitleHedge: 'Cote com a mesa',
      Field_Email: 'E-mail',
      Field_Name: 'Nome',
      Field_Question: 'Pergunta',
      Field_Commodity: 'Commodity',
      Remaining_Questions: 'Perguntas disponíveis restantes: '
    },
    MY_ACCOUNT: {
      Title: 'Minha Conta',
      Field_Email: 'E-mail',
      Field_Name: 'Nome',
      Field_CnpjCpf: 'Cpf/Cnpj',
      Field_Phone: 'Telefone',
      Field_Groups: 'Grupos',
      Field_Language: 'Idioma da Plataforma',
      Text_Language: 'Este parâmetro muda apenas o idioma da plataforma. Para alteração dos conteúdos, favor entrar em contato com a central de atendimento ao cliente.',
      Field_Country: 'País',
      Title_Receive_Email: 'Receba por Email',
      Title_Notification: 'Notificações',
      Field_Option_All: 'Todos',
      Notify_Success_Title: 'Minha Conta',
      Notify_Success_Message: 'Dados atualizados com sucesso',
      Help_Language: 'Necessário para receber email no idioma escolhido'
    },
    ERROR_404: {
      Title: 'Ops, página não encontrada',
      Message: 'Desculpe, esta página não foi encontrada'
    },
    FOOTER: {
      Help: 'Ajuda'
    },
    HELP: {
      Tab_About: 'Sobre',
      Tab_Attendance: 'Atendimento',
      Tab_Version: 'Versão',
      Tab_LGPD: 'LGPD',
      Tab_PrivacyPolicy: 'Política de Privacidade',
      Tab_Tour: 'Tour',
      Tab_Terms: 'Termos de uso',
      Tab_Quotes_Config: 'Suporte'
    },
    HELP_ABOUT: {
      Cma_Title: 'Sobre a CMA',
      Cma_Text: 'A CMA Consultoria, Métodos, Assessoria e Mercantil S/A é uma empresa multinacional brasileira que desde 1973 atua no desenvolvimento de soluções de alta tecnologia aplicadas aos mercados financeiro e de commodities, educacional, telecomunicações e data center. A empresa possui sua matriz e 9 filiais no Brasil, além de filiais nos Estados Unidos, América Latina e Europa, contando com clientes em 35 países.',
      Safras_Title: 'Sobre a SAFRAS & Mercados',
      Safras_Text: 'SAFRAS & Mercado é a consultoria líder do agronegócio brasileiro. Acompanha diariamente os mercados de soja, milho, algodão, café, açúcar & álcool, boi, frango, suíno, arroz, feijão e bioenergia, oferecendo diversos níveis de serviços que auxiliam a tomada de decisão dos participantes dos diferentes segmentos agropecuários. SAFRAS possui o mais completo banco de dados históricos do agronegócio brasileiro, é referência internacional em projeções e cenários agrícolas.',
      Know_More: 'Saiba mais em',
      Visit_Website: 'Visite o site em:'
    },
    HELP_ATTENDANCE: {
      Title: 'Atendimento',
      Contact_Text: 'Entre em contato conosco por telefone ou e-mail abaixo. Entraremos em contato o mais breve possível.',
      Phone: 'Telefone:',
      Email: 'E-mail:',
      Whatsapp: 'WhatsApp:',
      Form_Text: 'Ou envie uma mensagem pelo formulário abaixo.',
      Form_Field_Message: 'Mensagem',
      Notify_Success_Title: 'Atendimento',
      Notify_Success_Message: 'Mensagem enviada com sucesso',
      Phone_href: 'tel:+5501130532750',
      Phone_Text: '(11) 3053-2750',
      Whatsapp_href: 'https://wa.me/551130532600',
      Whatsapp_Text: '(11) 3053-2600',
      Mail_href: 'mailto:atendimento@cma.com.br',
      Mail_Text: 'atendimento@cma.com.br',
      NoRights_Text_Commodity: 'Gostaria de habilitar o acesso a conteúdos da commodity %.',
      NoRights_Text_Content: 'Gostaria de habilitar o acesso do conteúdo % da commodity #.',
      NoRights_Text_GetMoreQuestions: 'Gostaria de habilitar mais perguntas para os analistas.',
      Edit_Account_Data: 'Gostaria de editar meus dados',
    },
    HELP_VERSION: {
      Title: 'Versão',
      Item_Version: 'Versão',
      Item_Browser: 'Navegador',
      Item_System: 'Sistema',
      Item_Resolution: 'Resolução',
      Item_Status: 'Status',
    },
    HELP_LGPD: {
      Accept_Cookies: 'Aceitar',
      Reject_Cookies: 'Recusar',
      Privacy_Policy: 'Ler Política de Privacidade',
      Cookies_Notice: 'O nosso Web site utiliza cookies para fornecer com conteúdo personalizado e para análise do site. Recomendamos que aceite, para uma melhor navegação na página!',
      LGPD_Title: 'Lei Geral de Proteção de Dados Pessoais (LGPD)',
      LGPD_Text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged."
    },
    HELP_PRIVACY_POLICY: {
      Privacy_Policy: 'Política de Privacidade',
      Title: 'Política de Privacidade e Confidencialidade da Informação'
    },
    HELP_SUPPORT: {
      Follow_Market: 'Acompanhe o mercado',
      Restore_Layout: 'Restaurar layout padrão',
      Clear_Local_Data: 'Limpar dados locais',
      Detailed_Info: 'Informações detalhadas',
      Layout_History: 'Histórico layout',
      Created: 'Criado',
      Updated: 'Atualizado',
      Copy_Info_Success: 'Dados foram copiados para área de transferência.',
      Clear_Local_Data_Dialog_Title: 'Limpar dados',
      Clear_Local_Data_Dialog_Message: 'Deseja limpar os dados do acompanhe o mercado?',
      Restore_Layout_Dialog_Title: 'Restaurar layout padrão',
      Restore_Layout_Dialog_Message: 'Deseja restaurar seu layout do acompanhe o mercado para o padrão? A página será atualizado e será necessário realizar login novamente.',
      Update_Layout_History_Dialog_Title: 'Restaurar histórico de layout',
      Update_Layout_History_Dialog_Message: 'Deseja restaurar seu layout do dia',
      Detailed_Info_No_Data: 'Sem dados no momento'
    },
    TERMS_USE: {
      Title: 'Termos de uso',
      Text: '<p class="mt-3 mb-3">Todo o conteúdo disponibilizado na Plataforma Safras é protegido pela Lei de Direitos Autorais e de uso exclusivo dos seus assinantes. Por esta razão, é vedada a reprodução ou distribuição do conteúdo, no todo ou em parte, sem prévia e expressa autorização da CMA. O descumprimento desta vedação acarretará sanções nas esferas cível e criminal.</p><p class="mt-3 mb-3">As informações dispostas na Plataforma Safras refletem exclusivamente apurações e pesquisas realizadas por profissionais de Safras & Mercado. Consistem de informações disponíveis ao público e consideradas confiáveis na data de sua publicação.</p><p class="mt-3 mb-3">Este conteúdo está sujeito a mudanças e é pautado na liberdade de expressão. Sendo assim, possui caráter meramente informativo, não representando quaisquer ofertas ou recomendações de negociação de valores, sejam eles mobiliários, mercadorias e/ou outros instrumentos financeiros ou econômicos.</p><p class="mt-3 mb-3">As informações contidas na Plataforma Safras visam a fomentar o debate e a educação sobre economia e agronegócios a seus assinantes. Desta forma, os assinantes devem desenvolver as suas próprias avaliações de mercado para a tomada de decisões sobre a gestão de seus negócios e/ou investimentos, desde já isentando, resguardando e protegendo integralmente a CMA sobre as consequências destas decisões e, inclusive, sobre eventuais prejuízos financeiros, perdas e danos, durante e após o término do período do plano de assinatura.</p>',
      Text_Mobile: '<p class="mt-3 mb-3">Todo o conteúdo disponibilizado na Plataforma Safras é protegido pela Lei de Direitos Autorais e de uso exclusivo dos seus assinantes. Por esta razão, é vedada a reprodução ou distribuição do conteúdo, no todo ou em parte, sem prévia e expressa autorização da CMA. O descumprimento desta vedação acarretará sanções nas esferas cível e criminal.</p><p class="mt-3 mb-3">As informações dispostas na Plataforma Safras refletem exclusivamente apurações e pesquisas realizadas por profissionais de Safras & Mercado. Consistem de informações disponíveis ao público e consideradas confiáveis na data de sua publicação.</p><p class="mt-3 mb-3">Este conteúdo está sujeito a mudanças e é pautado na liberdade de expressão. Sendo assim, possui caráter meramente informativo, não representando quaisquer ofertas ou recomendações de negociação de valores, sejam eles mobiliários, mercadorias e/ou outros instrumentos financeiros ou econômicos.</p><p class="mt-3 mb-3">As informações contidas na Plataforma Safras visam a fomentar o debate e a educação sobre economia e agronegócios a seus assinantes. Desta forma, os usuários devem desenvolver as suas próprias avaliações de mercado para a tomada de decisões sobre a gestão de seus negócios e/ou investimentos, desde já isentando, resguardando e protegendo integralmente a CMA sobre as consequências destas decisões e, inclusive, sobre eventuais prejuízos financeiros, perdas e danos, durante e após o término do período de uso do sistema.</p>',
      Read_Accepted: 'Li e aceito',
      Cancel: 'Cancelar'
    },
    REPORT: {
      No_Report_Found: 'Nenhum Resultado Encontrado',
      No_Report_Found_Text: 'Você pode refazer a busca para encontrar o que está procurando',
      No_Report_Found_Text_Demo: 'Para mais resultados e conteúdos exclusivos, cadastre-se ou acesse nossa Plataforma.',
      Load_More: 'Carregar Mais...',
      Download_Spreadsheet: 'Download Planilha',
      Download_Spreadsheet_Text: 'Clique para baixar a planilha',
      Hear_Text: 'Ouvir o Texto',
      Hear_Text_Hearing: 'Ouvindo: ',
      All_Commodities: 'Todas Commodities',
      View_More: 'Ver mais'
    },
    REPORT_FILTER: {
      Informative_Title: 'Informativos',
      Informative: 'Análises e Informações',
      Search: 'Pesquisar',
      Filters: 'Pesquisar',
      Filter_Periodicity: 'Frequência',
      Filter_Publication_Type: 'Tipo de Conteúdo',
      Filter_Subject: 'Commodities',
      Filter_Order_By: 'Ordenar por',
      Filter_Content: 'Conteúdos',
      Filter_Country: 'Origem de relatório',
      Filter_Highlights: 'Destaque',
      Filter_InLive: 'Ao vivo',
      Filter_Important: 'Importante',
      Filter_Exclusive: 'Exclusivo',
      Filter_Date: 'Data',
      Filter_Date_From: 'DE',
      Filter_Date_To: 'ATÉ',
      Filter_Media_type: 'Tipo de Mídia',
      Filter_Priority: 'Prioridade',
      Filter_Attachment: 'Anexo',
      Filter_Video: 'Video',
      Filter_Audio: 'Audio',
      Filter_Podcast: 'Podcast',
      Filter_Relevant: 'Relevantes',
      Clear_Filter: 'Limpar',
      To_View: 'Visualizar',
      Results: 'resultados',
      Follow_Market: 'Acompanhe o Mercado',
      Favorite_Content: 'Editar Favoritos',
      Filter_Report_Type: 'Tipo de Relatório',
      Information_label: 'Informações',
      Advanced_Filters: 'Filtros Avançados',
      Filter_Author: 'Filtrar por autor',
      One_Day: '1 DIA',
      One_Week: '1 SEMANA',
      One_Month: '1 MÊS',
      Three_Months: '3 MESES',
      Select_Date: 'SELECIONE UMA DATA',
    },
    REPORT_ITEM: {
      Updated: 'Atualizado em',
      Today: 'Hoje'
    },
    BROWSER_NOT_SUPPORTED: {
      Title: 'AVISO',
      Text: 'Para uma experiência única com mais desempenho e segurança experimente nosso aplicativo em outros navegadores. Também é possível instalar nosso App para Windows.',
      Other_Browsers: 'Outros Navegadores',
      Windows_Store: 'Windows Store'
    },
    DOWNLOAD_PUBLIC_FILE_EMAIL: {
      Title: 'Download de Arquivo',
      Notify_Error_Title: 'Token',
      Notify_Error_Message_Token_Not_Found: 'Token não encontrado',
      Notify_Error_Message_Invalid_Token: 'Token inválido'
    },
    PLAYLIST: {
      Empty_Playlist: 'Sua playlist está vazia',
      Empty_Playlist_Text: 'Adicione um vídeo na sua playlist',
      Youtube_Add_Playlist_Text: 'Video adicionado a playlist',
      Audio_Add_Playlist_Text: 'Áudio adicionado a playlist',
      Item_Add_Playlist_Text: 'Item adicionado a playlist',
      Upcoming_Videos: 'Próximos vídeos',
      Clean: 'LIMPAR',
      Running: 'Em Execução'
    },
    LOST_ACCESS: {
      Title: 'Perdeu Acesso',
      ResetText: 'Como você prefere redefinir seu acesso ?',
      EmailCheckbox: 'Por E-mail',
      OtherCheckbox: 'Outros',
      ByEmail_Title: 'Envie uma mensagem para nós',
      Other_Title: 'Entre em contato com o nosso atendimento!',
      Email_field: 'E-mail',
      Phone_field: 'Telefone',
      Message_field: 'Mensagem',
      Notify_Error_Title: 'Perdeu Acesso',
      Notify_Error_Message: 'Endereço de e-mail inválido',
      Phone_href: 'tel:+5501130532750',
      Phone_Text: '(11) 3053-2750',
      Mail_href: 'mailto:atendimento@cma.com.br',
      Mail_Text: 'atendimento@cma.com.br'
    },
    NEW_CLIENT: {
      Title: 'Novo por aqui ?',
      Title2: 'Acompanhe os movimentos dos mercados agropecuários.',
      Title3: 'Vantagens Exclusivas da Plataforma SAFRAS',
      Description_1: 'Acompanhamento completo dos relatórios do <span>USDA</span>, integrando previsões de mercado, notícias agrícolas, alertas, quadros, vídeos e áudios',
      Description_2: 'Importantes dados de produção, comercialização, plantio, colheita e exportações das principais commodities, destacando dados exclusivos de <span>SAFRAS & Mercado</span>',
      Description_3: 'Equipe própria de jornalistas com larga especialização em cobertura do agronegócio',
      Email_field: 'E-mail',
      Phone_field: 'Telefone',
      Name_field: 'Nome',
      Notify_Error_Title: 'Novo por aqui ?',
      Notify_Error_Message: 'Por favor, verifique os campos senhas.',
    },
    TOUR_STEPS: {
      ButtonSkip: 'Não exibir',
      ButtonPrevious: 'Voltar',
      ButtonNext: 'Proximo',
      ButtonStop: 'Finalizar',
      StepFilterText: `<div>Filtro mudou de local</div>`,
      StepNewHighlightText: `<div class="tour-title">Agora temos destaques para Safras TV!</div> <div class="tour-small">Conheçam o "Resenha SAFRAS & Mercado", o novo programa semanal que reúne convidados especiais, de grande influência no agronegócio</div>`,
      StepNewCommodityText: `<div>Uma nova commodity <b>Fertilizantes</b> foi inserido na plataforma</div>`,
      StepFavoriteText: `<div class="tour-title">Agora temos favoritos!</div><div class="tour-small">Passando o mouse sobre o item irá aparecer o ícone que permite enviar o conteúdo aos favoritos.</div>`,
      StepPlayTourAgainText: `<div>Dentro da janela de ajuda pode iniciar novamente o Tour da plataforma com as ultimas novidades</div>`,
    },
    DIALOG_MESSAGES: {
      Title: 'Aviso',
      UserRightsText: 'Seu usuário não possui acesso a esse conteúdo. Entre em contato para habilitar',
      GetMoreQuestionsText: 'Não há mais perguntas disponíveis. Entre em contato para saber mais.',
      PlatformTourText: 'Gostaria de iniciar o tour e ver as novidade da plataforma ?',
      AcceptText: 'Entrar em contato',
      CancelText: 'Fechar',
      StartText: 'Iniciar',
      NotDisplatText: 'Não exibir',
      SentRequestDemo: 'Enviamos sua solicitação de demonstração. Enviaremos um email para mais novidades.',
      AccountEditDataText: 'Para editar seus dados, favor envie uma mensagem para nosso atendimento.'
    },
    BADGES: {
      Important: 'IMPORTANTE',
      Exclusive: 'EXCLUSIVO',
      InLive: 'AO VIVO',
      Disclosure: 'DIVULGAÇÃO',
      Announcement: 'ANÚNCIO',
      Invite: 'CONVITE',
    },
    BADGES_MEDIA: {
      Appendix: 'Anexo',
      Audio: 'Áudio',
      Video: 'Vídeo',
      Podcast: 'Podcast'
    },
    REGISTER: {
      Title: 'Criar uma conta',
      Subtitle: 'Preencha o formulário abaixo para criar uma nova conta.',
      Field_Email: 'E-mail',
      Field_Email_Again: 'Repetir E-mail',
      Placeholder_Email: 'Digite E-mail',
      Placeholder_Email_Again: 'Digite o e-mail novamente',
      Field_Username: 'Nome',
      Placeholder_Username: 'Digite o nome',
      Field_UserType: 'Tipo de usuário',
      Placeholder_UserType: 'Selecionar tipo de usuário',
      Field_Cnpj: 'CNPJ',
      Placeholder_Cnpj: '00.000.000/0000-00',
      Field_Cpf: 'CPF',
      Placeholder_Cpf: '000.000.000-00',
      Field_Phone: 'Telefone',
      Placeholder_Phone: '00 00000-0000',
      Field_Password: 'Senha',
      Placeholder_Password: 'Digite a senha',
      Confirm_Email_Title: 'Confirmação de e-mail',
      Confirm_Email_Subtitle: 'Não recebeu o e-mail?',
      Confirm_Email_Field_Code: 'Código',
      Confirm_Email_Placeholder_Code: 'Digite o código',
      Confirm_Email_Send_Token: 'Código enviado com sucesso',
      UserType_Item_PF: 'Pessoa Física',
      UserType_Item_PJ: 'Pessoa Jurídica',
      HasAccount: 'Já tem uma conta?',
      Terms_Of_Use: 'Ler os Termos de Uso',
      Accept_Terms: 'Aceito os termos de uso',
      Register: 'Cadastrar',
      Request_Free: 'Quero me cadastrar para ter acesso apenas aos conteúdos gratuitos da plataforma',
      Request_Demo: 'Quero me cadastrar e solicitar um período de 7 dias de demonstração para ter acesso a todos os conteúdos da plataforma',
      Success_Register: 'Cadastro realizado com sucesso'
    },
    USER_SIGNATURE: {
      Title: 'Assinatura',
      Contracted_Plan: 'Plano Contratado',
      Signature_Validate: 'Assinatura ativa até',
      Signature_Option_Agency_Safras_RT: 'Agência SAFRAS (RT)',
      Signature_Option_Other_Agencies: 'Outras Agências (sob contratação)',
      Signature_Option_Analisy_Agro_Today: 'Análise Agro Hoje',
      Signature_Option_Analisy_Agro_Vision: 'Análise Visão Agro',
      Signature_Option_Estatistic_Export: 'Estatísticas + Export/Import',
      Signature_Option_Ask_Analyst: 'Pergunte ao Analista',
      Signature_Option_Safras_Tv: 'SAFRAS TV',
      Signature_Option_Safras_Podcast: 'SAFRAS Podcast',
      Signature_Option_Courses: 'Cursos',
      Signature_Option_Speechs: 'Palestras',
      Signature_Option_Weather: 'Clima',
      Signature_Option_Fisical_Market: 'Mercado Físico',
      Signature_Option_Future_Market: 'Mercado Futuro (DT e/ou RT)',
      Signature_Option_Indicative: 'Indicadores',
      Signature_Option_Exchange_Market: 'Câmbio (DT)',
      Signature_Option_Lineup_Ships: 'Line-up de Navios',
      Signature_Option_Freight_Calculator: 'Calculadora de Fretes',
      Signature_Option_Open_Line: 'Open Line (Acesso Direto ao Analista)',
      Signature_Option_Monthly_Conference: 'Teleconferência mensal com o Analista',
      Latest: 'Últimas',
      Publications: 'Publicações'
    },
    PACKAGES: {
      Title: 'Planos',
      Contracted_Plan: 'Plano Contratado',
      Signature_Validate: 'Assinatura ativa até',
      I_Want_To_Hire: 'Quero contratar',
      More_Info: 'Mais informações'
    },
    USER_NOTIFICATION: {
      Notification: 'Notificações',
      Subtitle: 'Configure o recebimento de notificações por e-mail e pelo app para cada commodity',
      Not_Receive_Email: 'Não quero receber e-mail',
      Not_Receive_Push: 'Não quero receber notificações no app',
      Content: 'Conteúdo',
      Email: 'E-mail',
      Push: 'App',
      All: 'Todos',
      Block_notifications: 'Bloquear notificações'
    },
    NEWS_DETAIL: {
      Event: 'Evento',
      Invite: 'Convite',
      Type: 'Tipo',
      Type_Online: 'Online',
      Type_Presential: 'Presencial',
      All_Day: 'Todo o dia',
      Start_Date: 'Data de inicio',
      Final_Date: 'Data final',
      Location: 'Local',
      Price: 'Valor',
      Link: 'Link',
      Related_Event: 'Evento relacionado',
      Content: 'Conteúdo',
      Country: 'País',
      Report: 'Relatório:',
      Report_Date: 'Data do relatório:',
      Publish_Date: 'Data da publicação:',
      Updated: 'Atualizado em',
      Private_Content: 'Conteúdo privado apenas para assinantes',
      By: 'por',
      Read_More: 'Leia mais em',
      Kind_Event: 'Tipo de Evento',
      Start_Event: 'Início do Evento',
      Event_Details: 'Detalhes do Evento',
      Price: 'Valor',
      End_Event: 'Fim do Evento',
      Event_Location: 'Lugar do Evento',
      Open: 'Abrir',
      Related_News: 'Notícias Relacionadas',
    },
    USER_PROFILE: {
      Subscriber: 'Assinante',
      Demo: 'Demonstração',
      Free: 'Gratuito'
    },
    SIGAWEB_DEMO: {
      Plan_Free_Title: 'Plano Gratuito',
      Plan_Demo_Title: 'Conta Demonstração',
      Plan_Subscribe_Title: 'Assinante',
      Free_Text_First: 'Você está utilizando um plano de assinatura gratuita.',
      Free_Text_Second: 'Se desejar, solicite uma demonstração da Plataforma Safras completa, com acesso a todos os conteúdos e funcionalidades.',
      Free_Text_Third: 'Para conhecer os demais planos de assinatura, entre em contato conosco por meio do e-mail <a href="mailto:prevendas@cma.com.br?Subject=Contato" target="_top">prevendas@cma.com.br</a> ou pelo telefone/whatsapp: <a href="https://wa.me/5511939478908?text=Olá%2C%20gostaria%20de%20sabe%20as%20condições%20para%20continuar%20acessando%20a%20Plataforma%20SAFRAS" target="_blank">(11) 93947-8908</a>',
      Free_Text_Email: 'prevendas@cma.com.br',
      Free_Text_Click_Here: 'Solicitar demonstração',
      Request_Demo: 'Solicitar uma demonstração',
      Signature_Valid_Until: 'Assinatura valida até',
      Signature_Active: 'Assinatura ativa',
      Dialog_Title: 'Aviso',
      Field_Empty: 'não encontrado.',
      Field_Invalid_Format: 'com formato inválido.',
      User_Exist: 'Já existe um contrato ativo em nosso sistema.',
      User_Demo_Exist: 'Já existe uma conta gratuita ativa em nosso sistema.',
      Contact: '\n\nCaso o erro persista, entre em contato.',
      SentRequest: 'Recebemos sua solicitação de demonstração da Plataforma Safras. Enviaremos informações para acesso em seu e-mail cadastrado.',
      Attendance_Message: 'Olá, preciso de ajuda com a conta gratuita',
      Demo_Request: 'Solicitação de demonstração',
      Update_Phone_Title: 'Atualize seu número de telefone',
      Update_Phone_Text: 'Por favor, insira seu número de telefone para atualizarmos em nosso sistema.',
      Update: 'Atualizar'
    },
    AUTHOR_DETAIL: {
      Publication: 'Publicações',
      Total: 'Total',
      Today: 'Hoje',
      Last_Sent: 'Últimas enviadas'
    },
    DISPLAY_TYPES: {
      List: 'Lista',
      Card: 'Card',
      Mosaic: 'Mosaico',
      Tag: 'Etiqueta',
      Calendar: 'Calendario',
      Schedule: 'Agenda',
      Playlist: 'Playlist'
    },
    ACCESSIBILITY: {
      Accessibility: 'Acessibilidade',
      Normal: 'Normal',
      To_Hear: 'Ouvir',
      Pause_reading: 'Pausar a leitura',
      Appendix: 'Anexo'
    },
    HIGHLIGHTS: {
      Highlights: 'Destaques',
      Exclusive_Content: 'Conteúdo Exclusivo',
    },
    MULTIMEDIA: {
      Details: 'Ver Detalhes',
      Play: 'Reproduzir',
      Add_Playlist: 'Adicionar à playlist'
    },
    VIEW_MODES: {
      By: '',
      In: ''
    },
    LOGOUT: {
      Title: 'Sessão encerrada',
      Message: 'Sua sessão foi encerrada devido a um acesso simultâneo.'
    },
    TICKER: {
      View: 'Visualizar:',
      Important: 'Importante',
      Highlights: 'Destaques',
      View_At_Top: 'Visualizar no topo',
      View_In_Footer: 'Visualizar no rodapé',
    },
    PRIVATE_CONTENT: {
      Register: 'Cadastre-se Agora!',
      Exclusive_Subscribers: 'Alcance o sucesso no agronegócio com a Plataforma SAFRAS!',
      Sign_Up_access: 'Você pode se cadastrar gratuitamente para ter acesso a recursos e conteúdos exclusivos ou solicitar uma demonstração do serviço completo.',
      Smart_Content_Title: 'Descubra o poder da Plataforma SAFRAS',
      Smart_Content_L1: 'Identifique oportunidades lucrativas e aumente seu potencial competitivo no agronegócio.',
      Smart_Content_L2: 'Invista com assertividade, segurança e proteção em commodities agrícolas.',
      Smart_Content_L3: 'Tome decisões estratégicas com análises exclusivas da Plataforma SAFRAS.',
      Smart_Content_L4: 'Acompanhe o cenário global com notícias, previsões climáticas e paridades de preços.',
      Smart_Content_L5: 'Maximize seus resultados com proteção e acesso a estatísticas completas.',
      Alert_Footer: 'O acesso gratuito à Plataforma Safras e o período de demonstração gratuita têm como objetivo oferecer uma amostra do que a Plataforma Safras pode proporcionar aos seus negócios e investimentos. Caso deseje acesso ilimitado a todos os recursos e conteúdos exclusivos do serviço, conheça os diferentes planos de assinatura para fazer parte de nossa comunidade de clientes.'
    },
    PRIVATE_CONTENTUSERDEMO: {
      Register: 'Conhecer Planos de Assinatura',
      Attendance: 'Atendimento',
      IOS_Text: 'Se você tem interesse neste tipo de conteúdo, solicite a liberação',
      Exclusive_Subscribers: 'Você está em período de demonstração da Plataforma SAFRAS!',
      Sign_Up_access: 'Esta informação não é liberada durante o acesso de demonstração, mas é disponível para assinantes do serviço. Conheça os diferentes planos de assinatura para fazer parte de nossa comunidade de clientes e poder explorar, aprender e tirar o máximo de proveito de tudo que temos a oferecer.',
      Smart_Content_Title: 'Descubra o poder da Plataforma SAFRAS',
      Smart_Content_L1: 'Identifique oportunidades lucrativas e aumente seu potencial competitivo no agronegócio.',
      Smart_Content_L2: 'Invista com assertividade, segurança e proteção em commodities agrícolas.',
      Smart_Content_L3: 'Tome decisões estratégicas com análises exclusivas da Plataforma SAFRAS.',
      Smart_Content_L4: 'Acompanhe o cenário global com notícias, previsões climáticas e paridades de preços.',
      Smart_Content_L5: 'Maximize seus resultados com proteção e acesso a estatísticas completas.',
      Alert_Footer: 'O período de demonstração gratuita tem como objetivo oferecer uma amostra do que a Plataforma Safras pode proporcionar aos seus negócios e investimentos. Caso deseje acesso ilimitado a todos os recursos e conteúdos exclusivos do serviço, conheça os diferentes planos de assinatura para fazer parte de nossa comunidade de clientes.'
    },
    PRIVATE_CONTENTUSERSUBSCRIBER: {
      Register: 'Conhecer Planos de Assinatura',
      Exclusive_Subscribers: 'Parabéns, você já é assinante da Plataforma SAFRAS!',
      Sign_Up_access: 'No entanto, seu plano atual não contempla esta informação que está tentando acessar. Conheça outros planos de assinatura para ter acesso a mais informações estratégicas e recursos que vão te ajudar a ampliar seus resultados de negócios e investimentos.',
      Smart_Content_Title: 'Descubra o poder da Plataforma SAFRAS',
      Smart_Content_L1: 'Identifique oportunidades lucrativas e aumente seu potencial competitivo no agronegócio.',
      Smart_Content_L2: 'Invista com assertividade, segurança e proteção em commodities agrícolas.',
      Smart_Content_L3: 'Tome decisões estratégicas com análises exclusivas da Plataforma SAFRAS.',
      Smart_Content_L4: 'Acompanhe o cenário global com notícias, previsões climáticas e paridades de preços.',
      Smart_Content_L5: 'Maximize seus resultados com proteção e acesso a estatísticas completas.'
    },
    TOAST_NOTIFICATIONS: {
      // Validação de token
      invalidToken: 'Código inválido',
      expiredToken: 'Código expirado',
      // Login
      userNotFound: 'Usuário não encontrado',
      insufficientRights: 'Usuário não possui direitos para acessar o sistema. Entre contato com nossa equipe de Atendimento pelo e-mail atendimento@cma.com.br.',
      disabledUser: 'Usuário desabilitado',
      invalidCredentials: 'Usuário ou senha inválidos',
      // Login via S4
      unauthorized: 'Não autorizado',
      disabledS4User: 'Usuário desativado',
      // Esqueci a senha
      emailNotFound: 'Email não encontrado',
      disabledUserForgotPassword: 'Usuário desabilitado',
      emailNotFoundSystem: 'Email não encontrado. Entre contato com nossa equipe de Atendimento pelo e-mail atendimento@cma.com.br.',
      // Reset de senha
      invalidConfirmPassword: 'Confirmação de senha inválida',
      expiredResetToken: 'Token expirado',
      invalidResetToken: 'Token inválido',
      // Troca de senha
      invalidCurrentPassword: 'Senha atual inválida',
      newPasswordMismatch: 'Nova senha e confirmação devem ser iguais',
      newPasswordSameAsCurrent: 'Nova senha não pode ser igual à senha atual',
      // Cadastro
      invalidCPF: 'CPF inválido',
      invalidCNPJ: 'CNPJ inválido',
      cpfAlreadyRegistered: 'CPF já cadastrado',
      cnpjAlreadyRegistered: 'CNPJ já cadastrado',
      emailAlreadyRegistered: 'E-mail já cadastrado. Tente acessar o sistema ou Entre contato com nossa equipe de Atendimento pelo e-mail atendimento@cma.com.br.',
      emailAlreadyRegisteredSystem: 'Este e-mail já está cadastrado em nosso sistema. Utilize-o para fazer o seu acesso à Plataforma Safras.',
      // Leitura de PDF
      documentNotFound: 'Documento não existente',
      // Download público de PDF
      invalidCode: 'Código inválido',
      documentNotFoundPublic: 'Documento não encontrado',
      expiredTokenPublic: 'Token expirado',
      nonExistentEmail: 'E-mail inexistente',
      nonExistentReportId: 'ID do relatório inexistente',
      userNotFoundPublic: 'Usuário não encontrado',
      disabledUserPublic: 'Usuário desabilitado',
      // Removendo DeviceID no logout
      deviceIdNotFound: 'Device Id não encontrado',
      // TMN Quotes
      displayCannotLoadSystemTitle: 'Falha ao carregar o sistema',
      displayCannotLoadSystemMessage: 'Falha de comunicação. Atualize a página ou entre contato com nossa equipe de Atendimento pelo e-mail atendimento@cma.com.br.',
      displayNotAuthorizedTitle: 'Erro',
      displayNotAuthorizedMessage: 'Falha de comunicação. Atualize a página ou entre contato com nossa equipe de Atendimento pelo e-mail atendimento@cma.com.br.',
      messagesNotifyHelperTitle: 'Erro',
      messagesNotifyHelperMessage: 'Falha de comunicação. Atualize a página ou entre contato com nossa equipe de Atendimento pelo e-mail atendimento@cma.com.br.',
      // Ask The Analyst
      askAnalystTitle: 'Pergunte ao Analista',
      askAnalystSuccess: 'Pergunta enviada para o analista com sucesso',
      // REGISTER
      registerRequestDemoTitle: 'Demonstração',
      registerRequestDemoMessage: 'Após a conclusão do cadastro, vamos processar sua solicitação de demonstração. Enviaremos um e-mail para mais informações.',
      // Packages
      packRequestDemoTitle: 'Demonstração',
      packRequestDemoMessage: 'Pedido enviado com sucesso.',
      userPhoneNotFound: 'Telefone não encontrado',
      //TMN HELPER
      checkNotifyErrorTitle: 'Erro',
      checkNotifyErrorsMessage: 'Falha de comunicação. Atualize a página ou entre contato com nossa equipe de Atendimento pelo e-mail atendimento@cma.com.br.',
      // CHECK USER INFO
      checkUserInfoTitle: 'Usuário',
      checkUserInfoMessage: 'Usuário desabilitado.',
      // INTERNAL SERVER ERROR
      internalServerErrorTitle: 'Erro 503',
      internalServerErrorMessage: 'Sistema indisponivel no momento, tente novamente em alguns instantes.',
      userCannotDelete: 'Conta com assuntatura ativa não pode ser deletada.',
    },
    WDMA: {
      Error_System_Title: 'Não foi possível carregar o sistema.',
      Error_System_Subtitle: 'Tente novamente mais tarde...',
      Error_System_Button_Update: 'Atualizar',
      Error_System_Button_Attendance: 'Entrar em contato',
      Error_Session_Close: 'Identificamos que outra estação se conectou',
      Error_System_Title_Session_Close: 'Você foi desconectado.',
      Error_System_Button_Connect: 'Conectar',
      Error_Title_Max_Simultaneous_Connections: 'Você atingiu o número máximo de conexões simultâneas permitidas.',
      Error_Max_Simultaneous_Connections: 'Encerre uma conexão antiga para permitir o novo acesso',
      Error_Title_Invalid_Credentials: 'Acesso negado',
      Error_Invalid_Credentials: 'Verifique suas credenciais ou entre em contato com o administrador',
    },
    DELETE_ACCOUNT: {
      Delete_Account_Button: 'Solicitar exclusão de dados pessoais',
      Title: 'AVISO',
      First_Question: `A solicitação de exclusão dos dados pessoais das nossas bases é um direito garantido pela Lei Geral de Proteção de Dados Pessoais.
      \n Porém, sem estas informações, não conseguiremos identificar os seus acessos.
      \n Desta forma, se você prosseguir com esta solicitação, tão logo sua solicitação seja processada seu acesso na Plataforma Safras será bloqueado e você não poderá voltar a acessá-la até que você refaça o seu cadastro.
      \n Caso você tenha um contrato vigente de uso da Plataforma Safras, o registro da solicitação de exclusão dos seus dados pessoais não irá desonerá-lo de cumprir com as condições acordadas de rescisão contratual e a sua solicitação só terá efeito após você receber o contato da nossa área comercial que irá tratar com você sobre os passos deste processo de desregistro.
      \n Caso você tenha ou já tenha tido um contrato de uso dos produtos comercializados por esta empresa, seus dados pessoais serão excluídos da Plataforma Safras mas poderão ser mantidos em sistemas internos da empresa desde que sejam necessários para atender às obrigações legais as quais a empresa esteja submetida.
      \n Você realmente deseja prosseguir?`,
      First_Question_Button_Decline: 'Desistir',
      First_Question_Button_Continue: 'Registrar Solicitação',
      First_Question_Success_Title: 'Sucesso',
      First_Question_Success_Text: `Sua solicitação de exclusão dos seus dados pessoais foi recebida e está sendo processada.
      \n Sua sessão está sendo encerrada.
      \n Caso deseje retomar o seu acesso a Plataforma Safras, realize um novo cadastro.`,
      Cannot_Delete_Text: `Sua solicitação de exclusão dos seus dados pessoais foi recebida e está sendo processada.
      \n Aguarde o contato da nossa área comercial que revisará com você as condições do seu contrato vigente.`
    },
    SCHEDULE: {
      Empty_Schedule: 'Sua agenda está vazia',
      Empty_Schedule_Text: 'Adicione eventos a sua agenda.',
      Clean: 'LIMPAR',
      Today: 'Hoje',
      Month: 'Mês',
      Week: 'Semana',
      Day: 'Dia',
      List: 'Lista'
    },
    BIOMETRY: {
      Cancel: 'Cancelar',
      Activate: 'Ativar',
      Use_Pin: 'User PIN',
      Show_Fingerprint_Desc: 'Reconhecimento de biometria para acessar a sua',
      Register_Biometric_Secret_Desc: 'Reconhecimento de biometria',
      Biometry_Confirm_Activate_Text: 'Deseja ativar a biometria agora para acessos rápidos e protegidos?',
      Biometry_Confirm_Title: 'Login',
    }
  },
  PtPt: {
    BOOLEAN: {
      Yes: 'Sim',
      No: 'Não'
    },
    USER: {
      Details: 'Detalhes',
      Email: 'E-mail:',
      Name: 'Nome',
      Profile: 'Conta:',
      Document: 'Documento:',
      Phone: 'Telefone:',
      Country: 'País:',
    },
    BUTTONS: {
      Save: 'Poupar',
      Cancel: 'Cancelar',
      Back: 'Voltar',
      Send: 'Enviar',
      Enter: 'Entrar',
      AccessAccount: 'Inicie sessão na sua conta',
      Register: 'Inscreva-se',
      BackLogin: 'Voltar',
      RecoverButton: 'Recuperar',
      DownloadFile: 'Descarregar',
      BackHomePage: 'De volta a casa',
      MoreQuestion: 'Mais perguntas',
      RecoveryPassword: 'Enviar',
      TestTrial: 'Experimente gratuitamente durante 7 dias',
      Save_Announcement: 'Salvar anúncio',
      Edit_Data: 'Editar dados',
      Remove: 'Remover'
    },
    LOGIN: {
      Title: 'Entrar',
      User: 'E-mail',
      Password: 'Palavra-passe',
      Remember: 'Lembre-se',
      ForgotPass: 'Esqueceu-se da palavra-passe?',
      Enter: 'Entrar',
      Register: 'Inscreva-se',
      Code: 'código',
      New_Here: 'Novo por aqui?',
      Lost_Acess: 'Dificuldade de acesso?',
      Know_More: 'Saiba mais',
      Click_Here: 'Clique aqui',
      Resend_Token: 'voltar a apresentar o código',
      Notify_Error_Title: 'ADVERTÊNCIA',
      Notify_Error_Message: 'Utilizador ou palavra-passe inválidos',
      New_Here_Link: 'https://www2.safras.com.br/plataforma/',
      Two_Factor_Auth_Title: "Dupla autenticação",
      Two_Factor_Auth_Desc: "Enviamos ao seu e-mail um código para autenticação.",
      Two_Factor_Auth_Code: "Código",
      Two_Factor_Auth_Code_Placeholder: "Insira o código",
      Confirm_Email_Title: "Confirmação por e-mail",
      Confirm_Email_Desc: "Seu cadastro para acesso à demonstração da Plataforma Safras ainda não está concluído. Você precisa registrar na tela de cadastro o token enviado por Safras & Mercado ao seu endereço de e-mail.",
      Confirm_Email_Desc_Token_Val: "Tempo de validade do token: até 2 horas.",
      Confirm_Email_Desc_Sec: "Não recebeu o e-mail?",
      Confirm_Email_Field_Code: 'Código',
      Confirm_Email_Placeholder_Code: 'Inserir o código',
      Confirm_Email_Send_Token: 'Código enviado com êxito',
      Notify_Accept_Terms: 'Você deve aceitar os Termos de Uso para finalizar o cadastro.',
      Footer_CMA: 'está protegido por reCaptcha e está sujeito ao seu',
      Click_Back: 'Clique para voltar',
      Text_Market: 'Safras & Mercado: tudo sobre o agronegócio em um só lugar'
    },
    LOGINS4: {
      Error_Message_Title: 'Ocorreu um problema.',
      Error_Message_Content: 'Por favor, tente novamente em um momento, e se o problema continuar, entre em contato com nosso centro de atendimento ao cliente.',
      Error_Message_Content_Other_Login: 'Caro utilizador, a sua sessão expirou. Por favor, feche este módulo e abra-o novamente.'
    },
    GENERAL: {
      Home: 'Casa',
      Edit: 'Editar',
      Delete: 'Suprimir',
      Update: 'Atualizar',
      Create: 'Criação',
      Error: 'Erro',
      Atention: 'Atenção',
      Send: 'Enviar',
      Cma_Url: 'https://www.cma.com.br/',
      Safras_Url: 'https://safras.com.br/',
      Error_Download_File: 'Falha ao baixar arquivo',
      Copy_Data: 'Copiar dados'
    },
    MENU: {
      Home: 'Casa',
      AllSubjects: 'Todos os assuntos',
      Subjects: 'Assuntos',
      AllCommodities: 'Todas as mercadorias',
      Commodities: 'Mercadorias',
      DisabledItems: 'Subscreva agora',
      MoreCommodities: 'Mais culturas',
      NoRights: 'Sem direito'
    },
    TABLE: {
      Table_Column_ID: 'ID',
      Table_Column_DT_Insert: 'Data Incluída',
      Table_Column_DT_Change: 'Alteração de data',
    },
    MESSAGES: {
      Messages_Created: 'Registo criado',
      Messages_Updated: 'Registo atualizado',
      Messages_Deleted: 'Registo suprimido',
      Messages_Generic_Error: 'Erro ao executar a operação',
    },
    NAVBAR_DROPDOWN_MENU: {
      Profile: 'A minha conta',
      Change_Password: 'Alterar palavra-passe',
      Ask_To_Analyst: 'Pergunte ao analista',
      Dark_Theme: 'Tema escuro',
      Light_Theme: 'Tema claro',
      Biometry: 'Biometria',
      Language: 'Língua',
      Logout: 'Saída',
      Privacy_Policy: 'Política de Privacidade',
      Notification: 'Notificação',
      Signatures: 'Assinatura',
      Packages: 'Planos',
      My_Account: 'A minha conta',
      Info_Account: 'Dados da conta',
      Platform_Config: 'Configuração da plataforma',
      Font_Size: 'Tamanho do texto',
      Font_Align: 'Alinhamento de imagem',
      Font_Compact: 'Compacto',
      Font_Default: 'Normal',
      Font_Big: 'Largo',
      Appearance: 'Aparência',
      View_Type_List: 'Lista',
      View_Type_Card: 'Cartão',
      About: 'Sobre',
      Help: 'Ajuda',
      Show_Ticker: 'Mostrar ticker',
      Hide_Ticker: 'Ocultar ticker',
      Quotes_Config: 'Suporte'
    },
    CHANGE_PASSWORD: {
      Title: 'Alterar palavra-passe',
      Field_Email: 'E-mail',
      Field_Current_Password: 'Palavra-passe atual',
      Field_New_Password: 'Nova palavra-passe',
      Field_New_Password_Repeat: 'repetir a nova palavra-passe',
      Notify_Success_Title: 'Alterar palavra-passe',
      Notify_Success_Message: 'A sua palavra-passe foi atualizada com sucesso',
      Quit_all_apps: 'Sair de todos os dispositivos',
      Remember_Password: "Não se lembra da sua palavra-passe atual?",
      Click_Retrieve: 'Clique aqui para recuperar',
      Update_Password: 'Atualize a sua palavra-passe',
      Enter_Current_Password: 'Para atualizar sua senha, você precisa digitar a atual'
    },
    RESET_PASSWORD: {
      ResetTitle: 'Alteração de Palavra-passe',
      ResetDesc: 'Por favor, digite a sua nova palavra-passe',
      ResetPass: 'Nova palavra-passe',
      ResetConfirm: 'Repetir a nova palavra-passe',
      Reset_Confirm: 'repetir',
      InvalidToken: 'Código inválido',
      Notify_Title: 'Alteração de palavra-passe',
      Notify_Error_Message: 'Por favor, verifique os erros',
      PasswordChanged: 'Alteração de Palavra-passe',
      PasswordChangedDesc: 'A sua palavra-passe foi atualizada com sucesso',
    },
    FORGOT_PASSWORD: {
      RecoverTitle: 'Recuperar a sua palavra-passe',
      RecoverDesc: 'Informe o seu e-mail e enviaremos instruções para criar uma nova palavra-passe.',
      Field_Email: 'E-mail',
      EmailSent: 'E-mail enviado',
      CheckEmail: 'Foi enviado um e-mail para si. Por favor, verifique a sua caixa de entrada',
      Notify_Success_Title: 'Palavra-passe',
      Notify_Success_Message: 'Por favor, verifique o seu e-mail',
      Notify_Error_Title: 'Recuperar a sua palavra-passe',
      Notify_Error_Message: 'Endereço de e-mail inválido'
    },
    ASK_THE_ANALYST: {
      Title: 'Pergunte ao Analista',
      TitleHedge: 'Consulte a equipe',
      Field_Email: 'E-mail',
      Field_Name: 'Nome',
      Field_Question: 'Pergunta',
      Field_Commodity: 'Commodity',
      Remaining_Questions: 'Perguntas restantes disponíveis: '
    },
    MY_ACCOUNT: {
      Title: 'A Minha Conta',
      Field_Email: 'E-mail',
      Field_Name: 'Nome',
      Field_CnpjCpf: 'CPF/CNPJ',
      Field_Phone: 'Telefone',
      Field_Groups: 'Grupos',
      Field_Language: 'Idioma da Plataforma',
      Text_Language: 'Este parâmetro altera apenas o idioma da plataforma. Para alterar o conteúdo, entre em contato com o serviço de atendimento ao cliente.',
      Field_Country: 'País',
      Title_Receive_Email: 'Receber por E-mail',
      Title_Notification: 'Notificações',
      Field_Option_All: 'Todos',
      Notify_Success_Title: 'A Minha Conta',
      Notify_Success_Message: 'Dados atualizados com sucesso',
      Help_Language: 'Necessário para receber e-mails no idioma selecionado'
    },
    ERROR_404: {
      Title: 'Ops, página não encontrada',
      Message: 'Desculpe, esta página não foi encontrada'
    },
    FOOTER: {
      Help: 'Ajuda'
    },
    HELP: {
      Tab_About: 'Sobre',
      Tab_Attendance: 'Atendimento',
      Tab_Version: 'Versão',
      Tab_LGPD: 'LGPD',
      Tab_PrivacyPolicy: 'Política de Privacidade',
      Tab_Tour: 'Tour',
      Tab_Terms: 'Termos de uso',
      Tab_Quotes_Config: 'Suporte'
    },
    HELP_ABOUT: {
      Cma_Title: 'Sobre a CMA',
      Cma_Text: 'A CMA Consultoria, Métodos, Assessoria e Mercantil S/A é uma empresa multinacional brasileira que atua desde 1973 no desenvolvimento de soluções de alta tecnologia aplicadas aos mercados financeiro e de commodities, educacional, telecomunicações e data center. A empresa tem sua sede e 9 filiais no Brasil, além de filiais nos Estados Unidos, América Latina e Europa, e conta com clientes em 35 países.',
      Safras_Title: 'Sobre a SAFRAS & Mercados',
      Safras_Text: 'SAFRAS & Mercado é a principal consultoria do agronegócio brasileiro. Acompanha diariamente os mercados de soja, milho, algodão, café, açúcar & álcool, boi, frango, suíno, arroz, feijão e bioenergia, oferecendo diversos níveis de serviços que auxiliam na tomada de decisão dos participantes dos diferentes segmentos agropecuários. A SAFRAS possui o banco de dados históricos mais completo do agronegócio brasileiro e é uma referência internacional em projeções e cenários agrícolas.',
      Know_More: 'Saiba mais em',
      Visit_Website: 'Visite o website em:'
    },
    HELP_ATTENDANCE: {
      Title: 'Atendimento',
      Contact_Text: 'Entre em contato connosco por telefone ou e-mail abaixo. Entraremos em contacto o mais breve possível.',
      Phone: 'Telefone:',
      Email: 'Email:',
      Whatsapp: 'WhatsApp:',
      Form_Text: 'Ou envie uma mensagem através do formulário abaixo.',
      Form_Field_Message: 'Mensagem',
      Notify_Success_Title: 'Atendimento',
      Notify_Success_Message: 'Mensagem enviada com sucesso',
      Phone_href: 'tel:+5501130532750',
      Phone_Text: '(11) 3053-2750',
      Whatsapp_href: 'https://wa.me/551130532600',
      Whatsapp_Text: '(11) 3053-2600',
      Mail_href: 'mailto:atendimento@cma.com.br',
      Mail_Text: 'atendimento@cma.com.br',
      NoRights_Text_Commodity: 'Gostaria de habilitar o acesso a conteúdos da commodity %.',
      NoRights_Text_Content: 'Gostaria de habilitar o acesso ao conteúdo % da commodity #.',
      NoRights_Text_GetMoreQuestions: 'Gostaria de habilitar mais perguntas para os analistas.',
      Edit_Account_Data: 'Gostaria de editar meus dados',
    },
    HELP_VERSION: {
      Title: 'Versão',
      Item_Version: 'Versão',
      Item_Browser: 'Navegador',
      Item_System: 'Sistema',
      Item_Resolution: 'Resolução',
      Item_Status: 'Estado',
    },
    HELP_LGPD: {
      Accept_Cookies: 'Aceitar',
      Reject_Cookies: 'Recusar',
      Privacy_Policy: 'Ler Política de Privacidade',
      Cookies_Notice: 'O nosso Web site utiliza cookies para fornecer com conteúdo personalizado e para análise do site. Recomendamos que aceite, para uma melhor navegação na página!',
      LGPD_Title: 'Lei Geral de Proteção de Dados Pessoais (LGPD)',
      LGPD_Text: "Lorem Ipsum é simplesmente uma simulação de texto da indústria tipográfica e de impressos, e vem sendo utilizado desde o século XVI, quando um impressor desconhecido pegou uma bandeja de tipos e os embaralhou para fazer um livro de modelos de tipos. Lorem Ipsum sobreviveu não só a cinco séculos, como também ao salto para a editoração eletrônica, permanecendo essencialmente inalterado."
    },
    HELP_PRIVACY_POLICY: {
      Privacy_Policy: 'Política de Privacidade',
      Title: 'Política de Privacidade e Confidencialidade da Informação'
    },
    HELP_SUPPORT: {
      Follow_Market: 'Acompanhe o mercado',
      Restore_Layout: 'Restaurar layout padrão',
      Clear_Local_Data: 'Limpar dados locais',
      Detailed_Info: 'Informações detalhadas',
      Layout_History: 'Histórico layout',
      Created: 'Criado',
      Updated: 'Atualizado',
      Copy_Info_Success: 'Dados foram copiados para área de transferência.',
      Clear_Local_Data_Dialog_Title: 'Limpar dados',
      Clear_Local_Data_Dialog_Message: 'Deseja limpar os dados do acompanhe o mercado?',
      Restore_Layout_Dialog_Title: 'Restaurar layout padrão',
      Restore_Layout_Dialog_Message: 'Deseja restaurar seu layout do acompanhe o mercado para o padrão? A página será atualizado e será necessário realizar login novamente.',
      Update_Layout_History_Dialog_Title: 'Restaurar histórico de layout',
      Update_Layout_History_Dialog_Message: 'Deseja restaurar seu layout do dia',
      Detailed_Info_No_Data: 'Sem dados no momento'
    },
    TERMS_USE: {
      Title: 'Termos de Uso',
      Text: '<p class="mt-3 mb-3">Todo o conteúdo disponibilizado na Plataforma Safras é protegido pela Lei de Direitos Autorais e de uso exclusivo dos seus assinantes. Por esta razão, é vedada a reprodução ou distribuição do conteúdo, no todo ou em parte, sem prévia e expressa autorização da CMA. O descumprimento desta vedação acarretará sanções nas esferas cível e criminal.</p><p class="mt-3 mb-3">As informações dispostas na Plataforma Safras refletem exclusivamente apurações e pesquisas realizadas por profissionais de Safras & Mercado. Consistem de informações disponíveis ao público e consideradas confiáveis na data de sua publicação.</p><p class="mt-3 mb-3">Este conteúdo está sujeito a mudanças e é pautado na liberdade de expressão. Sendo assim, possui caráter meramente informativo, não representando quaisquer ofertas ou recomendações de negociação de valores, sejam eles mobiliários, mercadorias e/ou outros instrumentos financeiros ou econômicos.</p><p class="mt-3 mb-3">As informações contidas na Plataforma Safras visam a fomentar o debate e a educação sobre economia e agronegócios a seus assinantes. Desta forma, os assinantes devem desenvolver as suas próprias avaliações de mercado para a tomada de decisões sobre a gestão de seus negócios e/ou investimentos, desde já isentando, resguardando e protegendo integralmente a CMA sobre as consequências destas decisões e, inclusive, sobre eventuais prejuízos financeiros, perdas e danos, durante e após o término do período do plano de assinatura.</p>',
      Text_Mobile: '<p class="mt-3 mb-3">Todo o conteúdo disponibilizado na Plataforma Safras é protegido pela Lei de Direitos Autorais e de uso exclusivo dos seus assinantes. Por esta razão, é vedada a reprodução ou distribuição do conteúdo, no todo ou em parte, sem prévia e expressa autorização da CMA. O descumprimento desta vedação acarretará sanções nas esferas cível e criminal.</p><p class="mt-3 mb-3">As informações dispostas na Plataforma Safras refletem exclusivamente apurações e pesquisas realizadas por profissionais de Safras & Mercado. Consistem de informações disponíveis ao público e consideradas confiáveis na data de sua publicação.</p><p class="mt-3 mb-3">Este conteúdo está sujeito a mudanças e é pautado na liberdade de expressão. Sendo assim, possui caráter meramente informativo, não representando quaisquer ofertas ou recomendações de negociação de valores, sejam eles mobiliários, mercadorias e/ou outros instrumentos financeiros ou econômicos.</p><p class="mt-3 mb-3">As informações contidas na Plataforma Safras visam a fomentar o debate e a educação sobre economia e agronegócios a seus assinantes. Desta forma, os usuários devem desenvolver as suas próprias avaliações de mercado para a tomada de decisões sobre a gestão de seus negócios e/ou investimentos, desde já isentando, resguardando e protegendo integralmente a CMA sobre as consequências destas decisões e, inclusive, sobre eventuais prejuízos financeiros, perdas e danos, durante e após o término do período de uso do sistema.</p>',
      Read_Accepted: 'Li e aceito',
      Cancel: 'Cancelar'
    },
    REPORT: {
      No_Report_Found: 'Nenhum Resultado Encontrado',
      No_Report_Found_Text: 'Pode refazer a pesquisa para encontrar o que procura',
      No_Report_Found_Text_Demo: 'Para mais resultados e conteúdos exclusivos, cadastre-se ou acesse nossa Plataforma.',
      Load_More: 'Carregar Mais...',
      Download_Spreadsheet: 'Baixar Planilha',
      Download_Spreadsheet_Text: 'Clique para baixar a planilha',
      Hear_Text: 'Ouvir o Texto',
      Hear_Text_Hearing: 'Ouvindo: ',
      All_Commodities: 'Todas as Commodities',
      View_More: 'Ver mais'
    },
    REPORT_FILTER: {
      Informative_Title: 'Informativos',
      Informative: 'Análises e Informações',
      Search: 'Procurar',
      Filters: 'Filtros',
      Filter_Periodicity: 'Periodicidade',
      Filter_Publication_Type: 'Tipo de Publicação',
      Filter_Subject: 'Commodities',
      Filter_Order_By: 'Ordenar por',
      Filter_Content: 'Conteúdos',
      Filter_Country: 'País de Origem',
      Filter_Highlights: 'Destaque',
      Filter_InLive: 'Ao Vivo',
      Filter_Important: 'Importante',
      Filter_Exclusive: 'Exclusivo',
      Filter_Date: 'Data',
      Filter_Date_From: 'DE',
      Filter_Date_To: 'ATÉ',
      Filter_Media_type: 'Tipo de Mídia',
      Filter_Priority: 'Prioridade',
      Filter_Attachment: 'Anexo',
      Filter_Video: 'Vídeo',
      Filter_Audio: 'Áudio',
      Filter_Podcast: 'Podcast',
      Filter_Relevant: 'Relevantes',
      Clear_Filter: 'Limpar',
      To_View: 'Visualizar',
      Results: 'resultados',
      Follow_Market: 'Acompanhe o Mercado',
      Favorite_Content: 'Editar Favoritos',
      Filter_Report_Type: 'Tipo de Relatório',
      Information_label: 'Informações',
      Advanced_Filters: 'Filtros Avançados',
      Filter_Author: 'Filtrar por Autor',
      One_Day: '1 DIA',
      One_Week: '1 SEMANA',
      One_Month: '1 MÊS',
      Three_Months: '3 MESES',
      Select_Date: 'SELECIONE UMA DATA',
    },
    REPORT_ITEM: {
      Updated: 'Atualizado em',
      Today: 'Hoje'
    },
    BROWSER_NOT_SUPPORTED: {
      Title: 'AVISO',
      Text: 'Para uma experiência única com maior desempenho e segurança, experimente nosso aplicativo em outros navegadores. Também é possível instalar nosso App para Windows.',
      Other_Browsers: 'Outros Navegadores',
      Windows_Store: 'Windows Store'
    },
    DOWNLOAD_PUBLIC_FILE_EMAIL: {
      Title: 'Download de Arquivo',
      Notify_Error_Title: 'Token',
      Notify_Error_Message_Token_Not_Found: 'Token não encontrado',
      Notify_Error_Message_Invalid_Token: 'Token inválido'
    },
    PLAYLIST: {
      Empty_Playlist: 'A sua playlist está vazia',
      Empty_Playlist_Text: 'Adicione um vídeo à sua playlist',
      Youtube_Add_Playlist_Text: 'Vídeo adicionado à playlist',
      Audio_Add_Playlist_Text: 'Áudio adicionado à playlist',
      Item_Add_Playlist_Text: 'Item adicionado à playlist',
      Upcoming_Videos: 'Próximos vídeos',
      Clean: 'LIMPAR',
      Running: 'Em execução'
    },
    LOST_ACCESS: {
      Title: 'Perdeu o Acesso',
      ResetText: 'Como você prefere redefinir o seu acesso?',
      EmailCheckbox: 'Por E-mail',
      OtherCheckbox: 'Outros',
      ByEmail_Title: 'Envie uma mensagem para nós',
      Other_Title: 'Entre em contato com o nosso atendimento!',
      Email_field: 'E-mail',
      Phone_field: 'Telefone',
      Message_field: 'Mensagem',
      Notify_Error_Title: 'Perdeu o Acesso',
      Notify_Error_Message: 'Endereço de e-mail inválido',
      Phone_href: 'tel:+5501130532750',
      Phone_Text: '(11) 3053-2750',
      Mail_href: 'mailto:atendimento@cma.com.br',
      Mail_Text: 'atendimento@cma.com.br'
    },
    NEW_CLIENT: {
      Title: 'Novo por aqui?',
      Title2: 'Acompanhe os movimentos dos mercados agropecuários.',
      Title3: 'Vantagens Exclusivas da Plataforma SAFRAS',
      Description_1: 'Acompanhamento completo dos relatórios do <span>USDA</span>, integrando previsões de mercado, notícias agrícolas, alertas, quadros, vídeos e áudios',
      Description_2: 'Importantes dados de produção, comercialização, plantio, colheita e exportações das principais commodities, destacando dados exclusivos de <span>SAFRAS & Mercado</span>',
      Description_3: 'Equipe própria de jornalistas com larga especialização em cobertura do agronegócio',
      Email_field: 'E-mail',
      Phone_field: 'Telefone',
      Name_field: 'Nome',
      Notify_Error_Title: 'Novo por aqui?',
      Notify_Error_Message: 'Por favor, verifique os erros'
    },
    TOUR_STEPS: {
      ButtonSkip: 'Não exibir',
      ButtonPrevious: 'Voltar',
      ButtonNext: 'Próximo',
      ButtonStop: 'Finalizar',
      StepFilterText: `<div>O filtro mudou de local</div>`,
      StepNewHighlightText: `<div class="tour-title">Agora temos destaques para Safras TV!</div> <div class="tour-small">Conheçam o "Resenha SAFRAS & Mercado", o novo programa semanal que reúne convidados especiais, de grande influência no agronegócio</div>`,
      StepNewCommodityText: `<div>Uma nova commodity <b>Fertilizantes</b> foi inserida na plataforma</div>`,
      StepFavoriteText: `<div class="tour-title">Agora temos favoritos!</div><div class="tour-small">Ao passar o mouse sobre o item, irá aparecer o ícone que permite adicionar o conteúdo aos favoritos.</div>`,
      StepPlayTourAgainText: `<div>Dentro da janela de ajuda, você pode iniciar novamente o Tour da plataforma com as últimas novidades</div>`,
    },
    DIALOG_MESSAGES: {
      Title: 'Aviso',
      UserRightsText: 'Seu usuário não possui acesso a esse conteúdo. Entre em contato para habilitar',
      GetMoreQuestionsText: 'Não há mais perguntas disponíveis. Entre em contato para saber mais.',
      PlatformTourText: 'Gostaria de iniciar o tour e ver as novidades da plataforma?',
      AcceptText: 'Entrar em contato',
      CancelText: 'Fechar',
      StartText: 'Iniciar',
      NotDisplayText: 'Não exibir',
      SentRequestDemo: 'Enviamos sua solicitação de demonstração. Enviaremos um e-mail com mais novidades.',
      AccountEditDataText: 'Para editar seus dados, favor envie uma mensagem para nosso atendimento.'
    },
    BADGES: {
      Important: 'IMPORTANTE',
      Exclusive: 'EXCLUSIVO',
      InLive: 'AO VIVO',
      Disclosure: 'DIVULGAÇÃO',
      Announcement: 'ANÚNCIO',
      Invite: 'CONVITE'
    },
    BADGES_MEDIA: {
      Appendix: 'Anexo',
      Audio: 'Áudio',
      Video: 'Vídeo',
      Podcast: 'Podcast'
    },
    REGISTER: {
      Title: 'Criar uma conta',
      Subtitle: 'Preencha o formulário abaixo para criar uma nova conta.',
      Field_Email: 'E-mail',
      Field_Email_Again: 'Repetir E-mail',
      Placeholder_Email: 'Digite o e-mail',
      Placeholder_Email_Again: 'Digite o e-mail novamente',
      Field_Username: 'Nome',
      Placeholder_Username: 'Digite o nome',
      Field_UserType: 'Tipo de usuário',
      Placeholder_UserType: 'Selecione o tipo de usuário',
      Field_Cnpj: 'CNPJ',
      Placeholder_Cnpj: '00.000.000/0000-00',
      Field_Cpf: 'CPF',
      Placeholder_Cpf: '000.000.000-00',
      Field_Phone: 'Telefone',
      Placeholder_Phone: '00 00000-0000',
      Field_Password: 'Senha',
      Placeholder_Password: 'Digite a senha',
      Confirm_Email_Title: 'Confirmação de e-mail',
      Confirm_Email_Subtitle: 'Não recebeu o e-mail?',
      Confirm_Email_Field_Code: 'Código',
      Confirm_Email_Placeholder_Code: 'Digite o código',
      Confirm_Email_Send_Token: 'Código enviado com sucesso',
      UserType_Item_PF: 'Pessoa Física',
      UserType_Item_PJ: 'Pessoa Jurídica',
      HasAccount: 'Já tem uma conta?',
      Terms_Of_Use: 'Ler termos de uso',
      Accept_Terms: 'Aceito os termos de uso',
      Register: 'Cadastrar',
      Request_Free: 'Quero me cadastrar para ter acesso apenas aos conteúdos gratuitos da plataforma',
      Request_Demo: 'Quero me cadastrar e solicitar um período de 7 dias de demonstração para ter acesso a todos os conteúdos da plataforma',
      Success_Register: 'Cadastro realizado com sucesso'
    },
    USER_SIGNATURE: {
      Title: 'Assinatura',
      Contracted_Plan: 'Plano Contratado',
      Signature_Validate: 'Assinatura válida até',
      Signature_Option_Agency_Safras_RT: 'Agência SAFRAS (RT)',
      Signature_Option_Other_Agencies: 'Outras Agências (sob contratação)',
      Signature_Option_Analisy_Agro_Today: 'Análise Agro Hoje',
      Signature_Option_Analisy_Agro_Vision: 'Análise Visão Agro',
      Signature_Option_Estatistic_Export: 'Estatísticas + Exportações/Importações',
      Signature_Option_Ask_Analyst: 'Pergunte ao Analista',
      Signature_Option_Safras_Tv: 'SAFRAS TV',
      Signature_Option_Safras_Podcast: 'SAFRAS Podcast',
      Signature_Option_Courses: 'Cursos',
      Signature_Option_Speechs: 'Palestras',
      Signature_Option_Weather: 'Clima',
      Signature_Option_Fisical_Market: 'Mercado Físico',
      Signature_Option_Future_Market: 'Mercado Futuro (DT e/ou RT)',
      Signature_Option_Indicative: 'Indicadores',
      Signature_Option_Exchange_Market: 'Câmbio (DT)',
      Signature_Option_Lineup_Ships: 'Line-up de Navios',
      Signature_Option_Freight_Calculator: 'Calculadora de Fretes',
      Signature_Option_Open_Line: 'Open Line (Acesso Direto ao Analista)',
      Signature_Option_Monthly_Conference: 'Teleconferência Mensal com o Analista',
      Latest: 'Últimas',
      Publications: 'Publicações'
    },
    PACKAGES: {
      Title: "Planos",
      Contracted_Plan: "Plano Contratado",
      Signature_Validate: "Assinatura válida até",
      I_Want_To_Hire: "Quero contratar",
      More_Info: "Mais informações"
    },
    USER_NOTIFICATION: {
      Notification: "Notificações",
      Subtitle: "Configure o recebimento de notificações por e-mail e pelo app para cada commodity",
      Not_Receive_Email: "Não quero receber e-mails",
      Not_Receive_Push: "Não quero receber notificações no app",
      Content: "Conteúdo",
      Email: "E-mail",
      Push: 'App',
      All: "Todos",
      Block_notifications: "Bloquear notificações"
    },
    NEWS_DETAIL: {
      Event: "Evento",
      Invite: "Convite",
      Type: "Tipo",
      Type_Online: "Online",
      Type_Presential: "Presencial",
      All_Day: "Dia inteiro",
      Start_Date: "Data de início",
      Final_Date: "Data final",
      Location: "Local",
      Price: "Preço",
      Link: "Link",
      Related_Event: "Evento relacionado",
      Content: "Conteúdo",
      Country: "País",
      Report: "Relatório:",
      Report_Date: "Data do relatório:",
      Publish_Date: "Data de publicaçã:",
      Updated: "Atualizado em",
      Private_Content: "Conteúdo privado apenas para assinantes",
      By: "por",
      Read_More: "Leia mais em",
      Kind_Event: "Tipo de Evento",
      Start_Event: "Início do Evento",
      Event_Details: "Detalhes do Evento",
      Price: "Preço",
      End_Event: "Fim do Evento",
      Event_Location: "Local do Evento",
      Open: 'Abrir',
      Related_News: 'Notícias Relacionadas',
    },
    USER_PROFILE: {
      Subscriber: 'Assinante',
      Demo: 'Demonstração',
      Free: 'Gratuito'
    },
    SIGAWEB_DEMO: {
      Plan_Free_Title: 'Plano Gratuito',
      Plan_Demo_Title: 'Conta de Demonstração',
      Plan_Subscribe_Title: 'Assinante',
      Free_Text_First: 'Você está usando uma conta gratuita. Conheça nossos planos.',
      Free_Text_Second: 'Solicite uma conta de demonstração por 7 dias.',
      Free_Text_Third: 'Saiba mais sobre as condições de assinatura dos diferentes planos da Plataforma Safras. Entre em contato conosco pelo WhatsApp: +55 (11) 93947-8908. E-mail: ',
      Free_Text_Email: 'prevendas@cma.com.br',
      Free_Text_Click_Here: 'Solicitar demonstração',
      Request_Demo: 'Solicitar uma conta de demonstração',
      Signature_Valid_Until: 'Assinatura válida até',
      Signature_Active: 'Assinatura ativa',
      Dialog_Title: 'Aviso',
      Field_Empty: 'não encontrado.',
      Field_Invalid_Format: 'com formato inválido.',
      User_Exist: 'Já existe um contrato ativo em nosso sistema.',
      User_Demo_Exist: 'Já existe uma conta de demonstração ativa em nosso sistema.',
      Contact: '\n\nSe o erro persistir, entre em contato.',
      SentRequest: 'Enviamos sua solicitação de conta de demonstração por 7 dias. Em breve, enviaremos um e-mail com todas as informações.',
      Attendance_Message: 'Olá, preciso de ajuda com a conta gratuita',
      Demo_Request: 'Solicitação de conta de demonstração',
      Update_Phone_Title: 'Atualize seu número de telefone',
      Update_Phone_Text: 'Por favor, insira seu número de telefone para atualizarmos em nosso sistema.',
      Update: 'Atualizar'
    },
    AUTHOR_DETAIL: {
      Publication: 'Publicações',
      Total: 'Total',
      Today: 'Hoje',
      Last_Sent: 'Últimas enviadas'
    },
    DISPLAY_TYPES: {
      List: 'Lista',
      Card: 'Card',
      Mosaic: 'Mosaico',
      Tag: 'Etiqueta',
      Calendar: 'Calendario',
      Schedule: 'Agenda',
      Playlist: 'Playlist'
    },
    ACCESSIBILITY: {
      Accessibility: 'Acessibilidade',
      Normal: 'Normal',
      To_Hear: 'Ouvir',
      Pause_reading: 'Pausar a leitura',
      Appendix: 'Apêndice'
    },
    HIGHLIGHTS: {
      Highlights: 'Destaques',
      Exclusive_Content: 'Conteúdo Exclusivo',
    },
    MULTIMEDIA: {
      Details: 'Ver Detalhes',
      Play: 'Reproduzir',
      Add_Playlist: 'Adicionar à playlist'
    },
    VIEW_MODES: {
      By: '',
      In: ''
    },
    LOGOUT: {
      Title: 'Sessão encerrada',
      Message: 'Sua sessão foi encerrada devido a um acesso simultâneo.'
    },
    TICKER: {
      View: 'Visualizar:',
      Important: 'Importante',
      Highlights: 'Destaques',
      View_At_Top: 'Visualizar no topo',
      View_In_Footer: 'Visualizar no rodapé',
    },
    PRIVATE_CONTENT: {
      Register: 'Registe-se Agora!',
      Exclusive_Subscribers: 'Alcance o sucesso no agronegócio com a Plataforma SAFRAS!',
      Sign_Up_access: 'Pode registar-se gratuitamente para aceder a recursos e conteúdos exclusivos ou solicitar uma demonstração do serviço completo.',
      Smart_Content_Title: 'Descubra o poder da Plataforma SAFRAS',
      Smart_Content_L1: 'Identifique oportunidades lucrativas e aumente o seu potencial competitivo no agronegócio.',
      Smart_Content_L2: 'Invista com assertividade, segurança e proteção em commodities agrícolas.',
      Smart_Content_L3: 'Tome decisões estratégicas com análises exclusivas da Plataforma SAFRAS.',
      Smart_Content_L4: 'Acompanhe o cenário global com notícias, previsões climáticas e paridades de preços.',
      Smart_Content_L5: 'Maximize os seus resultados com proteção e acesso a estatísticas completas.',
      Alert_Footer: 'O acesso gratuito à Plataforma Safras e o período de demonstração gratuita têm como objetivo oferecer uma amostra do que a Plataforma Safras pode proporcionar aos seus negócios e investimentos. Caso deseje acesso ilimitado a todos os recursos e conteúdos exclusivos do serviço, conheça os diferentes planos de assinatura para fazer parte da nossa comunidade de clientes.'
    },
    PRIVATE_CONTENTUSERDEMO: {
      Register: 'Conhecer Planos de Assinatura',
      Attendance: 'Atendimento',
      IOS_Text: 'Se você tem interesse neste tipo de conteúdo, solicite a liberação',
      Exclusive_Subscribers: 'Está a usar o período de demonstração da Plataforma SAFRAS!',
      Sign_Up_access: 'Esta informação não está disponível durante o período de demonstração, mas está disponível para assinantes do serviço. Conheça os diferentes planos de assinatura para fazer parte da nossa comunidade de clientes e aproveitar ao máximo tudo o que temos para oferecer.',
      Smart_Content_Title: 'Descubra o poder da Plataforma SAFRAS',
      Smart_Content_L1: 'Identifique oportunidades lucrativas e aumente o seu potencial competitivo no agronegócio.',
      Smart_Content_L2: 'Invista com precisão, segurança e proteção em commodities agrícolas.',
      Smart_Content_L3: 'Tome decisões estratégicas com análises exclusivas da Plataforma SAFRAS.',
      Smart_Content_L4: 'Acompanhe o cenário global com notícias, previsões climáticas e paridades de preços.',
      Smart_Content_L5: 'Maximize os seus resultados com proteção e acesso a estatísticas completas.',
      Alert_Footer: 'O período de demonstração gratuita tem como objetivo oferecer uma amostra do que a Plataforma Safras pode proporcionar aos seus negócios e investimentos. Caso deseje acesso ilimitado a todos os recursos e conteúdos exclusivos do serviço, conheça os diferentes planos de assinatura para fazer parte da nossa comunidade de clientes.'
    },
    PRIVATE_CONTENTUSERSUBSCRIBER: {
      Register: 'Conhecer Planos de Assinatura',
      Exclusive_Subscribers: 'Parabéns, você já é assinante da Plataforma SAFRAS!',
      Sign_Up_access: 'No entanto, seu plano atual não inclui esta informação que você está tentando acessar. Conheça outros planos de assinatura para ter acesso a mais informações estratégicas e recursos que irão ajudá-lo a ampliar seus resultados nos negócios e investimentos.',
      Smart_Content_Title: 'Descubra o poder da Plataforma SAFRAS',
      Smart_Content_L1: 'Identifique oportunidades lucrativas e aumente seu potencial competitivo no agronegócio.',
      Smart_Content_L2: 'Invista com assertividade, segurança e proteção em commodities agrícolas.',
      Smart_Content_L3: 'Tome decisões estratégicas com análises exclusivas da Plataforma SAFRAS.',
      Smart_Content_L4: 'Acompanhe o cenário global com notícias, previsões climáticas e paridades de preços.',
      Smart_Content_L5: 'Maximize seus resultados com proteção e acesso a estatísticas completas.'
    },
    TOAST_NOTIFICATIONS: {
      // Validação de token
      invalidToken: 'Código inválido',
      expiredToken: 'Código expirado',
      // Login
      userNotFound: 'Usuário não encontrado',
      insufficientRights: 'Usuário não possui direitos para acessar o sistema. Entre contato com nossa equipe de Atendimento pelo e-mail atendimento@cma.com.br.',
      disabledUser: 'Usuário desabilitado',
      invalidCredentials: 'Usuário ou senha inválidos',
      // Login via S4
      unauthorized: 'Não autorizado',
      disabledS4User: 'Usuário desativado',
      // Esqueci a senha
      emailNotFound: 'Email não encontrado',
      disabledUserForgotPassword: 'Usuário desabilitado',
      emailNotFoundSystem: 'Email não encontrado. Entre contato com nossa equipe de Atendimento pelo e-mail atendimento@cma.com.br.',
      // Reset de senha
      invalidConfirmPassword: 'Confirmação de senha inválida',
      expiredResetToken: 'Token expirado',
      invalidResetToken: 'Token inválido',
      // Troca de senha
      invalidCurrentPassword: 'Senha atual inválida',
      newPasswordMismatch: 'Nova senha e confirmação devem ser iguais',
      newPasswordSameAsCurrent: 'Nova senha não pode ser igual à senha atual',
      // Cadastro
      invalidCPF: 'CPF inválido',
      invalidCNPJ: 'CNPJ inválido',
      cpfAlreadyRegistered: 'CPF já cadastrado',
      cnpjAlreadyRegistered: 'CNPJ já cadastrado',
      emailAlreadyRegistered: 'E-mail já cadastrado. Tente acessar o sistema ou Entre contato com nossa equipe de Atendimento pelo e-mail atendimento@cma.com.br.',
      emailAlreadyRegisteredSystem: 'Este e-mail já está cadastrado em nosso sistema. Utilize-o para fazer o seu acesso à Plataforma Safras.',
      // Leitura de PDF
      documentNotFound: 'Documento não existente',
      // Download público de PDF
      invalidCode: 'Código inválido',
      documentNotFoundPublic: 'Documento não encontrado',
      expiredTokenPublic: 'Token expirado',
      nonExistentEmail: 'E-mail inexistente',
      nonExistentReportId: 'ID do relatório inexistente',
      userNotFoundPublic: 'Usuário não encontrado',
      disabledUserPublic: 'Usuário desabilitado',
      // Removendo DeviceID no logout
      deviceIdNotFound: 'Device Id não encontrado',
      // TMN Quotes
      displayCannotLoadSystemTitle: 'Falha ao carregar o sistema',
      displayCannotLoadSystemMessage: 'Falha de comunicação. Atualize a página ou entre contato com nossa equipe de Atendimento pelo e-mail atendimento@cma.com.br.',
      displayNotAuthorizedTitle: 'Erro',
      displayNotAuthorizedMessage: 'Falha de comunicação. Atualize a página ou entre contato com nossa equipe de Atendimento pelo e-mail atendimento@cma.com.br.',
      messagesNotifyHelperTitle: 'Erro',
      messagesNotifyHelperMessage: 'Falha de comunicação. Atualize a página ou entre contato com nossa equipe de Atendimento pelo e-mail atendimento@cma.com.br.',
      // Ask The Analyst
      askAnalystTitle: 'Pergunte ao Analista',
      askAnalystSuccess: 'Pergunta enviada para o analista com sucesso',
      // REGISTER
      registerRequestDemoTitle: 'Demonstração',
      registerRequestDemoMessage: 'Após a conclusão do cadastro, vamos processar sua solicitação de demonstração. Enviaremos um e-mail para mais informações.',
      // Packages
      packRequestDemoTitle: 'Demonstração',
      packRequestDemoMessage: 'Pedido enviado com sucesso.',
      userPhoneNotFound: 'Telefone não encontrado',
      //TMN HELPER
      checkNotifyErrorTitle: 'Erro',
      checkNotifyErrorsMessage: 'Falha de comunicação. Atualize a página ou entre contato com nossa equipe de Atendimento pelo e-mail atendimento@cma.com.br.',
      // CHECK USER INFO
      checkUserInfoTitle: 'Usuário',
      checkUserInfoMessage: 'Usuário desabilitado.',
      // INTERNAL SERVER ERROR
      internalServerErrorTitle: 'Erro 503',
      internalServerErrorMessage: 'Sistema indisponivel no momento, tente novamente em alguns instantes.',
      userCannotDelete: 'Conta com assuntatura ativa não pode ser deletada.',
    },
    WDMA: {
      Error_System_Title: 'Não foi possível carregar o sistema.',
      Error_System_Subtitle: 'Tente novamente mais tarde...',
      Error_System_Button_Update: 'Atualizar',
      Error_System_Button_Attendance: 'Entrar em contato',
      Error_Session_Close: 'Identificamos que outra estação se conectou',
      Error_System_Title_Session_Close: 'Você foi desconectado.',
      Error_System_Button_Connect: 'Conectar',
      Error_Title_Max_Simultaneous_Connections: 'Você atingiu o número máximo de conexões simultâneas permitidas.',
      Error_Max_Simultaneous_Connections: 'Encerre uma conexão antiga para permitir o novo acesso',
      Error_Title_Invalid_Credentials: 'Acesso negado',
      Error_Invalid_Credentials: 'Verifique suas credenciais ou entre em contato com o administrador',
    },
    DELETE_ACCOUNT: {
      Delete_Account_Button: 'Solicitar exclusão de dados pessoais',
      Title: 'AVISO',
      First_Question: `A solicitação de exclusão dos dados pessoais das nossas bases é um direito garantido pela Lei Geral de Proteção de Dados Pessoais.
      \n Porém, sem estas informações, não conseguiremos identificar os seus acessos.
      \n Desta forma, se você prosseguir com esta solicitação, tão logo sua solicitação seja processada seu acesso na Plataforma Safras será bloqueado e você não poderá voltar a acessá-la até que você refaça o seu cadastro.
      \n Caso você tenha um contrato vigente de uso da Plataforma Safras, o registro da solicitação de exclusão dos seus dados pessoais não irá desonerá-lo de cumprir com as condições acordadas de rescisão contratual e a sua solicitação só terá efeito após você receber o contato da nossa área comercial que irá tratar com você sobre os passos deste processo de desregistro.
      \n Caso você tenha ou já tenha tido um contrato de uso dos produtos comercializados por esta empresa, seus dados pessoais serão excluídos da Plataforma Safras mas poderão ser mantidos em sistemas internos da empresa desde que sejam necessários para atender às obrigações legais as quais a empresa esteja submetida.
      \n Você realmente deseja prosseguir?`,
      First_Question_Button_Decline: 'Desistir',
      First_Question_Button_Continue: 'Registrar Solicitação',
      First_Question_Success_Title: 'Sucesso',
      First_Question_Success_Text: `Sua solicitação de exclusão dos seus dados pessoais foi recebida e está sendo processada.
      \n Sua sessão está sendo encerrada.
      \n Caso deseje retomar o seu acesso a Plataforma Safras, realize um novo cadastro.`,
      Cannot_Delete_Text: `Sua solicitação de exclusão dos seus dados pessoais foi recebida e está sendo processada.
      \n Aguarde o contato da nossa área comercial que revisará com você as condições do seu contrato vigente.`
    },
    SCHEDULE: {
      Empty_Schedule: 'Sua agenda está vazia',
      Empty_Schedule_Text: 'Adicione eventos a sua agenda.',
      Clean: 'LiMPAR',
      Today: 'Hoje',
      Month: 'Mês',
      Week: 'Semana',
      Day: 'Dia',
      List: 'Lista'
    },
    BIOMETRY: {
      Cancel: 'Cancelar',
      Activate: 'Ativar',
      Use_Pin: 'User PIN',
      Show_Fingerprint_Desc: 'Reconhecimento de biometria para acessar a sua',
      Register_Biometric_Secret_Desc: 'Reconhecimento de biometria',
      Biometry_Confirm_Activate_Text: 'Deseja ativar a biometria agora para acessos rápidos e protegidos?',
      Biometry_Confirm_Title: 'Login',
    }
  }
}
